import * as Localization from "expo-localization";
import { I18n } from "i18n-js";
const translations = {
  en: {
    app_name: "Lucky Town",
    login_text: "Log In",
    signUp_text: "Sign Up",
    welcom_text: "Welcome to the Lucky Town Plus App",
    username_text: "Username",
    password_text: "Password",
    forgotPassword_text: "Forgot Password",
    otp_text: "OTP",
    invalid_username_or_password: "Invalid username or password",
    invalid_password: "Invalid password",
    invalid_data_input: "Invalid data input",
    invalid_phone_number: "Invalid phone number",
    invalid_transaction_pin: "Invalid transaction pin",
    history_text: "History",
    from_date: "From Date",
    to_date: "To Date",
    to: "To",
    go: "Go",
    select: "Select",
    new_account: "New Account",
    new_password: "New Password",
    recommended_user: "Recommender user: ",
    phone_number: "Phone Number",
    confirm_password: "Confirm Password",
    username_or_phone_number_is_registered:
      "Username or phone number is registered",
    recover_password: "Recover Password",
    recover_username: "Recover Username",
    please_enter_phone_number:
      "Please enter your registered phone number to recover your password.",
    please_enter_phone_number_to_recover_username:
      "Please enter your registered phone number to recover your username.",
    please_enter_txid: "Please enter txid.",
    next: "Next",
    otp_code_resended: "OTP code resended",
    invalid_otp_code: "Invalid OTP code",
    request_otp: "Request OTP",
    please_enter_otp: "Please enter OTP send to your selected creadentials.",
    proceed: "Proceed",
    resend_code: "Resend code",
    change_login_password: "Change Login Password",
    select_one_of_the_cre:
      "Select one of any creadentials which should we use for recover your password.",
    password_changed: "Password Changed",
    congratulations_changed_password:
      "Congratulations! Youve successfully changed your password.",
    login_now: "Login Now",
    discover: "Discover",
    amount_RM: "Amount",
    start: "Start",
    contacts: "Contacts Us",
    new_friend: "New Friend",
    wallet: "Wallet",
    cash: "Cash",
    bank_account: "Bank Account",
    setting: "Setting",
    withdraw_succ: "Withdraw successfully",
    top_up_succ: "Top up successfully",
    coin: "Coin",
    interest: "Lucky Coin",
    wallet_balance: "Cash Balance",
    top_up: "Top Up",
    withdraw: "Withdraw",
    transaction: "Transaction",
    instant_top_up: "Instant Top Up",
    top_up_bank_transfer: "Bank Transfer",
    error_please_try_again: "Error, please try again.",
    top_up_RM: "Top Up",
    upload_receipt: "Upload Receipt",
    choose_upload_photo_method: "Choose Upload Photo Method",
    take_picture: "Take Picture",
    select_from_gallery: "Select From Gallery",
    take_photo: "Take Photo",
    retake: "Retake",
    use_photo: "Use Photo",
    upload_bank_receipt: "Upload Bank Receipt",
    confirm_to_upload_this_photo: "Confirm to upload this photo?",
    cancel: "Cancel",
    confirm: "Confirm",
    wallet_balance_not_enough: "Cash Balance Not Enought to withdraw",
    withdraw_RM: "Withdraw",
    no_transaction_for_dates: "No transactions for selected dates",
    no_more_transaction_for_dates: "No more transactions for selected dates",
    please_enter_date: "Please enter dates",
    all_transaction: "All Transaction",
    top_up_history: "Top Up History",
    interest_account_removed: "LuckyCoin account removed!",
    interest_account_created_succ: "LuckyCoin account created succesfully.",
    you_have_no_interest_account: "You have no running LuckyCoin account.",
    interest_history: "Lucky Coin History",
    days: "Days",
    hours: "Hours",
    create_interest: "Create LuckyCoin",
    deposit_RM: "Deposit",
    balance_RM: "Balance         :",
    remove: "Remove",
    partial_withdraw: "Partial Withdraw",
    interest_withdraw: "Interest withdraw",
    add_back_account_succ: "Add bank account successfully",
    edit_bank_account: "Edit Bank Account",
    bank: "Bank",
    account_name: "Account Name",
    account_no: "Account No.",
    add_bank_account: "Add Bank Account",
    sign_out: "Sign Out",
    language: "Language",
    clear_cache: "Clear Cache",
    about: "About",
    old_password_not_match: "Old Password Not Match.",
    old_password: "Old Password",
    back: "Back",
    version: "Version",
    change_payment_pin: "Change Payment Pin",
    change_nickname: "Change Nickname",
    transfer: "Transfer",
    create_pin: "Create Transaction Pin",
    change_pin: "Change Transaction Pin",
    creat_pin_description:
      "Create a 6 digits pin for your transaction in the app",
    please_enter_pin_again: "Please enter 6 digits pin again",
    pin_dont_match: "Pin does not match",
    old_pin: "Old Pin",
    new_pin: "New Pin",
    confirm_new_pin: "Confirm Pin",
    pin_max_six: "Transaction Pin 6 digits",
    succ_pin_change: "Transation Pin Changed",
    congratulations_changed_pin:
      "Congratulations! Youve successfully changed your transaction pin.",
    please_enter_pin: "Please enter transaction pin",
    forgot_pin: "Forgot transaction pin",
    recover_transaction_pin: "Recover Transaction Pin",
    please_enter_phone_number_pin:
      "Please enter your registered phone number to recover your transaction pin.",
    old_pin_not_match: "Old pin not match",
    new_pin_not_match: "New pin not match",
    transfer_RM: "Transfer",
    transfer_succ: "Transfer successfully",
    transfer_to: "Transfer to: ",
    wallet_insuffecient_amount: "Cash Balance Not Enought to transfer.",
    change_your_nickname: "Edit or change your nickname",
    nickname: "Nickname",
    fullname: "Full Name",
    nickname_change_succ: "Change nickname successfully",
    cancellation: "Cancellation",
    confirm_to_remove_and_withdraw: "Confirm to remove and withdraw",
    confirm_go_back: "Confirm to go back?",
    in_game: "In Game",
    close_game_first: "Please quit other games first!",
    close_game: "Close Game",
    game_closed: "Game Closed",
    game: "Games",
    information: "Information",
    search: "Search",
    no_user_found: "User not found",
    i_have_read_and_agree: "I have read and agree",
    LID: "LID",
    referral: "Referral",
    available_transfer_balance_RM: "Available Transfer",
    i_am_agreed_to_term: "I'm agreed the term",
    coin_transaction: "Coin Transaction",
    status: "Status",
    succ_submission_pending_review: "Successful submission pending review",
    leaderboard: "Leaderboard",
    time_zone: "Time Zone",
    customer_service: "Customer service",
    qr_transfer: "QR Transfer",
    top_up_details: "Top Up Details",
    top_up_type: "Top Up Type",
    date: "Date",
    receipt: "Receipt",
    available_transfer: "Available Transfer",
    available_coin: "Available Coin",
    commission: "Commission",
    today_stake: "Today Stake",
    yesterday_stake: "Yesterday Stake",
    wallet_transaction: "Wallet Transaction",
    game_transaction: "Game Transaction",
    type: "Type",
    all: "All",
    refund: "Refund",
    penalty: "Penalty",
    pick_date: "Pick Date",
    time: "Time",
    win: "Win/Loss",
    win_: "Win",
    bet: "Bet",
    bet_or_transfer: "Bet/Transfer",
    save_in_album: "Save In Album",
    qr_code_saved: "QR code saved",
    save_error: "Save error",
    change_avatar: "Change Avatar",
    avatar_changed: "Avatar changed",
    cant_start_game: "Can not start game",
    details: "Details",
    product: "Product",
    total_bet: "Total Bet",
    total: "Total",
    reward: "Reward",
    photo_library: "Photo Library",
    qr_code_error: "QR code error",
    maintenance: "Maintenance",
    coming_soon: "Coming Soon",
    top_up_disclaimer:
      "** Please comply with the regulations listed by our company. Otherwise, the points given will be delayed. We wish you a happy game, thank you.",
    minimum_top_up: "Minimum: ",
    maximum_top_up: "Maximum: ",
    top_up_left_times: "Remaining times:",
    top_up_unlimited: "(Unlimited)",
    order_history: "Order History",
    withdraw_history: "Withdraw History",
    no_bank_account_added: "Please bind at least one bank account",
    minimum_withdraw: "Min: ",
    maximum_withdraw: "Max: ",
    free_withdraw_time: "Free times: ",
    withdraw_balance: "Current balance: ",
    unlimited: "Unlimited",
    withdraw_details: "Withdraw Details",
    updated_date: "Updated Date",
    pending: "Pending",
    success: "Successfull!",
    in_inspection: "In inspection",
    hold: "On hold",
    confirm_to_remove_withdraw: "Confirm to remove withdraw?",
    confrim_to_remove_top_up: "Confirm to remove top up?",
    rejected: "Rejected",
    copied: "Copied to clipboard",
    anouncement: "Anouncement",
    contactUs: "Contact Us",
    newVersionTitle: "A new version is available",
    versionDescription:
      "To continue, please update you app to the latest version",
    verification: "Verification",
    register_device_text:
      "This device is not tied to your account. Please register the device to continue",
    device_name: "Device Name",
    device_info: "Device Info",
    friend: "Friends",
    about_phone: "About Phone",
    remarks: "Remarks",
    balance_transfer: "Balance transfer successfully",
    usdt_top_up: "Top Up USDT",
    app_close: "Close",
    topupRemarks:
      "Please specify LT- (your user name) on the transfer slip \nE.g. \nID: lucky town  \nRefer: LTluckytown",
    top_up_policy:
      "Our company will change the bank account from time to time, please confirm the account in advance at your bank/ before transfer of payment. The company is not responsible for any loss caused by your mistake",
    notification: "Notification",
    empty_notifications: "There are no new notifications.",
    promotion: "Promotion",
    use_now: "USE NOW",
    promo_code: "Promo Code",
    enter_otp: "Please enter OTP",
    change_phone_no: "Change Phone Number",
    change_your_phone: "Edit or change your phone number",
    congratulations_changed_phone:
      "Congratulations! Youve successfully changed your Phone number.",
    default_avatar: "Default Avatar",
    forgotUsername_text: "Forgot Username",
    authenticate: "Authentication",
    forgot_id_password: "Forgot UID / Password",
    manage_account: "Switch Account",
    add_another_account: "Add Another Account",
    add_account: "Add Account",
    cashout: "CASH OUT",
    please_signin_to_continue: "Please sign in to continue",
    no_account_found: "No Account Found",
    reward: "Reward",
    please_enter_amount: "Please enter amount.",
    topUpUSDTReceipt: "Topup USDT Receipt",
    amount_usdt: "Amount (USDT)",
    txid: "TXID",
    enter_txid: "Enter TXID",
    platform: "Platform",
    select_platrform: "Select Platform",
    request_topup_success: "Request Top Up Success.",
    chip: "Chip",
    confrim_to_remove_back_account: "Please confirm removal of bank account",
    footer_home: "Home",
    footer_contact: "Contacts",
    footer_transaction: "Transaction",
    footer_me: "Me",
    profile_cash: "Cash",
    profile_chip: "Chip",
    profile_luck: "Lucky Coin",
    profile_vip: "VIP",
    bank_search_bank: "Search Bank",
    avatar_back: "Back",
    friend_search_friend: "Search friend",
    friend_delete: "Delete",
    friend_title: "Add friend",
    friend_popup: "Enter friend name",
    game_details_download: "Download",
    game_details_launch: "Launch",
    game_details_transfer: "Transfer",
    qr_copy_link: "Copy Link",
    qr_qr_share: "Share QR",
    profile_lucky_coin: "Lucky Coin",
    currency_exchange: "Currency Exchange",
    currency_exchange_successfully: "Currency Exchange Successfully",
    please_select_other_currency: "Please select other currency to exchange",
    receipt_get: "Recipent Get",
    send_currency_exactly: "You Send Exactly",
    exchange_rate: "Exhange rate",
    helpDesk: "Helpdesk",
    topup_withdraw: "TopUp/Withdraw",
    more: "More",
    order: "Order",
    add_friend: "Add Friend",
    search_friend: "Search friend",
    friend_added_successfully: "Friend Added Successfully",
    please_enter_friend_name: "Please enter friend name",
    message: "Message",
    home: "Home",
    contact: "Contact",
    qr_topup: "QR TopUp",
    qr_topup_reciept: "TopUp QR",
    transaction_process: "Your transaction is in progress",
    please_allow_camera_permission: "Please allow camera permission.",
    enter_game: "Enter Game",
    exit_game: "Exit Game",
    edit_nickname: "Edit Nickname",
    model: "Model",
    device_id: "Device Id",
    unique_id: "Unique Id",
    lt_coin: "LT Coin",
    stage: "Stage",
    update_now: "UPDATE NOW",
    withdraw_policy:
      "Dear customers, in order to prevent fraud, customers must ensure that your bank holder name is same as that of your deposit account when making withdrawals. This policy is also to protect the security of the customer's funds. Sorry for any inconvenience, Thank you",
    max: "Max",
    promotion_reward: "Promotion Reward",
    birthday_gift: "Birthday Gift",
    daily_withdraw: "Max daily withdrawals",
    monthly_Salary: "Double monthly salary",
    edit_bank_account_succ: "Edit bank account successfully",
    cancel_request: "Cancel Request",
    redeem_coupon: "Redeem Coupon",
    coupon_list: "Coupon List",
    code_redeem_success: "Code Redeem Successful",
    please_enter_username: "Please enter username.",
    limitPerDay: "Limit per day: ",
    approved: "approved",
    processing: "Processing",
    got_it: "GOT IT",
    amount_greater_then_available_balance:
      "Sorry, your amount is greater that available balance",
    details: "Detail",
    rate: "Rate",
    select_bank: "Select Bank",
    address: "Address",
    date_time: "Date Time",
    select_country_code: "Select Country Code",
    pick_bank: "Pick Bank",
    balance: "Balance",
    luckytownviplabel: "Lucky Town VIP",
    vip_activity_label: "Activity",
    vip_member_bonus: "VIP Member Bonus ",
    vip_promoted_conditions: "Promoted Conditions",
    vip_toa: "LuckyTown VIP Term & Condition",
    promoted_bonus: "Promoted Bonus",
    birthday_bonus: "Birthday Bonus",
    withdraw_limit: "Withraw Limit",
    monthly_bonus: "Monthly Bonus",
    vip_activity_1:
      "● Lucky Town is committed to creating a comfortable gaming platform but also does not forget to create a first-class VIP platform that we have been pursuing in the industry.",
    vip_activity_2:
      "●With the continuous growth of players' on the Lucky Town gaming platform, we will provide players with more attentive care and higher-quality activities. A new reward system for Lucky Town players has been launched. New and old players can also enjoy more event bonus offers;",
    vip_policy_1:
      "1. Promotion conditions: The system automatically determines that the promotion gift will be distributed immediately after the upgrade is completed. The time limit for receiving the gift is 14 days after the distribution. Failure to receive it within the time limit will be regarded as giving up and will be automatically withdrawn by the system.",
    vip_policy_2:
      "2. Relegation Condition: The system automatically accumulates whether the relegation eligibility is met. The cumulative time is the first day of the upgrade day, and it will be calculated later. \nExample: A member is upgraded to a gold member on November 3, and the accumulated time in the system is from September 3 at 12:00:01 PM to December 3 at 11:59:59 AM, during a period of three months ( one season) whether to qualify for relegation.",
    vip_policy_3:
      "3. Birthday gift: 3 days before and after receiving the birthday gift or on the same day, you need to submit your ID card photo to the customer service for verification. And the name of the ID card presented must match the name of the bank account of the game account before it can be claimed. Exceeding the deadline for applying for the birthday gift money will be regarded as giving up.",
    vip_policy_4:
      "4. Irregular holiday gifts, irregular holiday gifts will be given by mail or gift money.",
    vip_policy_5:
      "5. For free travel, you need to maintain vip6 for at least 4 quarters (12 months) before you can get it. The departure date, hotel and air ticket will be arranged by the company at its sole responsibility (it will not be given to change the hotel or change the air ticket date and departure date).",
    vip_policy_6:
      "6. The above event rewards or gift money collection period is within 14 days after distribution. Failure to collect within the time limit will be regarded as giving up and will be automatically withdrawn by the system.",
    vip_policy_7:
      "7. Weekly/Monthly Rewards: (VIP2 / VIP3) Monthly - At least 10 deposits are completed, or the cumulative deposit is THB8000 and the rolling amount is more than 40,000, in order to get the monthly VIP reward. \n(VIP4 / VIP5 / VIP6 ) At least 1 deposit per week, or a cumulative deposit of THB8000 and a rolling amount of 40,000 or more, can get weekly VIP bonus",
    vip_policy_8:
      "《Event Terms》 \n\n1. The promotion is only for entertainment members. If it is found that the user has more than one account, including the same name, the same email address, the same/similar IP address, the same address, the same debit/credit card, the same bank account, the same computer, etc. Any abnormal betting behavior, once found, LUCKY TOWN will reserve the right to freeze your account profit and balance. \n\n2. Any betting, tie, other hedging bets (cross-site betting), rejected bets, void bets, ties or sports odds below 1.5 will not be counted as valid bets required for the promotion. \n\n3. Any bets made through third-party illegal software such as 'robots' and 'opening double/multiple windows' can be regarded as illegal bets, and LUCKY TOWN reserves the right to freeze the balance of the suspected account and close the member account. \n\n4. LUCKY TOWN has the right to check all betting records of members. If a member violates the regulations and rules of the event or has any non-entertainment purpose of using bonuses to make profits, LUCKY TOWN reserves all rights to stop, cancel or claim back at any time. All offers paid. \n\n5. LUCKY TOWN reserves the right to require members to submit relevant documents to verify their identity if the relevant account is suspected of being abused and/or not eligible for this promotion. \n\n6. If any individual/team/organization is suspected of using dishonest methods or fraudulent acts for the purpose of defrauding/abusing bonuses, once verified, LUCKY TOWN will have the right to freeze the relevant account profits and balances. \n\n7. By participating in this promotion, you agree to the 'All Rules and Terms of Promotion'. \n\n8. LUCKY TOWN reserves the right to revise, terminate or final interpretation of this promotion; and to make changes to this promotion without notice. \n\n9. If illegal betting is found, the deposit (including profit amount and bonuses) will be frozen, and the system will automatically clear it to zero.",
    vip_policy_9: "``",
    vip_policy_10: "",
    vip_accumulated_deposit: "`Accumulated Deposit:`",
    vip_require_turnover: "`Require Turn Over:`",
    change_language: "Change language",
    fraud_prevention: "Fraud Prevention",
    fraud_prevention_desc:
      "(Inside the remarks) If the following words are filled in, we will review them more strictly and the user may not be able to top-ups successfully. \nExample: Sales / Purchases, Rent / Loan, Telecommunication station, Currency exchange, Medical supplies, Clothing supply, Electronic products, Transportation, Car parts, Motor parts, Luxury / Famous brand, Concert tickets / Coupons, Foods / Snacks / Fruits / Drink / Books and others.",
    got_it: "Got It",
    type_a_message: "Type a message",
    vip_coupon: "VIP Coupon",
    egames_coupon: "Egames Coupon",
    reminder: "Reminder",
    signup_username_info:
      "Username is only allowed to consist of letters + numbers, and the length is at least 8 characters",
    signup_password_info:
      "Password must be at least 8 digits, and spaces are not supported",
    signup_new_password_error_msg: "New Password should be alphanumeric",
    signup_password_confirm_passwors_error_msg:
      "Password and confirm password not match ",
    eng_text: "English",
    bahasa_melayu_text: "Bahasa Melayu",
    thai_text: "เปลื่ยนภาษา",
    ch_text: "中文",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*Deposit processing time will completed within 10 minutes, please be patient, thank you!",
    qr_description_thb:
      "*Recommend a new player to 'register an account' with a minimum ' Topup of 100THB ' and you will get a 'referral' fee of 20THB'. \n\n*Successfully recommending a 'new player', your account will be automatically upgraded to a 'super player', and you can extract a percentage of the effective betting amount of the 'player' you recommend.",
    total_amount: "Total Amount",
    transaaction_no: "Transaction No",
    share: "Share",
    timer: "Timer",
    gift: "Gift",
    schedule: "Schedule",
    qr_description_myr:
      "*Recommend a new player to 'register an account' with a minimum ' Topup of 20MYR ' and you will get a 'referral' fee of 2MYR'. \n\n*Successfully recommending a 'new player', your account will be automatically upgraded to a 'super player', and you can extract a percentage of the effective betting amount of the 'player' you recommend.",
    bonus_monthly: "Bonus(monthly)",
    birthday_bonus: "birthday bonus",
    withdraw_per_day: "Withdraw per day",
    exclusive_domain: "Exclusive domain name",
    deposit_priority: "Deposit priority",
    festival_gift: "Festival gift",
    exclusive_customer_service: "Exclusive customer service",
    free_travel: "Free travel",
    vip_myr_activity_1:
      "● Lucky Town is committed to creating a comfortable gaming platform but also does not forget to create a first-class VIP platform that we have been pursuing in the industry.",
    vip_myr_activity_2:
      "● With the continuous growth of players' on the Lucky Town gaming platform, we will provide players with more attentive care and higher-quality activities. A new reward system for Lucky Town players has been launched. New and old players can also enjoy more event bonus offers;",
    vip_myr_policy:
      "1. Promotion conditions: The system automatically determines that the promotion gift will be distributed immediately after the upgrade is completed. The time limit for receiving the gift is 14 days after the distribution. Failure to receive it within the time limit will be regarded as giving up and will be automatically withdrawn by the system. \n2. Relegation Condition: The system automatically accumulates whether the relegation eligibility is met. The cumulative time is the first day of the upgrade day, and it will be calculated later.Example: A member is upgraded to a gold member on November 3, and the accumulated time in the system is from September 3 at 12:00:01 PM to December 3 at 11:59:59 AM, during a period of three months ( one season) whether to qualify for relegation. \n3. Birthday gift: 3 days before and after receiving the birthday gift or on the same day, you need to submit your ID card photo to the customer service for verification. And the name of the ID card presented must match the name of the bank account of the game account before it can be claimed. Exceeding the deadline for applying for the birthday gift money will be regarded as giving up. \n4. Irregular holiday gifts, irregular holiday gifts will be given by mail or gift money. \n5.  For free travel, you need to maintain vip6 for at least 4 quarters (12 months) before you can get it. The departure date, hotel and air ticket will be arranged by the company at its sole responsibility (it will not be given to change the hotel or change the air ticket date and departure date). \n6. The above event rewards or gift money collection period is within 14 days after distribution. Failure to collect within the time limit will be regarded as giving up and will be automatically withdrawn by the system. \n7. Weekly/Monthly Rewards: (VIP2 / VIP3) Monthly - At least 10 deposits are completed, or the cumulative deposit is RM1000 and the rolling amount is more than 5000, in order to get the monthly VIP reward. (VIP4 / VIP5 / VIP6 ) At least 1 deposit per week, or a cumulative deposit of RM1000 and a rolling amount of 5000 or more, can get weekly VIP bonus \n\n《Event Terms》\n1. The promotion is only for entertainment members. If it is found that the user has more than one account, including the same name, the same email address, the same/similar IP address, the same address, the same debit/credit card, the same bank account, the same computer, etc. Any abnormal betting behavior, once found, LUCKY TOWN will reserve the right to freeze your account profit and balance. \n2. Any betting, tie, other hedging bets (cross-site betting), rejected bets, void bets, ties or sports odds below 1.5 will not be counted as valid bets required for the promotion. \n3. Any bets made through third-party illegal software such as 'robots' and 'opening double/multiple windows' can be regarded as illegal bets, and LUCKY TOWN reserves the right to freeze the balance of the suspected account and close the member account. \n4. LUCKY TOWN has the right to check all betting records of members. If a member violates the regulations and rules of the event or has any non-entertainment purpose of using bonuses to make profits, LUCKY TOWN reserves all rights to stop, cancel or claim back at any time. All offers paid. \n5. LUCKY TOWN reserves the right to require members to submit relevant documents to verify their identity if the relevant account is suspected of being abused and/or not eligible for this promotion. \n6. If any individual/team/organization is suspected of using dishonest methods or fraudulent acts for the purpose of defrauding/abusing bonuses, once verified, LUCKY TOWN will have the right to freeze the relevant account profits and balances. \n7.  By participating in this promotion, you agree to the 'All Rules and Terms of Promotion'. \n8.  LUCKY TOWN reserves the right to revise, terminate or final interpretation of this promotion; and to make changes to this promotion without notice.  \n9. If illegal betting is found, the deposit (including profit amount and bonuses) will be frozen, and the system will automatically clear it to zero. \n",
    weekly: "Weekly",
    withdraw_duration_text:
      "*Deposit processing time will completed within 30 minutes, please be patient, thank you!",
    hot_game: "Hot Games",
    new_games: "New Games",
    reset_app: "Clear App Cache",
    reset_app_title: "Clear Cached Data",
    reset_app_description: "Are you sure ? You want to delete your app data.",
    anoucement_intro_title: "Announcement",
    anoucement_intro_description:
      "You can find the important announcement here.",
    game_list_intro_title: "Game List",
    game_list_intro_description:
      "All the games are listed here, you can click the game icon to start game.",
    topup_intro_title: "Topup/Withdraw",
    topup_intro_description:
      "This is where you can top up/withdraw your balance.",
    leatherboard_intro_title: "Leaderboard ",
    leatherboard_intro_description:
      "Top players of the month will be listed here. Spend and win the prize!",
    previous_step: "Previous",
    next_step: "Next",
    skip_step: "Skip",
    finish_step: "Finish",
    point_history: "Point History",
    points: "Points",
    luckytown_points: "LK Points",
    you_have_earned: "You have earned",
    topup_info:
      "If the real name and bank transfer account name submitted for topup are inconsistent, company has right to reject the submitted application",
    please_upload_reciept: "Please upload receipt",
    pull_out_credit: "Pull Out Credit",
    pull_out_all_credit: "Pull Out All Credit",
    pull_out_credit_message: "Are you sure you want to Pull Out all Credits?",
    topup_promotion_intro:
      "IMPORTANT NOTICE: To participate in any special events, users will not be able to use QR transfer or ID transfer until the turnover conditions of the selected discount are fulfilled. and after the withdrawal through the platform is completed brought to customer service and passed the verification to start the QR transfer function.",
    statment: "Statement",
    withdraw_usdt: "Withdraw USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n• The minimum withdrawal amount is: 1USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    origin_amount: "Origin Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",
    game_detail: "Game Detail",
    google_auth: "Google Authentication",
    redeem: "Redeem",
    enter_verification_code: "Enter the 6-digit verification code",
    activate_google_auth: "Activate Google Authenticator",
    inactivate_google_auth: "In Activate Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Are you sure you want to Reset Google Authenticator?",
    activate_google_auth_msg:
      "Are you sure you want to Activate Google Authenticator?",
    register_google_auth_verification_msg:
      "Setup account with Google Auth Veririfcation",
    scan_google_auth_msg:
      "Scan this QR Code with yoour Google Authenticator App. Alternatively, you can use this code to reset   ",
    secret_key: "Secret Key:",
    pin: "PIN",
    change_app_icon: "Change App Icon",
    change_app_icon_message: "Are you sure you want to change app icon?",
    change_app_icon_success_message: "App Icon Change Successfully",
    real_name_verification: "Real Name Verification",
    enter_real_name: "Enter Real Name",
    real_name_notes:
      "Notes:\n\n1. Add a bank account with your real-name. \n2. Choose the bank account.\n3. Fill in your real-name. \n4. Submit Verification Request. \n5. Your request will be updated within 3 working days.",
    please_login_first: "Please Login first",
    otp_prefix: "OTP Prefix",
    notification_detail: "Notification Detail",
    bonus_chips: "Bonus Chips",
    bonus: "Bonus",
    cash_wallet: "Cash Wallet",
    promotion_intro_description: "Check out our latest promotion here.",
    looked_amount: "Looked Amount",
    current_tunrover_stake: "Current/Turnover Stake",
    turnover_stake_remarks: "Turnover Stake Auto Update in 10 Minutes",
    otp_verification_text:
      "Please check the mobile phone SMS and enter the OTP for verification and binding your mobile device to protect your account security",
    select_deposit_method: "Select Deposit Method",
    user_agreement: "User Agreement",
    no_record_found: "No Record Found",
    info: "Info",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "Instruction",
  },
  ch: {
    app_name: "幸运城",
    login_text: "登入",
    signUp_text: "注册",
    welcom_text: "欢迎使用幸运城",
    username_text: "账号",
    password_text: "密码",
    forgotPassword_text: "忘记密码",
    otp_text: "验证码",
    invalid_username_or_password: "无效账号或密码",
    invalid_password: "密码错误",
    invalid_data_input: "无效数据输入",
    invalid_phone_number: "无效电话号码",
    invalid_transaction_pin: "无效交易密码",
    history_text: "历史",
    from_date: "从日期",
    to_date: "到日期",
    to: "到",
    go: "去",
    select: "选择",
    new_account: "新账号",
    new_password: "新密码",
    recommended_user: "推荐人账号",
    phone_number: "电话号码",
    confirm_password: "确认密码",
    username_or_phone_number_is_registered: "账号或电话号码已被注册",
    recover_password: "找回密码",
    recover_username: "找回用户名",
    please_enter_phone_number: "输入您的电话号码以找回密码",
    next: "下一步",
    otp_code_resended: "已重新发送",
    invalid_otp_code: "无效验证码码",
    request_otp: "验证码请求",
    please_enter_otp: "输入从您验证方式获得的OTP",
    proceed: "继续",
    resend_code: "重新发送代码",
    change_login_password: "修改登入密码",
    select_one_of_the_cre: "择其中一项验证方式来恢复您的密码",
    password_changed: "密码已被修改",
    congratulations_changed_password: "恭喜!您已成功修改密码",
    login_now: "现在登入",
    discover: "发现",
    amount_RM: "金额",
    start: "开始",
    contacts: "通讯录",
    new_friend: "新好友",
    wallet: "钱包",
    cash: "现金",
    bank_account: "银行户口",
    setting: "设定",
    withdraw_succ: "提款成功",
    top_up_succ: "充值成功",
    coin: "礼码",
    interest: "幸运币",
    wallet_balance: "现金余额",
    top_up: "充值",
    withdraw: "提款",
    transaction: "交易记录",
    instant_top_up: "快速充值",
    top_up_bank_transfer: "银行转账",
    error_please_try_again: "误,请重试",
    top_up_RM: "充值",
    upload_receipt: "Upload Receipt",
    choose_upload_photo_method: "选择上传照片方式",
    take_picture: "拍照",
    select_from_gallery: "从相册选择",
    take_photo: "拍照",
    retake: "重拍",
    use_photo: "使用照片",
    upload_bank_receipt: "上传银行收据",
    confirm_to_upload_this_photo: "确定上传此照片?",
    cancel: "取消",
    confirm: "确定",
    wallet_balance_not_enough: "现金余额不足用于提款",
    withdraw_RM: "提款",
    no_transaction_for_dates: "选定日期无交易",
    please_enter_date: "请输入日期",
    all_transaction: "所有交易记录",
    top_up_history: "充值记录",
    interest_account_removed: "利息户口已删除",
    interest_account_created_succ: "利息户口成功创建",
    you_have_no_interest_account: "没有运行利息户口",
    interest_history: "幸运币历史",
    days: "天",
    hours: "小时",
    create_interest: "创建利息",
    deposit_RM: "存款",
    balance_RM: "余额",
    remove: "删除",
    partial_withdraw: "部分提款",
    interest_withdraw: "利息提款",
    add_back_account_succ: "银行户口成功添加",
    edit_bank_account: "修改银行户口",
    bank: "银行",
    account_name: "户口名字",
    account_no: "户口号码",
    add_bank_account: "添加银行户口",
    sign_out: "登出",
    language: "语言",
    clear_cache: "清除缓存",
    about: "关于",
    old_password_not_match: "旧密码不匹配",
    old_password: "旧密码",
    back: "返回",
    version: "版本",
    change_payment_pin: "修改支付码",
    change_nickname: "修改昵称",
    transfer: "转账",
    create_pin: "创建交易密码",
    change_pin: "修改交易密码",
    creat_pin_description: "创建6位数交易密码用以交易",
    please_enter_pin_again: "请再输入6位数交易密码",
    pin_dont_match: "交易密码不匹配",
    old_pin: "旧交易密码",
    new_pin: "新交易密码",
    confirm_new_pin: "确认交易密码",
    pin_max_six: "6位数交易密码",
    succ_pin_change: "交易密码已修改",
    congratulations_changed_pin: "恭喜！您已成功修改交易密码",
    please_enter_pin: "请输入交易密码",
    forgot_pin: "忘记交易密码",
    recover_transaction_pin: "恢复交易密码",
    please_enter_phone_number_pin: "请输入注册电话号码以恢复交易密码",
    old_pin_not_match: "旧交易密码不匹配",
    new_pin_not_match: "新交易密码不匹配",
    transfer_RM: "转账",
    transfer_succ: "转账成功",
    transfer_to: "转账去",
    wallet_insuffecient_amount: "现金余额不足用以转账",
    change_your_nickname: "修改或更换昵称",
    nickname: "设定昵称",
    fullname: "全名",
    nickname_change_succ: "成功修改昵称",
    cancellation: "取消",
    confirm_to_remove_and_withdraw: "确认删除和提款",
    confirm_go_back: "确认返回？",
    in_game: "游戏中",
    close_game_first: "请退出其他游戏",
    close_game: "关闭游戏",
    game_closed: "游戏已关闭",
    game: "游戏",
    information: "资讯",
    search: "搜索",
    no_user_found: "用户不存在",
    i_have_read_and_agree: "我已阅读和赞同",
    LID: "LID",
    referral: "推荐人",
    available_transfer_balance_RM: "可用转账余额",
    i_am_agreed_to_term: "我已赞同规则",
    coin_transaction: "礼码交易记录",
    status: "状态",
    succ_submission_pending_review: "成功提交待审核",
    leaderboard: "排行榜",
    time_zone: "时区",
    customer_service: "联系客服",
    qr_transfer: "转账",
    top_up_details: "充值详情",
    top_up_type: "充值类型",
    date: "日期",
    receipt: "收据",
    available_transfer: "可用转账余额",
    available_coin: "可用礼码",
    commission: "佣金",
    today_stake: "今日押注",
    yesterday_stake: "昨日押注",
    wallet_transaction: "钱包交易记录",
    game_transaction: "游戏记录",
    type: "类型",
    all: "全部",
    refund: "退款",
    penalty: "罚款",
    pick_date: "选择日期",
    time: "时间",
    win: "赢/输",
    win_: "赢",
    bet: "赌注",
    bet_or_transfer: "下注/转账",
    save_in_album: "保存在相册",
    qr_code_saved: "保存QR",
    save_error: "保存失败",
    change_avatar: "修改头像",
    avatar_changed: "头像已修改",
    cant_start_game: "无法启动游戏",
    details: "详情",
    product: "产品",
    total_bet: "下注总额",
    reward: "奖励",
    photo_library: "照片库",
    qr_code_error: "QR码错误",
    maintenance: "维护",
    coming_soon: "即将推出",
    top_up_disclaimer:
      "**请遵守本公司所列出的条规，否则将会延迟上分，祝您游戏愉快 谢谢",
    minimum_top_up: "最低限度: ",
    maximum_top_up: "最大限度: ",
    top_up_left_times: "剩余次数",
    top_up_unlimited: "（无限次数）",
    order_history: "订单历史",
    withdraw_history: "提款记录",
    no_bank_account_added: "请绑定至少1个银行户口",
    minimum_withdraw: "最低限度：",
    maximum_withdraw: "最大限度：",
    free_withdraw_time: "免费次数：",
    withdraw_balance: "当前余额：",
    unlimited: "无限",
    withdraw_details: "提款详情",
    updated_date: "更新日期",
    pending: "等待中",
    success: "成功",
    in_inspection: "审核中",
    hold: "On hold",
    confirm_to_remove_withdraw: "确认删除提款？",
    confrim_to_remove_top_up: "确认删除充值？",
    rejected: "已拒绝",
    copied: "复制到剪贴板",
    anouncement: "公告",
    contactUs: "客服 ",
    newVersionTitle: "新版本可用",
    versionDescription: "要使用该应用程序，您需要将其升级到最新版本",
    verification: "验证",
    device_name: "手机名字",
    device_info: "手机资料",
    friend: "朋友圈",
    about_phone: "关于手机",
    remarks: "评论",
    balance_transfer: "余额转账成功",
    usdt_top_up: "充值 USDT",
    app_close: "关闭",
    topupRemarks:
      "请把 LT-(你的用户名)注明在转钱单上面 \nE.g. \nID: luckytown \nRefer: LTluckytown",
    top_up_policy:
      "我们公司会不时更改银行账号，请在您的银行/转账前确认户口，公司对因您的过错造成的任何损失概不负责。",
    notification: "通知",
    promotion: "优惠",
    use_now: "现在使用",
    promo_code: "优惠码",
    enter_otp: "请输入验证码",
    change_phone_no: "更改电话号码",
    change_your_phone: " 编辑或者更改电话号码 ",
    congratulations_changed_phone: "恭喜！你已经成功更改电话号码",
    default_avatar: "Default Avatar",
    forgotUsername_text: "忘了用户名了吗",
    authenticate: "验证",
    forgot_id_password: "忘记 UID/密码",
    manage_account: "切换账号",
    add_another_account: "添加另一个帐户",
    add_account: "新增帐户",
    cashout: "兑现",
    please_signin_to_continue: "请登录以继续",
    no_account_found: "未找到帐户",
    please_enter_phone_number_to_recover_username:
      "请输入您注册的电话号码以找回您的用户名.",
    register_device_text: "手机与户口不匹配。请匹配您的手机型号先",
    reward: "奖励",
    please_enter_txid: "请输入TXID",
    please_enter_amount: "请输入数目",
    topUpUSDTReceipt: "充值 USDT 收据",
    amount_usdt: "数目(USDT)",
    txid: "TXID",
    enter_txid: "输入TXID",
    platform: "平台",
    select_platrform: "选择平台",
    request_topup_success: "充值成功",
    chip: "筹码",
    confrim_to_remove_back_account: "确定移除银行户口?",
    footer_home: "主页",
    footer_contact: "联系人",
    footer_transaction: "记录",
    footer_me: "个人",
    profile_cash: "现金",
    profile_chip: "礼码",
    profile_luck: "幸运币",
    profile_vip: "VIP",
    bank_search_bank: "搜索银行户口",
    avatar_back: "返回",
    friend_search_friend: "搜索朋友",
    friend_delete: "删除",
    friend_title: "添加朋友",
    friend_popup: "请输入朋友名字",
    game_details_download: "下载",
    game_details_launch: "进入",
    game_details_transfer: "转发",
    qr_copy_link: "复制链接",
    qr_qr_share: "分享二维码",
    profile_lucky_coin: "幸运币",
    confrim_to_remove_back_account: "确认删除银行账户？",
    currency_exchange: "货币兑换",
    currency_exchange_successfully: "货币兑换成功",
    please_select_other_currency: "请选择其他货币兑换",
    receipt_get: "获取收据",
    send_currency_exactly: "准确发送货币",
    exchange_rate: "汇率",
    helpDesk: "客服",
    topup_withdraw: "充值/提款",
    more: "更多",
    order: "订单",
    add_friend: "添加好友",
    search_friend: "搜索好友",
    friend_added_successfully: "成功添加好友",
    please_enter_friend_name: "请输入好友名字",
    message: "信息",
    qr_topup: "二维码充值",
    qr_topup_reciept: "二维码充值",
    transaction_process: "您的交易正在进行中",
    please_allow_camera_permission: "请允许相机权限",
    enter_game: "进入游戏",
    exit_game: "退出游戏",
    edit_nickname: "修改昵称",
    max: "全部",
    stage: "阶段",
    empty_notifications: "没有新的通知",
    model: "模型",
    device_id: "设备ID",
    unique_id: "唯一身份",
    lt_coin: "幸运币",
    update_now: "更新最新版本",
    withdraw_policy:
      "亲爱的顾客，本公司为了提防诈骗行为，顾客们进行提款时请务必确保与您的存款户口名字相同，此项条规也是在保护顾客户口的资金安全，如有不便请谅解，谢谢",
    please_enter_username: "請輸入用戶名.",
    promotion_reward: "晋升奖励",
    birthday_gift: "生日礼金",
    daily_withdraw: "日提款次数",
    monthly_Salary: "每月双俸禄",
    edit_bank_account_succ: "更改银行户口成功",
    cancel_request: "取消请求",
    redeem_coupon: "兑换优惠",
    coupon_list: "优惠列表",
    code_redeem_success: "兑换优惠成功",
    limitPerDay: "每日上限次数: ",
    approved: "成功",
    processing: "处理中",
    got_it: "知道了",
    amount_greater_then_available_balance: "抱歉，您的金额大于可用余额",
    details: "详情",
    rate: "汇率",
    select_bank: "选择银行",
    address: "地址",
    date_time: "日期 时间",
    select_country_code: "选择国家区号",
    pick_bank: "选择银行",
    balance: "余额",
    luckytownviplabel: "Lucky Town 幸运城 VIP",
    vip_activity_label: "晋升条件",
    vip_member_bonus: "VIP会员特权 ",
    vip_promoted_conditions: "晋升条件",
    vip_toa: "LuckyTown(幸运城）VIP的规则与条款",
    promoted_bonus: "晋升奖励",
    birthday_bonus: "生日礼金",
    withdraw_limit: "日提款次数",
    monthly_bonus: "每月双俸禄",
    vip_activity_1:
      "● Lucky Town (幸运城) 在致力打造舒心游戏平台的同时，更不忘重金打造业界一流的贵宾之所，尽享奢华，用心成就您的尊贵，用信誉铸就我们的经典，满足您的享受，是我们一直的追求，贵者为宾，尊者唯尊",
    vip_activity_2:
      "● 伴随着玩家在Lucky Town (幸运城) 娱乐平台上的持续活跃度的增长，为玩家提供更细心的关怀和更优质的活动。推出的一套面向Lucky Town (幸运城) 玩家的全新回馈体系。新老玩家也可以享受更多的活动红利优惠；",
    vip_policy_1:
      "1.系统会在每月1号进行玩家条件审核，符合条件会进\n行升级并且派发晋升奖励。",
    vip_policy_2:
      "2.平台将根据符合条件的玩家根据等级每月发放两次\n俸禄金。无需申请，系统自动派发\n派发时间：每月1号以及16号。中午2点至3点。\n申请条件：申请16号俸禄－当月1号至15号必须充值\n最少3次，单笔超过5000.申请1号俸禄－上月16号至30号／31号必须\n充值最少3次，单笔超过5000.",
    vip_policy_3:
      "3.如玩家有参加LuckyTown(幸运城）其他优惠活动，则活\n动优惠所需要的有效金额不计算在会员成长有效金额内。",
    vip_policy_4: "4.该活动与天天返水活动共享。",
    vip_policy_5:
      "5.玩家当月升级后，可享受升级后等级的升级礼金\n（例：玩家XXX在10月初由VIP1玩家升级VIP2玩家，\n10月初玩家XXX就可以享受VIP2玩家1880泰铢升级礼金）。",
    vip_policy_6:
      "6.生日彩金可在生日当天，提供会员账号相关资料以及身份证正面照扫描，通过客服进行申请。",
    vip_policy_7: "7.客服经理24小时为您贴心服务。",
    vip_policy_8:
      "8.如发现会员滥用我们的VIP条款，恶意使用非正常手段套取利益，我们保留收回VIP特权的权利。",
    vip_policy_9:
      "9.公司风控部门一旦检测会员属于套利玩家，将给与十倍有效流水提款，退还本金惩罚处理。",
    vip_policy_10:
      "10.参与此活动，即表示您同意《规则说明》，LuckyTown（幸运城）保留对活动的修改，停止及最终解释权。",
    vip_accumulated_deposit: "`累计存款:`",
    vip_require_turnover: "`流水要求:`",
    change_language: "改變語言",
    fraud_prevention: "预防欺诈",
    fraud_prevention_desc:
      "（备注里面） 如有填下任何一下字眼，我们会更加严格审核您的充值，用户不一定能顺利换取分数。\n例如:买/卖，租/借，电信台，兑换货币，医护用品，衣橱用品，电子产品，交通工具，汽车零件，摩托零件，奢侈品/名牌，演唱会票/固本，食物/零食/水果/饮料/书箱等。",
    got_it: "知道了",
    type_a_message: "鍵入消息",
    vip_coupon: "貴賓券",
    egames_coupon: "電子遊戲優惠券",
    reminder: "温馨提示",
    signup_username_info: "账号只允许由“字母+数字”组成，长度最少是8个字符",
    signup_password_info: "密码最少为8个位，不支持空格",
    signup_new_password_error_msg: "新密码应为字母数字组合。",
    signup_password_confirm_passwors_error_msg: "密码与确认密码不匹配",
    ch_text: "中文",
    eng_text: "English",
    bahasa_melayu_text: "Bahasa Melayu",
    thai_text: "เปลื่ยนภาษา",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text: "*存款处理时间在10分钟内完成，请耐心等待，谢谢！",
    qr_description_thb:
      "*推荐新玩家'注册账号”并且最低'充值100THB'您将会获取“推荐费20THB'. \n\n*推荐“新玩家”成功，您的账号将会自动升级为“超级玩家”可抽取你推荐的“玩家”有效投注打码量的百分比返佣现金",
    total_amount: "Total Amount",
    transaaction_no: "Transaction No",
    share: "Share",
    timer: "Timer",
    gift: "Gift",
    schedule: "Schedule",
    qr_description_myr:
      "*推荐新玩家'注册账号”并且最低'充值20MYR'您将会获取“推荐费2MYR'. \n\n*推荐“新玩家”成功，您的账号将会自动升级为“超级玩家”可抽取你推荐的“玩家”有效投注打码量的百分比返佣现金",
    bonus_monthly: "奖励(每月)",
    birthday_bonus: "生日礼金",
    withdraw_per_day: "日提款次数",
    exclusive_domain: "专属域名",
    deposit_priority: "存款优先",
    festival_gift: "不定期节日送礼",
    exclusive_customer_service: "专属客服",
    free_travel: "免费旅游",
    vip_myr_activity_1:
      "● Lucky Town (幸运城) 在致力打造舒心游戏平台的同时，更不忘重金打造业界一流的贵宾之所，尽享奢华，用心成就您的尊贵，用信誉铸就我们的经典，满足您的享受，是我们一直的追求，贵者为宾，尊者唯尊",
    vip_myr_activity_2:
      "● 伴随着会员在Lucky Town (幸运城) 娱乐平台上的持续活跃度的增长，为会员提供更细心的关怀和更优质的活动。推出的一套面向Lucky Town (幸运城) 玩家的全新回馈体系。新老玩家也可以享受更多的活动红利优惠；",
    vip_myr_policy:
      "1. 晋级条件：系统将会在每一季（3个月）以存款+流水作为标准自动进行判定会员符合条件升级并且派发晋升奖励* 升级完成当下将立即派送晋级礼金. \n2. 保级条件：系统自动累计是否达到保级资格，累计时间为升级当天为第一天，往后推算。例：会员在11月3号升级为黄金会员，系统累计时间为9月3日12时:00分:01秒PM至12月3日11时:59分:59秒AM，期间三个月份（一季）是否达到保级资格。\n3. 生日礼金：领取生日礼金前后3天或当天需提交本人身份证照片给予客服进行核对。并且所出示的身份证名需和该游戏账户的出款银行账户名字相符,方可领取,超过申请生日礼金的期限视同放弃。\n4. 不定期节日礼物，不定期节日礼物会通过邮寄方式赠送或通过礼金方式赠送。\n5. 免费旅游，需保持至少4个季度（12个月）的vip6 方可获得，出发日期、酒店、机票 将由公司全权负责安排（不给予更换酒店或更改机票日期以及出发日期。\n6.  以上活动奖励或礼金领取期限为派发后14天内，未在期限内领取视同放弃，将由系统自动收回。\n7.每周/每月礼金：（VIP2 / VIP3 ）每月 - 最少完成10次存款 ，或累积存款有 RM1000 以及有效打码量为 5000 以上，才可获取每月VIP礼金。（VIP4 / VIP5 / VIP6 ）每周最少完成1次存款，或累积存款有 RM1000 以及有效打码量为 5000 以上，才可获取每周VIP礼金  \n\n《活动条款》\n1. 优惠活动仅针对娱乐性质会员，如发现用户拥有超过一个帐户，包括同一姓名、同一邮件地址、同一/相似IP地址、同一住址、同一借记卡/信用卡、同一银行帐户、同一电脑等其他任何不正常投注行为，一经发现，LUCKY TOWN将保留冻结您的帐户盈利及余额的权利。\n2.  任何对赌、和局、其他对冲投注（跨网站对投）、拒绝投注、无效投注、打平或是体育赔率低於1.5情况，都不计算为优惠所需有效投注额。\n3.  通过「机器人」等第三方非法软件以及「开启双重/多重视窗」所进行的任何投注可视为非法投注，LUCKY TOWN保留权利冻结涉嫌帐户的余额和关闭会员帐户。\n4. LUCKY TOWN有权查核会员的一切投注记录，若会员违反活动条例及细则之规定或出现任何有非娱乐目的利用红利获利的情况，并保留所有权利在任何时候可以停止、取消或索回已支付的全部优惠。\n5. 若相关帐户被怀疑疑滥用和/或不符合取得此项优惠的资格，LUCKY TOWN保留要求会员提交相关证明文档验证核实身份的权利。\n6. 任何个体/团队/组织被怀疑存在使用不诚实的方式或欺诈行为以骗取/滥用红利为目的，一经核实，LUCKY TOWN将有权冻结相关帐盈利及余额。\n7.  参与该优惠，即表示您同意《优惠所有规则与活动条款》。\n8. LUCKY TOWN保留对本优惠活动的修订、终止或最终的解释权；以及在无通知的情况下对本次活动作出更改的权利。\n9. 如若发现违规投注之情况，将冻结该笔存款（包含盈利金额以及所享受红利），系统将自动清零。\n",
    weekly: "每周",
    withdraw_duration_text: "*存款处理时间在30分钟内完成，请耐心等待，谢谢！",
    hot_game: "热门游戏",
    new_games: "新游戏",
    reset_app: "重置缓存",
    reset_app_title: "清除缓存",
    reset_app_description: "确定清楚缓存？这将会清楚应用程序资料",
    anoucement_intro_title: "公告",
    anoucement_intro_description: "重要公告将会公布在这里",
    game_list_intro_title: "游戏列表",
    game_list_intro_description:
      "全部游戏将会显示在这里。点击游戏图片开始游戏。",
    topup_intro_title: "充值/提款",
    topup_intro_description: "这里可以充值/提款至你的户口",
    leatherboard_intro_title: "排行榜 ",
    leatherboard_intro_description:
      "每月最佳玩家将会显示在这里。开始游戏以赢取奖品！",
    previous_step: "上一笔",
    next_step: "下一步",
    skip_step: "跳过",
    finish_step: "完成",
    point_history: "LK 礼码历史记录",
    points: "礼码",
    luckytown_points: "LK 礼码",
    you_have_earned: "总额",
    topup_info: "若实名和提交充值银行转账账号名称不一致，公司有权拒绝充值申请",
    please_upload_reciept: "请上传收据凭证照片",
    pull_out_credit: "强制退出游戏",
    pull_out_all_credit: "拉出所有余额",
    pull_out_credit_message: "确定把所有余额拉出？",
    topup_promotion_intro:
      "重要提示：凡事参与任何优惠活动，该用户将无法使用QR 转帐或ID 转帐，直到完成选定优惠的流水条件后，通过平台提款完成后，向客服申请，通过审核，才能开启QR转帐功能。",
    statment: "游戏记录",
    withdraw_usdt: "提款 USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n\n• The minimum withdrawal amount is: 1USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    withdraw_amount: "Withdraw Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",

    game_detail: "游戏界面",
    google_auth: "Google 身份验证器",
    redeem: "兑换",
    enter_verification_code: "输入6位数验证码",
    activate_google_auth: "Google身份验证器已激活",
    inactivate_google_auth: "激活Google身份验证器",
    activate: "激活",
    in_activate: "已激活",
    reset_google_auth_msg: "您确定要重置 Google 身份验证器吗？",
    activate_google_auth_msg: "您确定要激活 Google 身份验证器吗？",
    register_google_auth_verification_msg: "设置帐户使用 Google 身份验证器",
    scan_google_auth_msg:
      "使用您的 Google 身份验证器应用程序扫描此二维码。或者,您可以使用此代码进行重置",
    secret_key: "密钥:",
    pin: "PIN",
    change_app_icon: "更改应用程序图标",
    change_app_icon_message: "您确定要更改应用程序图标吗？",
    change_app_icon_success_message: "应用图标更改成功",
    real_name_verification: "实名验证",
    enter_real_name: "输入真实姓名",
    real_name_notes:
      "备注:\n\n1. 添加实名银行账户。\n2. 选择银行账户。\n3. 填写您的真实姓名。\n4. 提交验证请求。\n5. 您的请求将在3个工作日内更新。",
    please_login_first: "请先登录",
    otp_prefix: "OTP 前缀",
    notification_detail: "通知信息详情",
    bonus_chips: "奖金筹码",
    bonus: "奖金筹码",
    cash_wallet: "现金钱包",
    total: "总数",
    promotion_intro_description: " 在这里查看我们的最新促销活动。",
    looked_amount: "锁定金额",
    current_tunrover_stake: "需要当前/周转股份",
    turnover_stake_remarks: "流水约10分钟计算一次",
    otp_verification_text:
      "请检查手机短信并输入OTP用于验证并绑定您的手机设备，以保护您的账户安全",
    select_deposit_method: "选择存款方式",
    user_agreement: "用户协议",
    no_record_found: "No Record Found",
    info: "信息",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "使用说明",
  },
  bm: {
    app_name: "Lucky Town",
    login_text: "Log Masuk",
    signUp_text: "Daftar",
    welcom_text: "Selamat Datang Ke APP Lucky Town Plus",
    username_text: "Nama Pengguna",
    password_text: "Kata Laluan",
    forgotPassword_text: "Lupa Kata Laluan",
    otp_text: "OTP",
    invalid_username_or_password: "Nama Pengguna atau Kata Laluan tidak betul",
    invalid_password: "Kata Laluan tidak betul",
    invalid_data_input: "Input data tidak betul",
    invalid_phone_number: "Nombor telefon tidak betul",
    invalid_transaction_pin: "Pin Transaksi tidak betul",
    history_text: "Rekod",
    from_date: "Dari Tarikh",
    to_date: "Ke Tarikh",
    to: "Ke",
    go: "Pergi",
    select: "Pilih",
    new_account: "Akaun Baru",
    new_password: "Kata Laluan Baru",
    recommended_user: "Perujuk Pengguna",
    phone_number: "Nombor Telefon",
    confirm_password: "Sahkan Kata Laluan",
    username_or_phone_number_is_registered:
      "Nama pengguna atau nombor telefon didaftar",
    recover_password: "Menetapkan semula kata laluan",
    please_enter_phone_number:
      "Masukkan nombor telefon daftar untuk tetapan semula kata laluan",
    next: "Seterusnya",
    otp_code_resended: "Kod OTP dihantar sekali ",
    invalid_otp_code: "Kod OTP tidak betul",
    request_otp: "Minta OTP",
    please_enter_otp: "Masukkan OTP dihantar ke kaedah pengesahan anda",
    proceed: "Teruskan",
    resend_code: "Kod dihantar sekali",
    change_login_password: "Tukar kata laluan log masuk",
    select_one_of_the_cre:
      "Pilih salah satu kaedah pengesahan untuk menetapkan semula kata laluan",
    password_changed: "Kata laluan ditukar",
    congratulations_changed_password: "Taniah!Kata laluan anda ditukar",
    login_now: "Log masuk sekarang",
    discover: "Didapati",
    amount_RM: "Jumalah",
    start: "Masuk Game",
    contacts: "Hubungi",
    new_friend: "Rakan Baru",
    wallet: "Dompet",
    cash: "Tunai",
    bank_account: "Akaun Bank",
    setting: "Tetapan",
    withdraw_succ: "Pengeluaran nilai berjaya",
    top_up_succ: "Tambah nilai berjaya",
    coin: "Coin",
    interest: "Lucky Coin",
    wallet_balance: "Baki tunai",
    top_up: "Tambah nilai",
    withdraw: "Pengeluaran nilai",
    transaction: "Transaksi",
    instant_top_up: "Pantas tambah nilai",
    top_up_bank_transfer: "Pemindahan Bank",
    error_please_try_again: "Silap,sila cuba sekali",
    top_up_RM: "Tambah nilai",
    upload_receipt: "Upload Receipt",
    choose_upload_photo_method: "Pilih kaedah muat naik foto",
    take_picture: "Ambil gambar",
    select_from_gallery: "Pilih dari galeri",
    take_photo: "Ambil foto",
    retake: "Ambil semula",
    use_photo: "Guna foto",
    upload_bank_receipt: "Muat naik resit bank ",
    confirm_to_upload_this_photo: "Sahkan untuk memuat naik foto ini？",
    cancel: "Batal",
    confirm: "Sahkan",
    wallet_balance_not_enough: "Baki tunai tidak cukup untuk pengeluaran",
    withdraw_RM: "Pengeluaran nilai",
    no_transaction_for_dates: "Tiada transaksi untuk tarikh yang dipilih",
    please_enter_date: "Masukkan tarikh",
    all_transaction: "Semua transaksi",
    top_up_history: "Rekod tambah nilai",
    interest_account_removed: "Akaun LuckyCoin ditutup",
    interest_account_created_succ: "Akaun LuckyCoin berjaya dibuat",
    you_have_no_interest_account: "Anda tidak mempunyai akaun LuckyCoin",
    interest_history: "Rekod faedah",
    days: "Hari",
    hours: "Jam",
    create_interest: "Buat LuckyCoin",
    deposit_RM: "Deposit",
    balance_RM: "Baki",
    remove: "Tutup",
    partial_withdraw: "Pengeluaran sebahagian",
    interest_withdraw: "Pengeluaran faedah",
    add_back_account_succ: "Akaun bank berjaya ditambah ",
    edit_bank_account: "Edit akaun bank",
    bank: "Bank",
    account_name: "Nama akaun",
    account_no: "Nombor akaun",
    add_bank_account: "Tambah akaun bank",
    sign_out: "Log keluar",
    language: "Bahasa",
    clear_cache: "Padam cache",
    about: "Mengenai",
    old_password_not_match: "Kata laluan lama salah",
    old_password: "Kata laluan lama",
    back: "Kembali",
    version: "Versi",
    change_payment_pin: "Tukar pin pembayaran",
    change_nickname: "Tukar nama samaran",
    transfer: "Pindah",
    create_pin: "Buat pin transaksi",
    change_pin: "Tukar pin transaksi",
    creat_pin_description: "Buat pin 6 digit untuk transaksi anda di aplikasi",
    please_enter_pin_again: "Masukkan pin 6 digit sekali",
    pin_dont_match: "Pin salah",
    old_pin: "Pin lama",
    new_pin: "Pin baru",
    confirm_new_pin: "Sahkan pin",
    pin_max_six: "6 digit pin transaksi",
    succ_pin_change: "pin transaksi ditukar",
    congratulations_changed_pin: "Taniah!Pin transaksi anda berjaya ditukar",
    please_enter_pin: "Masukkan pin transaksi",
    forgot_pin: "Lupa pin transaksi",
    recover_transaction_pin: "Menetapkan semula pin transaksi",
    please_enter_phone_number_pin:
      "Masukan nombor telefon daftar untuk tetapan semula pin transaksi",
    old_pin_not_match: "Pin lama salah",
    new_pin_not_match: "Pin baru salah",
    transfer_RM: "Pindah",
    transfer_succ: "Pindahan berjaya",
    transfer_to: "Pindah ke",
    wallet_insuffecient_amount: "Baki tunai tidak cukup untuk dipindah",
    change_your_nickname: "Edit atau tukar nama samaran",
    nickname: "Nama samaran",
    nickname_change_succ: "Nama samaran berjaya ditukar",
    cancellation: "Pembatalan",
    confirm_to_remove_and_withdraw: "Sahkan untuk tutup dan pengeluaran nilai",
    confirm_go_back: "Sahkan untuk kembali？",
    in_game: "Dalam Game",
    close_game_first: "Sila keluar game lain dulu",
    close_game: "Tutup game",
    game_closed: "Game ditutup",
    game: "Games",
    information: "Maklumat",
    search: "Cari",
    no_user_found: "Pengguna tidak dapat dicari",
    i_have_read_and_agree: "Saya telah membaca dan bersetuju",
    LID: "LID",
    referral: "Perujuk",
    available_transfer_balance_RM: "Pemindahan yang ada",
    i_am_agreed_to_term: "Saya bersetuju terma",
    coin_transaction: "Coin transaksi",
    status: "Status",
    succ_submission_pending_review: "Hantar berjaya untuk disemak",
    leaderboard: "Papan pendahulu",
    time_zone: "Zon masa",
    customer_service: "Perkhidmatan pelanggan",
    qr_transfer: "Pemindahan dengan QR",
    top_up_details: "Maklumat tambah nilai",
    top_up_type: "Jenis tambah nilai",
    date: "Tarikh",
    receipt: "Resit",
    available_transfer: "Pemindahan yang ada",
    available_coin: "Coin yang ada",
    commission: "Komisen",
    today_stake: "Pertaruhan semasa",
    yesterday_stake: "Pertaruhan lepas",
    wallet_transaction: "Dompet transaksi",
    game_transaction: "Transaksi game",
    type: "Jenis",
    all: "Semua",
    refund: "Bayaran balik",
    penalty: "Denda",
    pick_date: "Pilih tarikh",
    time: "Masa",
    win: "Menang/Kalah",
    win_: "Menang",
    bet: "Pertaruhan",
    bet_or_transfer: "Pertaruhan/Pemindahan",
    save_in_album: "Simpan di album",
    qr_code_saved: "Kod QR disimpan",
    save_error: "Simpanan tidak berjaya",
    change_avatar: "Tukar avatar",
    avatar_changed: "Avatar ditukar",
    cant_start_game: "Game tidak dapat dimulakan ",
    details: "Perincian ",
    product: "Produk",
    total_bet: "Jumlah taruhan",
    reward: "Ganjaran",
    photo_library: "Foto galeri",
    qr_code_error: "Kesalahan kod QR",
    maintenance: "Penyelenggaraan",
    coming_soon: "Akan Datang",
    top_up_disclaimer:
      "** Harap patuhi peraturan yang disenaraikan oleh syarikat kami. Jika tidak, mata yang diberikan akan ditangguhkan. Kami mengucapkan selamat bermain, terima kasih.",
    minimum_top_up: "Minimum: ",
    maximum_top_up: "Maksimum: ",
    top_up_left_times: "Kekal: ",
    top_up_unlimited: "(Tidak terhad)",
    order_history: "Sejarah Pesanan",
    withdraw_history: "Pengeluaran Sejarah",
    no_bank_account_added: "Sila ikat sekurang-kurangnya satu akaun bank",
    minimum_withdraw: "Min: ",
    maximum_withdraw: "Max: ",
    free_withdraw_time: "Percuma kekerapan: ",
    withdraw_balance: "Baki terkini: ",
    unlimited: "Tidak terhad",
    withdraw_details: "Maklumat Pengeluaran Nilai",
    updated_date: "Tarikh dikemas kini",
    pending: "Belum selesai",
    success: "Berjaya",
    in_inspection: "Dalam pemeriksaan",
    hold: "ditahan",
    confirm_to_remove_withdraw: "Sahkan pengeluaran nilai?",
    confrim_to_remove_top_up: "Sahkan tambah nilai",
    rejected: "Ditolak",
    copied: "Disalin ke papan keratan",
    anouncement: "Pengumuman",
    contactUs: "Perkhidmatan pelanggan",
    newVersionTitle: "Versi Baru Terkini Ada",
    versionDescription:
      "Untuk menggunakan aplikasi tersebut，perlu meningkatkan aplikasi ke versi baru",
    verification: "Verifikasi",
    device_name: "Nama Telephone",
    device_info: "Info telephone",
    friend: "Sosial",
    about_phone: "Info telefon",
    remarks: "kenyataan",
    balance_transfer: "Pemindahan baki berjaya",
    usdt_top_up: "Top Up USDT",
    app_close: "Tutup",
    topupRemarks:
      "Sila nyatakan LT- (nama pengguna anda) pada slip pemindahan \nE.g. \nID: lucky town \nRefer: LTluckytown ",
    top_up_policy:
      "Syarikat kami akan menukar akaun bank dari semasa ke semasa, sila sahkan akaun terlebih dahulu di bank anda / sebelum pindahan wang. Syarikat tidak bertanggungjawab atas kerugian yang disebabkan oleh kesilapan anda.",
    notification: "Pemberitahuan",
    promotion: "Promosi",
    use_now: "Gunakan sekarang",
    promo_code: "Kod Promosi",
    enter_otp: "Sila masukkan OTP",
    change_phone_no: "Tukar nombor",
    congratulations_changed_phone: "Tahniah! anda telah berjaya tukar nombor.",
    change_your_phone: "Edit atau tukar nombor",
    default_avatar: "Default Avatar",
    forgotUsername_text: "Terlupa nama",
    authenticate: "Pengesahan",
    forgot_id_password: "Terlupa UID / Kata Laluan",
    recover_username: "Pulihkan Nama Pengguna",
    manage_account: "Tukar Akaun",
    add_another_account: "Tambah Akaun Lain",
    add_account: "Tambah Akaun",
    cashout: "Keluarkan duit",
    please_signin_to_continue: "Sila log masuk untuk meneruskan",
    no_account_found: "Tiada Akaun Ditemui",
    please_enter_phone_number_to_recover_username:
      "Sila masukkan nombor telefon berdaftar anda untuk memulihkan nama pengguna anda.",
    register_device_text:
      "Peranti ini tidak terikat dengan akaun anda. Sila daftarkan peranti untuk meneruskan",
    reward: "Reward",
    please_enter_txid: "Sila masukkan txid.",
    please_enter_amount: "Sila masukkan amount.",
    topUpUSDTReceipt: "Topup USDT Receipt",
    amount_usdt: "Amaun (USDT)",
    txid: "TXID",
    enter_txid: "Masukkan TXID",
    platform: "Platform",
    select_platrform: "Pilih Platform",
    request_topup_success: "Request Top Up Success.",
    chip: "Cip",
    confrim_to_remove_back_account: "Sila sahkan pengalihan keluar akaun bank?",
    footer_home: "Utama",
    footer_contact: "Contact",
    footer_transaction: "Transaksi",
    footer_me: "Profil",
    profile_cash: "Duit Tunai",
    profile_chip: "Cip",
    profile_lucky_coin: "Lucky Coin",
    profile_vip: "VIP",
    bank_search_bank: "Cari akaun bank",
    avatar_back: "Balik",
    friend_search_friend: "Cari kawan",
    friend_delete: "Padam",
    friend_title: "Tambah kawan",
    friend_popup: "Masukkan nama kawan",
    game_details_download: "Muat Turun",
    game_details_launch: "Masuk",
    game_details_transfer: "Hantar",
    qr_copy_link: "Salinan Link",
    qr_qr_share: "Kongsi QR",
    confrim_to_remove_back_account: "Sahkan untuk mengalih keluar akaun bank?",
    currency_exchange: "Pertukaran mata wang",
    currency_exchange_successfully: "Pertukaran Mata Wang Berjaya",
    please_select_other_currency: "Sila pilih mata wang lain untuk ditukar",
    receipt_get: "resit dapat",
    send_currency_exactly: "hantar mata wang dengan tepat",
    exchange_rate: "Kadar pertukaran",
    helpDesk: "Meja bantuan",
    topup_withdraw: "TopUp/Withdraw",
    more: "lebih",
    order: "Pesanan",
    add_friend: "Menambah rakan",
    search_friend: "Cari kawan",
    friend_added_successfully: "Rakan Berjaya Ditambah",
    please_enter_friend_name: "Sila masukkan nama rakan",
    message: "Mesej",
    qr_topup: "QR TopUp",
    qr_topup_reciept: "TopUp QR",
    transaction_process: "Urus niaga anda sedang dijalankan",
    please_allow_camera_permission: "Sila benarkan kebenaran kamera.",
    enter_game: "Masuk game",
    exit_game: "Keluar game",
    edit_nickname: "edit nama panggilan",
    max: "Max",
    stage: "pentas",
    empty_notifications: "Tiada pemberitahuan baharu.",
    model: "Model",
    device_id: "Id Peranti",
    unique_id: "Id unik",
    lt_coin: "LT Coin",
    update_now: "Kemas Kini",
    withdraw_policy:
      "Pelanggan yang dihormati, untuk mengelakkan penipuan, pelanggan mesti memastikan bahawa nama akaun deposit adalah sama dengan akaun deposit anda semasa membuat pengeluaran. Polisi ini juga untuk melindungi keselamatan dana pelanggan. Mohon maaf atas sebarang kesulitan, Terima Kasih",
    please_enter_username: "sila masukkan nama pengguna.",
    promotion_reward: "Ganjaran Kenaikan Pangkat",
    birthday_gift: "Hadiah Hari Lahir",
    daily_withdraw: "Pengeluaran Harian",
    monthly_Salary: "Gaji Bulanan Dua Kali Ganda",
    edit_bank_account_succ: "Edit bank account successfully",
    cancel_request: "Cancel Request",
    redeem_coupon: "tebus kupon",
    coupon_list: "Coupon List",
    code_redeem_success: "Code Redeem Successful",
    limitPerDay: "had pengeluaran setiap hari: ",
    approved: "Diluluskan",
    processing: "Memproses",
    got_it: "dah dapat",
    amount_greater_then_available_balance:
      "Maaf, jumlah anda lebih besar daripada baki yang ada",
    details: "Butiran",
    rate: "Kadar",
    select_bank: "Pilih Bank",
    address: "Alamat",
    date_time: "Masa Tarikh",
    select_country_code: "Pilih Kod Negara",
    pick_bank: "Pilih Bank",
    balance: "Baki",
    luckytownviplabel: "Lucky Town VIP",
    vip_activity_label: "Aktiviti",
    vip_member_bonus: "Bonus Ahli VIP ",
    vip_promoted_conditions: "Syarat Yang Dipromosikan",
    vip_toa: "LuckyTown VIP Terma & Syarat",
    promoted_bonus: "Bonus Dinaikkan Pangkat",
    birthday_bonus: "Bonus Hari Jadi",
    withdraw_limit: "Had Pengeluaran",
    monthly_bonus: "Bonus Bulanan",
    vip_activity_1:
      "● Lucky Town is committed to creating a comfortable gaming platform but also does not forget to create a first-class VIP platform that we have been pursuing in the industry.",
    vip_activity_2:
      "● With the continuous growth of players on the Lucky Town gaming platform, we will provide players with more attentive care and higher-quality activities. A new reward system for Lucky Town players has been launched. New and old players can also enjoy more event bonus offers;",
    vip_policy_1:
      "1.System will review the member conditions on the 1st of every month to distribute promotion rewards",
    vip_policy_2:
      "2.The platform will issue twice bonus a month based on eligible member levels\nNo need to apply,and system will automatically distribute\nDistribution time: 1st and 16th of every month, Time: 2pm to 3pm\nApply conditions: Apply bonus for the 16th of the month- Must be topup from the 1st to the 15th of the month\nAt least 3 times with a single transaction exceeds THB 5000. Apply bonus for the 1st of the month- Must be topup at least 3 times with a single transaction exceeds THB 5000 from the 16th to the 30th / 31st of the previous month.",
    vip_policy_3:
      "3.If players has participate in other promotions of LuckyTown,the effective amount required for active promotions will not included in the players promoted effective amount.",
    vip_policy_4: "4.This activity is shared with the daily rebate activity.",
    vip_policy_5:
      "5.After the player is promoted in the current month, you can enjoy the promoted bonus\n(Exp: Player XXX was promoted from  VIP1 to VIP2 at the beginning of October,\nAt the beginning of October, players XXX can enjoy VIP2 promoted bonus for THB 1880 ).",
    vip_policy_6:
      "6.Birthday bonus can be applied through customer service on the day of your birthday by providing the relevant information of the player account and the scan of the ID card.",
    vip_policy_7:
      "7.Customer service manager is at your service 24 hours a day.",
    vip_policy_8:
      "8.If find that players abuse our VIP terms and maliciously use abnormal means to obtain benefits, we reserve the right to take back VIP privileges.",
    vip_policy_9:
      "`9.Once the company's risk control department detects that the player is an arbitrage player, it will give ten times turn over for withdrawal , refund the principal as a punishment.`",
    vip_policy_10:
      "10.By participating in this activity, you agree to the Rules and Regulations, and LuckyTown reserves the right to revise, stop and final interpretation of the activity.",
    vip_accumulated_deposit: "`Deposit terkumpul:`",
    vip_require_turnover: "`Keperluan peralihan:`",
    change_language: "Tukar bahasa",
    fraud_prevention: "Pencegahan Penipuan",
    fraud_prevention_desc:
      "(Dalam Catatan) Sekiranya kata-kata berikut diisi, kami akan memeriksa dengan lebih ketat dan pengguna mungkin tidak dapat menambah nilai dengan berjaya.\nContoh: Jualan / Belian, Sewa / Pinjam, Stesen telekomunikasi, Tukar mata wang, Bekalan Perubatan, Bekalan Pakaian, Produk elektronik, Pengangkutan, Bahagian kereta, Bahagian motor, Jenama mewah / Terkenal, Tiket konsert / Kupon, Makanan / Makananan ringan / Buah-buahan / Minuman/  Buku dan lain-lain",
    got_it: "faham",
    type_a_message: "Taip mesej",
    vip_coupon: "Kupon VIP",
    egames_coupon: "Kupon Egames",
    reminder: "Peringatan",
    signup_username_info:
      "Nama pengguna hanya dibenarkan terdiri daripada 'huruf + nombor', dan panjangnya sekurang-kurangnya 8 aksara",
    signup_password_info:
      "Kata laluan mestilah sekurang-kurangnya 8 digit, dan ruang tidak disokong",
    signup_new_password_error_msg: "Kata laluan baru mestilah alfanumerik.",
    signup_password_confirm_passwors_error_msg:
      "Kata laluan dan sahkan kata laluan tidak sepadan ",
    bahasa_melayu_text: "Bahasa Melayu",
    eng_text: "English",
    thai_text: "เปลื่ยนภาษา",
    ch_text: "中文",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*Masa pemprosesan deposit selesai dalam masa 10 minit, harap bersabar, terima kasih!",
    qr_description_thb:
      "*Syorkan pemain baru untuk 'daftar akaun' dengan minimum ' Tambah Nilai 100THB' dan anda akan mendapat ' Bonus sebanyak 20THB'. \n\n*Berjaya mengesyorkan 'pemain baru', akaun anda akan dinaik taraf secara automatik kepada 'pemain super', dan anda boleh mendapat peratusan daripada jumlah pertaruhan berkesan 'pemain' yang anda mengesyorkan",
    total_amount: "Total Amount",
    transaaction_no: "Transaction No",
    share: "Share",
    timer: "Timer",
    gift: "Gift",
    schedule: "Schedule",
    qr_description_myr:
      "*Syorkan pemain baru untuk 'daftar akaun' dengan minimum ' Tambah Nilai 20THB' dan anda akan mendapat ' Bonus sebanyak 2MYR'. \n\n*Berjaya mengesyorkan 'pemain baru', akaun anda akan dinaik taraf secara automatik kepada 'pemain super', dan anda boleh mendapat peratusan daripada jumlah pertaruhan berkesan 'pemain' yang anda mengesyorkan",
    bonus_monthly: "Ganjaran kenaikan taraf",
    birthday_bonus: "Bonus hari jadi",
    withdraw_per_day: "Pengeluaran harian",
    exclusive_domain: "Domain eksklusif",
    deposit_priority: "Keutamaan deposit",
    festival_gift: "Hadiah cuti keistimewanan",
    exclusive_customer_service: "Perkhidmatan pelanggan eksklusif",
    free_travel: "Pelancongan Percuma",
    vip_myr_activity_1:
      "● Lucky Town komited untuk mewujudkan platform permainan yang selesa, tetapi juga tidak lupa untuk melabur banyak dalam mewujudkan tempat VIP kelas pertama industri - nikmati kemewahan, capai kehormatan anda dengan keikhlasan hati, dan cipta klasik kami dengan kredibiliti anda. Memuaskan keseronokan anda adalah usaha berterusan kami. Yang mulia adalah tetamu, yang mulia adalah yang dihormati.",
    vip_myr_activity_2:
      "● Dengan pertumbuhan berterusan aktiviti ahli di platform hiburan Lucky Town，demi menyediakan ahli dengan penjagaan yang lebih prihatin dan aktiviti yang lebih baik, sistem ganjaran baharu untuk pemain Lucky Town dilancarkan. Pemain baharu dan lama juga boleh menikmati lebih banyak tawaran bonus；",
    vip_myr_policy:
      "1. Syarat promosi: Sistem secara automatik menentukan bahawa hadiah promosi akan diedarkan serta-merta selepas naik taraf selesai. Had masa untuk menerima hadiah ialah 14 hari selepas pengagihan. Kegagalan menerimanya dalam had masa akan dianggap sebagai pemberian naik dan akan ditarik balik secara automatik oleh sistem. \n2. Syarat Penyingkiran: Sistem secara automatik terkumpul sama ada kelayakan penyingkiran dipenuhi. Masa terkumpul ialah hari pertama hari naik taraf, dan ia akan dikira kemudian. Contoh: Seorang ahli dinaik taraf kepada ahli emas pada 3 November, dan masa terkumpul dalam sistem adalah dari 3 September pada 12:00:01 PM hingga 3 Disember pada 11:59:59 AM, dalam tempoh tiga bulan ( satu musim) sama ada layak ke penyingkiran. \n3. Hadiah hari jadi: 3 hari sebelum dan selepas menerima hadiah hari jadi atau pada hari yang sama, anda perlu menyerahkan gambar kad pengenalan anda kepada perkhidmatan pelanggan untuk pengesahan. Dan nama kad pengenalan yang dikemukakan mesti sepadan dengan nama akaun bank akaun permainan sebelum ia boleh dituntut. Melebihi tarikh akhir untuk memohon wang hadiah hari jadi akan dianggap sebagai menyerah kalah. \n4. Hadiah hari raya tidak teratur, hadiah hari raya tidak tetap akan diberikan melalui pos atau wang hadiah. \n5. Untuk perjalanan percuma, anda perlu mengekalkan vip6 sekurang-kurangnya 4 suku (12 bulan) sebelum anda boleh mendapatkannya.Tarikh berlepas, hotel dan tiket penerbangan akan diuruskan oleh syarikat di atas tanggungjawab sendiri (ia tidak akan diberikan untuk menukar hotel atau menukar tarikh tiket penerbangan dan tarikh berlepas). \n6. Ganjaran acara atau tempoh kutipan wang hadiah di atas adalah dalam tempoh 14 hari selepas pengedaran. Kegagalan untuk mengumpul dalam had masa akan dianggap sebagai berputus asa dan akan ditarik balik secara automatik oleh sistem. \n7. Ganjaran Mingguan/Bulanan: (VIP2 / VIP3) Bulanan - Sekurang-kurangnya 10 deposit dilengkapkan, atau deposit terkumpul ialah RM1000 dan jumlah kod efektif adalah lebih daripada 5000, untuk mendapatkan ganjaran VIP bulanan.(VIP4 / VIP5 / VIP6 ) Sekurang-kurangnya 1 deposit seminggu, atau deposit terkumpul RM1000 dan jumlah kod sah 5000 atau lebih, boleh mendapat bonus VIP mingguan. \n\n《Syarat Acara》\n1.Promosi hanya untuk ahli hiburan. Jika didapati pengguna mempunyai lebih daripada satu akaun, termasuk nama yang sama, alamat e-mel yang sama, alamat IP yang sama/serupa, alamat yang sama, kad debit/kredit yang sama , akaun bank yang sama, komputer yang sama, dsb. Sebarang tingkah laku pertaruhan yang tidak normal, setelah ditemui, LUCKY TOWN akan berhak untuk membekukan keuntungan dan baki akaun anda. \n2. Sebarang pertaruhan, seri, pertaruhan lindung nilai lain (pertaruhan merentas tapak), pertaruhan yang ditolak, pertaruhan terbatal, seri atau peluang sukan di bawah 1.5 tidak akan dikira sebagai pertaruhan sah yang diperlukan untuk promosi. \n3. Sebarang pertaruhan yang dibuat melalui perisian haram pihak ketiga seperti 'robot' dan 'membuka tingkap berganda/berbilang' boleh dianggap sebagai pertaruhan haram, dan LUCKY TOWN berhak untuk membekukan baki akaun yang disyaki dan menutup akaun ahli . \n4. LUCKY TOWN mempunyai hak untuk menyemak semua rekod pertaruhan ahli. Jika ahli melanggar peraturan dan peraturan acara atau mempunyai sebarang tujuan bukan hiburan untuk menggunakan bonus untuk membuat keuntungan, LUCKY TOWN berhak untuk menghentikan, membatalkan atau tuntut semula pada bila-bila masa. Semua tawaran telah dibayar. \n5. LUCKY TOWN berhak untuk meminta ahli mengemukakan dokumen sokongan yang berkaitan untuk mengesahkan identiti mereka jika akaun berkenaan disyaki disalahgunakan dan/atau tidak layak untuk promosi ini. \n6. Jika mana-mana individu/pasukan/organisasi disyaki menggunakan kaedah tidak jujur ​​atau tindakan penipuan untuk tujuan menipu/menyalahgunakan bonus, setelah disahkan, LUCKY TOWN akan mempunyai hak untuk membekukan keuntungan dan baki akaun yang berkaitan. \n7. Dengan menyertai promosi ini, anda bersetuju menerima 'Semua Peraturan dan Syarat Promosi' \n8. LUCKY TOWN berhak untuk menyemak, menamatkan atau tafsiran akhir promosi ini, dan membuat perubahan pada promosi ini tanpa notis. \n9.Jika pertaruhan haram ditemui, deposit (termasuk jumlah keuntungan dan bonus) akan dibekukan, dan sistem akan mengosongkannya secara automatik kepada sifar.\n",
    weekly: "Mingguan",
    withdraw_duration_text:
      "*Masa pemprosesan deposit selesai dalam masa 30 minit, harap bersabar, terima kasih!",
    hot_game: "Permainan popular",
    new_games: "Permainan Baru",
    reset_app: "Kosongkan Cache App",
    reset_app_title: "Kosongkan Data Cache",
    reset_app_description:
      "Adakah awak pasti? Anda mahu memadamkan data app anda.",
    anoucement_intro_title: "Announcement",
    anoucement_intro_description:
      "Anda boleh mendapatkan pengumuman penting di sini.",
    game_list_intro_title: "Game List",
    game_list_intro_description:
      "Semua permainan disenaraikan di sini, anda boleh mengklik ikon permainan untuk memulakan permainan.",
    topup_intro_title: "TopUp/Withdraw",
    topup_intro_description: "Anda boleh topup/withdraw nilai anda.",
    leatherboard_intro_title: "Papan Pendahulu ",
    leatherboard_intro_description:
      "Pemain terbaik bulan ini akan disenaraikan di sini. Bermain dan menangi hadiahnya!",
    previous_step: "Sebelumnya",
    next_step: "Seterusnya",
    skip_step: "Langkau",
    finish_step: "Selesai",
    point_history: "Transaksi rekod",
    points: "Points",
    luckytown_points: "LK Points",
    you_have_earned: "Anda sudah terima",
    topup_info:
      "Sekiranya name sebenar dan name akaun pindahan bank yang dikemukakan untuk topup tidak konsisten,syarikat berhak menolak promohonan yang dikemukakan.",
    please_upload_reciept: "Sila muat nail gambar resit",
    pull_out_credit: "Pemulangan Cip Wang Wajib",
    pull_out_all_credit: "Tarik Keluar Semua Kredit",
    pull_out_credit_message:
      "Adakah anda pasti mahu Tarik Keluar semua Kredit?",
    topup_promotion_intro:
      "Pengingat penting: Untuk berpartisipasi dalam aktivitas prioritas apa pun, pengguna tidak akan dapat menggunakan transfer QR atau transfer ID hingga ketentuan transaksi diskon yang dipilih selesai, dan setelah penarikan melalui platform selesai, berlaku untuk layanan pelanggan dan lulus cek untuk mengaktifkan fungsi transfer QR.",
    statment: "Statement",
    withdraw_usdt: "Pengeluaran nilai USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n\n• The minimum withdrawal amount is: 1USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    withdraw_amount: "Withdraw Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",
    game_detail: "Butiran Permainan",
    google_auth: "Google Authentication",
    redeem: "Pertukaran",
    enter_verification_code: "Masukkan kod pengesahan 6 digit",
    activate_google_auth: "Google Authenticator Diaktifkan",
    inactivate_google_auth: "Aktifkan Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Adakah anda pasti mahu Tetapkan Semula Google Authenticator?",
    activate_google_auth_msg:
      "Adakah anda pasti mahu Aktifkan Google Authenticator?",
    register_google_auth_verification_msg:
      "Sediakan akaun dengan Google Authenticator",
    scan_google_auth_msg:
      "Imbas Kod QR ini dengan Aplikasi Google Authenticator anda. Sebagai alternatif, anda boleh menggunakan kod ini untuk menetapkan semula ",
    secret_key: "Kunci Rahsia:",
    pin: "PIN",
    change_app_icon: "Tukar Ikon Aplikasi",
    change_app_icon_message: "Adakah anda pasti mahu menukar ikon aplikasi?",
    change_app_icon_success_message: "Berjaya Berubah Ikon Aplikasi",
    real_name_verification: "Pengesahan Nama Sebenar",
    enter_real_name: "Masukkan Nama Sebenar",
    real_name_notes:
      "Nota:\n\n1. Tambahkan akaun bank dengan nama sebenar anda. \n2. Pilih akaun bank.\n3. Isikan nama sebenar anda. \n4. Serahkan Permintaan Pengesahan. \n5. Permintaan anda akan dikemas kini dalam masa 3 hari bekerja.",
    please_login_first: "Sila Log Masuk dahulu",
    otp_prefix: "Awalan OTP",
    notification_detail: "Butiran Pemberitahuan",
    bonus_chips: "Bonus Chip",
    bonus: "Bonus",
    cash_wallet: "Dompet Tunai",
    total: "Jumlah",
    promotion_intro_description: "Semak promosi terkini kami di sini.",
    looked_amount: "Jumlah terkunci",
    current_tunrover_stake: "Kepentingan semasa/perolehan diperlukan",
    turnover_stake_remarks: "Kemas kini Auto Perolehan dalam 10 Minit",
    otp_verification_text:
      " Sila semak SMS telefon dan masukkan OTP untuk pengesahan dan mengikat telefon anda untuk melindungi keselamatan akaun anda",
    select_deposit_method: "Pilih Kaedah Deposit ",
    user_agreement: "Perjanjian Pengguna",
    no_record_found: "No Record Found",
    info: "Info",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "Arahan Pengguna",
  },
  th: {
    app_name: "ลัคกี้ทาวน์",
    login_text: "เข้าสู่ระบบ",
    signUp_text: "ลงชื่อ",
    welcom_text: "ยินดีต้อนรับสู่แอปเมืองลัคกี้",
    username_text: "ชื่อผู้ใช้",
    password_text: "รหัสผ่าน",
    forgotPassword_text: "ลืมรหัสผ่าน",
    otp_text: "OTP",
    invalid_username_or_password: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
    invalid_password: "รหัสผ่านไม่ถูกต้อง",
    invalid_data_input: "ใส่ข้อมูลไม่ถูกต้อง",
    invalid_phone_number: "หมายเลขโทรศัพท์ไม่ถูกต้อง",
    invalid_transaction_pin: "พินธุรกรรมไม่ถูกต้อง",
    history_text: "ประวัติศาสตร์",
    from_date: "จากวันที่",
    to_date: "ถึงวันที่",
    to: "ถึง",
    go: "ไป",
    select: "เลือก",
    new_account: "บัญชีใหม่",
    new_password: "รหัสผ่านใหม่",
    recommended_user: "ผู้ใช้ผู้แนะนำ: ",
    phone_number: "หมายเลขโทรศัพท์",
    confirm_password: "ยืนยันรหัสผ่าน",
    username_or_phone_number_is_registered:
      "ลงทะเบียนชื่อผู้ใช้หรือหมายเลขโทรศัพท์",
    recover_password: "กู้คืนรหัสผ่าน",
    recover_username: "กู้คืนชื่อผู้ใช้",
    please_enter_phone_number:
      "โปรดป้อนหมายเลขโทรศัพท์ที่ลงทะเบียนเพื่อกู้คืนรหัสผ่านของคุณ",
    please_enter_phone_number_to_recover_username:
      "โปรดป้อนหมายเลขโทรศัพท์ที่ลงทะเบียนเพื่อกู้คืนชื่อผู้ใช้ของคุณ",
    please_enter_txid: "โปรดป้อน txid",
    next: "ต่อไป",
    otp_code_resended: "ส่งรหัส OTP อีกครั้ง",
    invalid_otp_code: "รหัส OTP ไม่ถูกต้อง",
    request_otp: "ขอรหัส OTP",
    please_enter_otp: "โปรดป้อน OTP ที่ส่งไปยังข้อมูลรับรองที่คุณเลือก",
    proceed: "ดำเนินการ",
    resend_code: "ส่งรหัสอีกครั้ง",
    change_login_password: "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
    select_one_of_the_cre:
      "เลือกหนึ่งในข้อมูลประจำตัวที่เราควรใช้สำหรับกู้คืนรหัสผ่านของคุณ",
    password_changed: "เปลี่ยนรหัสผ่านแล้ว",
    congratulations_changed_password: "ยินดีด้วย! คุณเปลี่ยนรหัสผ่านสำเร็จแล้ว",
    login_now: "ลงชื่อเข้าใช้ตอนนี้",
    discover: "ในตอนนี้",
    amount_RM: "จำนวน",
    start: "เริ่ม",
    contacts: "ติดต่อเรา",
    new_friend: "เพื่อนใหม่",
    wallet: "กระเป๋าสตางค์",
    cash: "เงินสด",
    bank_account: "บัญชีธนาคาร",
    setting: "การตั้งค่า",
    withdraw_succ: "ถอนสำเร็จ",
    top_up_succ: "เติมเงินสำเร็จ",
    coin: "เหรียญ",
    interest: "เหรียญนำโชค",
    wallet_balance: "ยอดเงินสด",
    top_up: "เติม",
    withdraw: "ถอนเงิน",
    transaction: "ธุรกรรม",
    instant_top_up: "เติมเงินทันที",
    top_up_bank_transfer: "โอนเงินผ่านธนาคาร",
    error_please_try_again: "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
    top_up_RM: "เติม",
    upload_receipt: "อัพโหลดใบเสร็จรับเงิน",
    choose_upload_photo_method: "เลือกวิธีการอัปโหลดรูปภาพ",
    take_picture: "ถ่ายภาพ",
    select_from_gallery: "เลือกจากคลังภาพ",
    take_photo: "ถ่ายภาพ",
    retake: "ถ่ายใหม่",
    use_photo: "ใช้รูปภาพ",
    upload_bank_receipt: "อัพโหลดใบเสร็จธนาคาร",
    confirm_to_upload_this_photo: "ยืนยันอัปโหลดรูปภาพนี้หรือไม่",
    cancel: "ยกเลิก",
    confirm: "ยืนยัน",
    wallet_balance_not_enough: "เงินสดคงเหลือไม่พอถอน",
    withdraw_RM: "ถอน",
    no_transaction_for_dates: "ไม่มีธุรกรรมสำหรับวันที่เลือก",
    no_more_transaction_for_dates: "ไม่มีธุรกรรมเพิ่มเติมสำหรับวันที่เลือก",
    please_enter_date: "กรุณาระบุวันที่",
    all_transaction: "ธุรกรรมทั้งหมด",
    top_up_history: "ประวัติการเติมเงิน",
    interest_account_removed: "บัญชี LuckyCoin ถูกลบ!",
    interest_account_created_succ: "บัญชี LuckyCoin สร้างสำเร็จแล้ว",
    you_have_no_interest_account: "คุณไม่มีบัญชี LuckyCoin ที่ใช้งานอยู่",
    interest_history: "ประวัติเหรียญนำโชค",
    days: "วัน",
    hours: "ชั่วโมง",
    create_interest: "สร้าง LuckyCoin",
    deposit_RM: "เงินฝาก",
    balance_RM: "สมดุล         :",
    remove: "ลบ",
    partial_withdraw: "ถอนบางส่วน",
    interest_withdraw: "ถอนดอกเบี้ย",
    add_back_account_succ: "เพิ่มบัญชีธนาคารเรียบร้อยแล้ว",
    edit_bank_account: "แก้ไขบัญชีธนาคาร",
    bank: "ธนาคาร",
    account_name: "ชื่อบัญชี",
    account_no: "เลขที่บัญชี",
    add_bank_account: "เพิ่มบัญชีธนาคาร",
    sign_out: "ออกจากระบบ",
    language: "ภาษา",
    clear_cache: "ล้างแคช",
    about: "เกี่ยวกับ",
    old_password_not_match: "รหัสผ่านเก่าไม่ตรงกัน",
    old_password: "รหัสผ่านเก่า",
    back: "กลับ",
    version: "เวอร์ชั่น",
    change_payment_pin: "เปลี่ยนพินการชำระเงิน",
    change_nickname: "เปลี่ยนชื่อเล่น",
    transfer: "โอนย้าย",
    create_pin: "สร้างพินธุรกรรม",
    change_pin: "เปลี่ยนพินธุรกรรม",
    creat_pin_description: "สร้างพิน 6 หลักสำหรับการทำธุรกรรมของคุณในแอพ",
    please_enter_pin_again: "กรุณาใส่รหัส PIN 6 หลักอีกครั้ง",
    pin_dont_match: "พินไม่ตรงกัน",
    old_pin: "พินเก่า",
    new_pin: "พินใหม่",
    confirm_new_pin: "ยืนยันพิน",
    pin_max_six: "พินธุรกรรม 6 หลัก",
    succ_pin_change: "เปลี่ยนพินการเปลี่ยนแปลง",
    congratulations_changed_pin:
      "ยินดีด้วย! คุณเปลี่ยน PIN ธุรกรรมของคุณสำเร็จแล้ว",
    please_enter_pin: "โปรดป้อน PIN ธุรกรรม",
    forgot_pin: "ลืมพินธุรกรรม",
    recover_transaction_pin: "กู้คืนพินธุรกรรม",
    please_enter_phone_number_pin:
      "โปรดป้อนหมายเลขโทรศัพท์ที่ลงทะเบียนเพื่อกู้คืนรหัสธุรกรรมของคุณ",
    old_pin_not_match: "พินเก่าไม่ตรงกัน",
    new_pin_not_match: "พินใหม่ไม่ตรงกัน",
    transfer_RM: "โอนย้าย",
    transfer_succ: "โอนเรียบร้อย",
    transfer_to: "โอนไปที่: ",
    wallet_insuffecient_amount: "เงินสดคงเหลือไม่พอโอน",
    change_your_nickname: "แก้ไขหรือเปลี่ยนชื่อเล่นของคุณ",
    nickname: "ชื่อเล่น",
    fullname: "ชื่อเต็ม",
    nickname_change_succ: "เปลี่ยนชื่อเล่นสำเร็จ",
    cancellation: "การยกเลิก",
    confirm_to_remove_and_withdraw: "ยืนยันการลบและถอนออก",
    confirm_go_back: "ยืนยันว่าจะกลับ?",
    in_game: "ในเกมส์",
    close_game_first: "กรุณาออกจากเกมอื่นก่อน!",
    close_game: "ปิดเกม",
    game_closed: "เกมปิดแล้ว",
    game: "เกม",
    information: "ข้อมูล",
    search: "ค้นหา",
    no_user_found: "ไม่พบชื่อผู้ใช้",
    i_have_read_and_agree: "ฉันได้อ่านและตกลง",
    LID: "LID",
    referral: "ผู้อ้างอิง",
    available_transfer_balance_RM: "พร้อมโอน",
    i_am_agreed_to_term: "ฉันเห็นด้วยคำว่า",
    coin_transaction: "ธุรกรรมเหรียญ",
    status: "สถานะ",
    succ_submission_pending_review: "ส่งเรียบร้อยแล้วรอตรวจสอบ",
    leaderboard: "ลีดเดอร์บอร์ด",
    time_zone: "เขตเวลา",
    customer_service: "บริการลูกค้า",
    qr_transfer: "QR โอน",
    top_up_details: "รายละเอียดการเติมเงิน",
    top_up_type: "ประเภทเติมเงิน",
    date: "วันที่",
    receipt: "ใบเสร็จ",
    available_transfer: "พร้อมโอน",
    available_coin: "เหรียญที่มีจำหน่าย",
    commission: "คณะกรรมการ",
    today_stake: "เดิมพันวันนี้",
    yesterday_stake: "เดิมพันเมื่อวาน",
    wallet_transaction: "ธุรกรรมกระเป๋าเงิน",
    game_transaction: "ธุรกรรมของเกม",
    type: "พิมพ์",
    all: "ทั้งหมด",
    refund: "คืนเงิน",
    penalty: "การลงโทษ",
    pick_date: "เลือกวันที่",
    time: "เวลา",
    win: "ชนะ/แพ้",
    win_: "ชนะ",
    bet: "เดิมพัน",
    bet_or_transfer: "เดิมพัน/โอน",
    save_in_album: "บันทึกในอัลบั้ม",
    qr_code_saved: "บันทึกรหัส QR แล้ว",
    save_error: "บันทึกข้อผิดพลาด",
    change_avatar: "เปลี่ยนอวาตาร์",
    avatar_changed: "อวาตาร์เปลี่ยนแล้ว",
    cant_start_game: "เริ่มเกมไม่ได้",
    details: "รายละเอียด",
    product: "ผลิตภัณฑ์",
    total_bet: "เดิมพันทั้งหมด",
    total: "ทั้งหมด",
    reward: "รางวัล",
    photo_library: "ห้องสมุดรูปภาพ",
    qr_code_error: "รหัส QR ผิดพลาด",
    maintenance: "การซ่อมบำรุง",
    coming_soon: "เร็วๆ นี้",
    top_up_disclaimer:
      "** กรุณาปฏิบัติตามระเบียบที่บริษัทกำหนด มิฉะนั้น คะแนนที่ได้รับจะล่าช้า เราหวังว่าคุณจะมีความสุขในเกมขอบคุณ",
    minimum_top_up: "ขั้นต่ำ: ",
    maximum_top_up: "ขีดสุด: ",
    top_up_left_times: "เวลาที่เหลืออยู่:",
    top_up_unlimited: "(ไม่ จำกัด)",
    order_history: "ประวัติการสั่งซื้อ",
    withdraw_history: "ประวัติการถอน",
    no_bank_account_added: "กรุณาผูกบัญชีธนาคารอย่างน้อยหนึ่งบัญชี",
    minimum_withdraw: "ขั้นตำ่: ",
    maximum_withdraw: "สูงสุด: ",
    free_withdraw_time: "เวลาว่าง: ",
    withdraw_balance: "ยอดคงเหลือ: ",
    unlimited: "ไม่ จำกัด",
    withdraw_details: "รายละเอียดการถอน",
    updated_date: "อัพเดทวันที่",
    pending: "รอดำเนินการ",
    success: "ความสำเร็จ",
    in_inspection: "อยู่ในการตรวจสอบ",
    hold: "พักไว้",
    confirm_to_remove_withdraw: "ยืนยันการลบ ถอน?",
    confrim_to_remove_top_up: "ยืนยันการลบการเติมเงิน?",
    rejected: "ถูกปฏิเสธ",
    copied: "คัดลอกไปยังคลิปบอร์ดแล้ว",
    anouncement: "ประกาศ",
    contactUs: "ติดต่อเรา",
    newVersionTitle: "มีเวอร์ชันใหม่แล้ว",
    versionDescription:
      "หากต้องการดำเนินการต่อ โปรดอัปเดตแอปของคุณเป็นเวอร์ชันล่าสุด",
    verification: "การยืนยัน",
    register_device_text:
      "อุปกรณ์นี้ไม่ได้ผูกกับบัญชีของคุณ โปรดลงทะเบียนอุปกรณ์เพื่อดำเนินการต่อ",
    device_name: "ชื่ออุปกรณ์",
    device_info: "ข้อมูลอุปกรณ์",
    friend: "เพื่อน",
    about_phone: "เกี่ยวกับโทรศัพท์",
    remarks: "หมายเหตุ",
    balance_transfer: "โอนยอดคงเหลือเรียบร้อยแล้ว",
    usdt_top_up: "เติมเงิน USDT",
    app_close: "ปิด I",
    topupRemarks:
      "โปรดระบุ LT- (ชื่อผู้ใช้ของคุณ) ในใบโอนเงิน \nE.g. \nID: ลัคกี้ทาวน์ \nอ้างอิง: LTluckytown",
    top_up_policy:
      "บริษัทของเราจะเปลี่ยนแปลงบัญชีธนาคารเป็นระยะ โปรดยืนยันบัญชีล่วงหน้าที่ธนาคารของคุณ/ ก่อนโอนเงิน บริษัทจะไม่รับผิดชอบต่อความสูญเสียใดๆ ที่เกิดจากความผิดพลาดของคุณ",
    notification: "การแจ้งเตือน",
    empty_notifications: "ไม่มีการแจ้งเตือนใหม่",
    promotion: "โปรโมชั่น",
    use_now: "ใช้ทันที",
    promo_code: "รหัสโปรโมชั่น",
    enter_otp: "กรุณากรอก OTP",
    change_phone_no: "เปลี่ยนหมายเลขโทรศัพท์",
    change_your_phone: "แก้ไขหรือเปลี่ยนหมายเลขโทรศัพท์ของคุณ",
    congratulations_changed_phone:
      "ยินดีด้วย! คุณเปลี่ยนหมายเลขโทรศัพท์ของคุณสำเร็จแล้ว",
    default_avatar: "อวาตาร์เริ่มต้น",
    forgotUsername_text: "ลืมชื่อผู้ใช้",
    authenticate: "การตรวจสอบสิทธิ์",
    forgot_id_password: "ลืม UID / รหัสผ่าน",
    manage_account: "เปลี่ยนบัญชี",
    add_another_account: "เพิ่มบัญชีอื่น",
    add_account: "เพิ่มบัญชี",
    cashout: "เงินออก",
    please_signin_to_continue: "กรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ",
    no_account_found: "ไม่พบบัญชี",
    reward: "รางวัล",
    please_enter_amount: "กรุณาระบุจำนวนเงิน.",
    topUpUSDTReceipt: "เติมเงิน USDT ใบเสร็จ",
    amount_usdt: "จำนวนเงิน (USDT)",
    txid: "TXID",
    enter_txid: "ป้อน TXID",
    platform: "แพลตฟอร์ม",
    select_platrform: "เลือกแพลตฟอร์ม",
    request_topup_success: "ขอเติมเงินสำเร็จ",
    chip: "ชิป",
    confrim_to_remove_back_account: "กรุณายืนยันการลบบัญชีธนาคาร",
    max: "แม็กซ์",
    footer_home: "บ้าน",
    footer_contact: "ติดต่อ",
    footer_transaction: "ธุรกรรม",
    footer_me: "ผม",
    profile_cash: "เงินสด",
    profile_chip: "ชิป",
    profile_luck: "เหรียญนำโชค",
    profile_vip: "VIP",
    bank_search_bank: "ค้นหาธนาคาร",
    avatar_back: "กลับ",
    friend_search_friend: "ค้นหาเพื่อน",
    friend_delete: "ลบ",
    friend_title: "เพิ่มเพื่อน",
    friend_popup: "ใส่ชื่อเพื่อน",
    game_details_download: "ดาวน์โหลด",
    game_details_launch: "ปล่อย",
    game_details_transfer: "โอนย้าย",
    qr_copy_link: "คัดลอกลิงค์",
    qr_qr_share: "แบ่งปัน QR",
    profile_lucky_coin: "เหรียญนำโชค",
    currency_exchange: "แลกเปลี่ยนเงินตรา",
    currency_exchange_successfully: "แลกเปลี่ยนเงินตราได้สำเร็จ",
    please_select_other_currency: "กรุณาเลือกสกุลเงินอื่นเพื่อแลกเปลี่ยน",
    receipt_get: "ผู้รับ รับ",
    send_currency_exactly: "คุณส่งตรง",
    exchange_rate: "อัตราแลกเปลี่ยน",
    helpDesk: "ติดต่อ",
    topup_withdraw: "ฝาก/ถอน",
    more: "มากกว่า",
    order: "คำสั่ง",
    add_friend: "เพิ่มเพื่อน",
    search_friend: "ค้นหาเพื่อน",
    friend_added_successfully: "เพิ่มเพื่อนสำเร็จแล้ว",
    please_enter_friend_name: "กรุณาใส่ชื่อเพื่อน",
    message: "ข้อความ",
    home: "บ้าน",
    contact: "ติดต่อ",
    qr_topup: "สแกนQRชำระเงิน",
    qr_topup_reciept: "เติมเงิน QR",
    transaction_process: "การทำธุรกรรมของคุณอยู่ในระหว่างดำเนินการ",
    please_allow_camera_permission: "ขออนุญาติเปิดกล้อง.",
    enter_game: "เข้าเกม",
    exit_game: "ออกจากเกม",
    edit_nickname: "แก้ไขชื่อเล่น",
    model: "แบบอย่าง",
    device_id: "รหัสอุปกรณ์",
    unique_id: "ID ไม่ซ้ำกัน",
    lt_coin: "เหรียญนำโชค",
    stage: "เวที",
    update_now: "อัพเดทเดี๋ยวนี้",
    withdraw_policy:
      "เรียนลูกค้าทุกท่าน เพื่อป้องกันการฉ้อโกงเงินของคุณลูกค้า ลูกค้าต้องตรวจสอบให้แน่ใจว่าชื่อบัญชีเงินฝากเป็นชื่อเดียวกับบัญชีเงินฝากของคุณเมื่อทำการถอนเงิน นโยบายนี้มีไว้เพื่อปกป้องความปลอดภัยเงินของลูกค้า ทางเราต้องขออภัยในความไม่สะดวกด้วยนะคะ ขอบคุณค่ะ",
    please_enter_username: "กรุณากรอกชื่อผู้ใช้.",
    promotion_reward: "รางวัลโปรโมชั่น",
    birthday_gift: "ของขวัญวันเกิด",
    daily_withdraw: "ถอนได้ทุกวัน",
    monthly_Salary: "เงินเดือนสองเท่า",
    edit_bank_account_succ: "Edit bank account successfully",
    cancel_request: "Cancel Request",
    redeem_coupon: "แลกคูปอง",
    coupon_list: "Coupon List",
    code_redeem_success: "Code Redeem Successful",
    limitPerDay: "ถอนสูงสุดต่อวัน: ",
    approved: "ที่ได้รับการอนุมัติ",
    processing: "กำลังประมวลผล",
    got_it: "สำเร็จ",
    amount_greater_then_available_balance:
      "ขออภัย จำนวนเงินของคุณไม่เพียงพอสำหรับการเติมเงิน",
    details: "รายละเอียด",
    rate: "เรทสกุลเงิน",
    select_bank: "เลือกธนาคาร",
    address: "ที่อยู่",
    date_time: "วันเวลา",
    select_country_code: "เลือกรหัสประเทศ",
    pick_bank: "เลือกธนาคาร",
    balance: "ยอดคงเหลือ",
    luckytownviplabel: "ลัคกี้ทาวน์  VIP",
    vip_activity_label: "กิจกรรม:",
    vip_member_bonus: "สิทธิพิเศษสมาชิกวีไอพี ",
    vip_promoted_conditions: "เงื่อนไขโปรโมชั่น",
    vip_toa: "กฎและข้อกำหนดของวีไอพี",
    promoted_bonus: "รางวัลโปรโมชั่น",
    birthday_bonus: "ของขวัญวันเกิด",
    withdraw_limit: "ถอนได้ทุกวัน",
    monthly_bonus: "รับเงินเดือนสองเท่า",
    vip_activity_1:
      "`●ในขณะที่มุ่งมั่นจะสร้างแพลตฟอร์มเกมส์ที่สะดวกสบาย เรายังมีสิทธิพิเศษ สำหรับลูกค้า VIP เพื่อได้เพลิดเพลินไปกับความหรูหรา บรรลุเป้าหมายของคุณด้วยหัวใจ เพื่อสร้างคลาสสิกของเราด้วยชื่อเสียง และเพื่อความเพลิดเพลินของท่านซึ่งเป็นการแสวงหาของเราอย่างต่อเนื่อง เพราะลูกค้าทุกท่านคือเเขกผู้มีเกียรติของทางเรา`",
    vip_activity_2:
      "`●ด้วยการเติบโตอย่างต่อเนื่องของกิจกรรมของสมาชิกบนแพลตฟอร์มความบันเทิง (LuckyTown) เราจะให้บริการสมาชิกด้วยความเอาใจใส่และกิจกรรมคุณภาพสูงขึ้น ระบบรางวัลใหม่สำหรับผู้เล่น Lucky Town ได้เปิดตัวแล้ว ผู้เล่นใหม่และผู้เล่นเก่าสามารถเพลิดเพลินกับข้อเสนอโบนัสกิจกรรมต่างๆได้เลย`",
    vip_policy_1:
      "1. เงื่อนไขโปรโมชั่น: ระบบจะกำหนดโดยอัตโนมัติว่าโบนัสโปรโมชั่นจะถูกส่งทันทีหลังจากการอัพเกรดเสร็จสิ้น ระยะเวลาในการรับของขวัญคือ 14 วันหลังจากแจกจ่าย การไม่ได้รับภายในระยะเวลาจะถือเป็นการให้ ขึ้นและจะถูกถอนออกจากระบบโดยอัตโนมัติ",
    vip_policy_2:
      "2. เงื่อนไขการตกชั้น: ระบบจะสะสมโดยอัตโนมัติว่ามีคุณสมบัติตรงตามการตกชั้นหรือไม่ เวลาสะสมคือวันแรกของวันอัปเกรด และจะคำนวณในภายหลัง \nตัวอย่าง: สมาชิกได้รับการอัพเกรดเป็นสมาชิกระดับโกลด์ในวันที่ 3 พฤศจิกายน และเวลาสะสมในระบบคือวันที่ 3 กันยายน เวลา 12:00:01 น. ถึง 3 ธันวาคม เวลา 11:59:59 น. ในช่วงเวลาสามเดือน ( หนึ่งฤดูกาล) ไม่ว่าจะผ่านเข้ารอบในการตกชั้นหรือไม่",
    vip_policy_3:
      "3. ของขวัญวันเกิด: 3 วันก่อนและหลังได้รับของขวัญวันเกิดหรือในวันเดียวกัน คุณต้องส่งรูปถ่ายบัตรประจำตัวของคุณไปที่ฝ่ายบริการลูกค้าเพื่อยืนยัน และชื่อบัตรประจำตัวที่แสดงจะต้องตรงกับชื่อบัญชีธนาคารของบัญชีเกมก่อนจึงจะอ้างสิทธิ์ได้ ทั้งนี้ เกินกำหนดเวลาในการสมัครรับเงินของขวัญวันเกิดถือเป็นการสละสิทธิ์",
    vip_policy_4:
      "4. ของขวัญวันหยุดที่ผิดปกติ ของขวัญวันหยุดที่ผิดปกติ จะได้รับทางไปรษณีย์หรือเงินของขวัญ。",
    vip_policy_5:
      "5. ทัวร์ฟรี คุณต้องรักษา vip6,ต้องบำรุงรักษาอย่างน้อย 4 ไตรมาส (12 เดือน) ก่อนจึงจะได้รับมัน บริษัทจะจัดการวันออกเดินทาง โรงแรม และตั๋วเครื่องบินโดยรับผิดชอบแต่เพียงผู้เดียว (ไม่อนุญาตให้เปลี่ยนโรงแรมหรือเปลี่ยนแปลงวันเดินทางและวันเดินทาง)",
    vip_policy_6:
      "6. ระยะเวลารับรางวัลกิจกรรมหรือเงินของขวัญข้างต้นคือภายใน 14 วันหลังจากแจกจ่าย หากไม่ได้รับภายในเวลาที่กำหนดจะถือว่าสละสิทธิ์และจะถูกถอนออกโดยอัตโนมัติโดยระบบ",
    vip_policy_7:
      "7. รางวัลรายสัปดาห์/รายเดือน: (VIP2 / VIP3) รายเดือน - มีการฝากอย่างน้อย 10 ครั้ง หรือยอดฝากสะสมคือ 8,000 บาท และจำนวนรหัสที่มีผลมากกว่า 40,000 เพื่อรับรางวัล VIP รายเดือน (VIP4 / VIP5 / VIP6 ) เงินฝากอย่างน้อย 1 ครั้งต่อสัปดาห์หรือเงินฝากสะสม 8,000 บาท ละจำนวนรหัสที่ถูกต้อง 40,000 ขึ้นไปสามารถรับโบนัสวีไอพีรายสัปดาห์",
    vip_policy_8:
      "《เงื่อนไขการจัดงาน'》 \n1. โปรโมชั่นนี้สำหรับสมาชิกเพื่อความบันเทิงเท่านั้น หากพบว่าผู้ใช้มีบัญชีมากกว่าหนึ่งบัญชี ได้แก่ ชื่อเดียวกัน, ที่อยู่อีเมลเดียวกัน, ที่อยู่ IP เดียวกัน/คล้ายกัน, ที่อยู่เดียวกัน, บัตรเดบิต/บัตรเครดิตเดียวกัน บัญชีธนาคารเดียวกัน ฯลฯ พฤติกรรมการเดิมพันที่ผิดปกติใดๆ เมื่อพบ LUCKY TOWN จะสงวนสิทธิ์ในการระงับกำไรและยอดคงเหลือในบัญชีของคุณ \n\n2. การเดิมพัน เสมอ เดิมพันป้องกันความเสี่ยงอื่น ๆ (การเดิมพันข้ามไซต์) เดิมพันที่ถูกปฏิเสธ เดิมพันเป็นโมฆะ เสมอ หรืออัตราต่อรองกีฬาที่ต่ำกว่า 1.5 จะไม่ถูกนับเป็นการเดิมพันที่ถูกต้องที่จำเป็นสำหรับโปรโมชั่น \n\n3. การเดิมพันใดๆ ที่ทำผ่านซอฟต์แวร์ที่ผิดกฎหมายของบุคคลที่สาม เช่น การแฮก และ เปิดหลายๆยูส ถือเป็นการเดิมพันที่ผิดกฎหมาย และลัคกี้ทาวน์ขอสงวนสิทธิ์ในการระงับยอดเงินคงเหลือของบัญชีต้องสงสัยและปิดบัญชีสมาชิกทันที. \n\n4. LUCKY TOWN มีสิทธิ์ตรวจสอบบันทึกการเดิมพันของสมาชิกทุกคน หากสมาชิกฝ่าฝืนระเบียบและกฎของการแข่งขันหรือมีวัตถุประสงค์ที่ไม่ใช่เพื่อความบันเทิงในการใช้โบนัสเพื่อทำกำไร LUCKY TOWN ขอสงวนสิทธิ์ในการหยุด ยกเลิก หรือ เรียกร้องคืนเมื่อใดก็ได้ \n\n5. LUCKY TOWN ขอสงวนสิทธิ์ในการกำหนดให้สมาชิกส่งข้อมูลเพื่อยืนยันตัวตน หากบัญชีถูกบล็อกจะไม่มีสิทธิ์ได้รับโปรโมชั่นนี้ \n\n6. หากบุคคล/ทีม/องค์กรใดใช้วิธีการที่ไม่ซื่อสัตย์หรือการกระทำที่เป็นการฉ้อโกงเพื่อจุดประสงค์ในการฉ้อโกง/ใช้โบนัสในทางที่ผิด เมื่อตรวจสอบแล้ว LUCKY TOWN จะมีสิทธิ์ระงับผลกำไรและยอดคงเหลือในบัญชีที่เกี่ยวข้อง \n\n7. ในการเข้าร่วมโปรโมชั่นนี้ ต้องยืนยันว่าคุณยอมรับ 'กฎและข้อกำหนดทั้งหมดของการส่งเสริมการขาย' \n\n8. ลัคกี้ทาวน์ขอสงวนสิทธิ์ในการแก้ไข ยุติ หรือการตีความขั้นสุดท้ายของโปรโมชั่นนี้ และทำการเปลี่ยนแปลงโปรโมชั่นนี้โดยไม่ต้องแจ้งให้ทราบ \n\n9. หากพบการเดิมพันที่ผิดกฎหมาย เงินฝาก (รวมถึงจำนวนกำไรและโบนัส) จะถูกระงับ และระบบจะปรับให้เป็นศูนย์โดยอัตโนมัติ",
    vip_policy_9: "``",
    vip_policy_10: "``",
    vip_accumulated_deposit: "`เงินฝากสะสม:`",
    vip_require_turnover: "`ยอดเสียสะสม:`",
    change_language: "เปลี่ยนภาษา",
    fraud_prevention: "การป้องกันการฉ้อโกง",
    fraud_prevention_desc:
      "หากกรอกคำต่อไปนี้เป็นหมายเหตการโอนเงินผ่านธนาคาร/อ้างอิงด้านล่างเราจะตรวจสอบอย่างเข้มงวดและอาจไม่สามารถดำเนินการเติมเงินได้ \nเกี่ยวกับ:การขาย/การซื้อ/เช่า/เงินกู้/สถานีโทรคมนาคม/แลกเปลี่ยนเงินตรา/เวชภัณฑ์/จัดหาเสื้อผ้า/ผลิตภัณฑ์อิเล็กทรอนิกส์/การขนส่ง/ชิ้นส่วนรถยนต์/ชิ้นส่วนมอเตอร์/แบรนด์หรู/มีชื่อเสียง/ตั๋วคอนเสิร์ต/คูปอง/อาหาร/ขนม/ผลไม้/หนังสือ/และคนอื่นๆ",
    got_it: "เข้าใจแล้ว",
    type_a_message: "พิมพ์ข้อความ",
    vip_coupon: "คูปองวีไอพี",
    egames_coupon: "คูปอง Egames",
    reminder: "เคล็ดลับดีๆ",
    signup_username_info:
      "1. เลขที่บัญชีต้องประกอบด้วย 'ตัวอักษร + ตัวเลข' เท่านั้น และมีความยาวอย่างน้อย 8 ตัว",
    signup_password_info:
      "2. รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัว และห้ามเว้นวรรค",
    signup_new_password_error_msg: "รหัสผ่านใหม่ควรเป็นตัวอักษรและตัวเลข.",
    signup_password_confirm_passwors_error_msg:
      "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน",
    thai_text: "เปลื่ยนภาษา",
    bahasa_melayu_text: "Bahasa Melayu",
    eng_text: "English",
    ch_text: "中文",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*Masa pemprosesan deposit selesai dalam masa 10 minit, harap bersabar, terima kasih!",
    qr_description_thb:
      "*แนะนำผู้เล่นใหม่ให้ 'ลงทะเบียนบัญชี' พร้อมฝากขั้นต่ำ  100 บาท คุณจะได้รับ 'ค่าแนะนำทันที 20 บาท'. \n\n*แนะนำ 'ผู้เล่นใหม่' ได้สำเร็จ บัญชีของคุณจะได้รับการอัปเกรดเป็น 'ผู้เล่นระดับสูง' โดยอัตโนมัติ และคุณสามารถรับเปอร์เซ็นต์ยอดเสียของ 'ผู้เล่น' ที่คุณแนะนำได้",
    total_amount: "Total Amount",
    transaaction_no: "Transaction No",
    share: "Share",
    timer: "Timer",
    gift: "Gift",
    schedule: "Schedule",
    qr_description_myr:
      "*แนะนำผู้เล่นใหม่ให้ 'ลงทะเบียนบัญชี' พร้อมฝากขั้นต่ำ  20 MYR คุณจะได้รับ 'ค่าแนะนำทันที 2MYR'. \n\n*แนะนำ 'ผู้เล่นใหม่' ได้สำเร็จ บัญชีของคุณจะได้รับการอัปเกรดเป็น 'ผู้เล่นระดับสูง' โดยอัตโนมัติ และคุณสามารถรับเปอร์เซ็นต์ยอดเสียของ 'ผู้เล่น' ที่คุณแนะนำได้",
    bonus_monthly: "รางวัล (รายเดือน)",
    birthday_bonus: "ของขวัญวันเกิด",
    withdraw_per_day: "ถอนได้ทุกวัน",
    exclusive_domain: "ชื่อโดเมนพิเศษ",
    deposit_priority: "ลำดับเงินฝาก",
    festival_gift: "ของขวัญวันหยุดที่ผิดปกติ",
    exclusive_customer_service: "บริการลูกค้าพิเศษ",
    free_travel: "ทัวร์ฟรี",
    vip_myr_activity_1:
      "●ในขณะที่มุ่งมั่นจะสร้างแพลตฟอร์มเกมส์ที่สะดวกสบาย เรายังมีสิทธิพิเศษ สำหรับลูกค้า VIP เพื่อได้เพลิดเพลินไปกับความหรูหรา บรรลุเป้าหมายของคุณด้วยหัวใจ เพื่อสร้างคลาสสิกของเราด้วยชื่อเสียง และเพื่อความเพลิดเพลินของท่านซึ่งเป็นการแสวงหาของเราอย่างต่อเนื่อง เพราะลูกค้าทุกท่านคือเเขกผู้มีเกียรติของทางเรา",
    vip_myr_activity_2:
      "●ด้วยการเติบโตอย่างต่อเนื่องของกิจกรรมของสมาชิกบนแพลตฟอร์มความบันเทิง (LuckyTown) เราจะให้บริการสมาชิกด้วยความเอาใจใส่และกิจกรรมคุณภาพสูงขึ้น ระบบรางวัลใหม่สำหรับผู้เล่น Lucky Town ได้เปิดตัวแล้ว ผู้เล่นใหม่และผู้เล่นเก่าสามารถเพลิดเพลินกับข้อเสนอโบนัสกิจกรรมต่างๆได้เลย",
    vip_myr_policy:
      "1. เงื่อนไขโปรโมชั่น: ระบบจะกำหนดโดยอัตโนมัติว่าโบนัสโปรโมชั่นจะถูกส่งทันทีหลังจากการอัพเกรดเสร็จสิ้น ระยะเวลาในการรับของขวัญคือ 14 วันหลังจากแจกจ่าย การไม่ได้รับภายในระยะเวลาจะถือเป็นการให้ ขึ้นและจะถูกถอนออกจากระบบโดยอัตโนมัติ. \n2. เงื่อนไขการตกชั้น: ระบบจะสะสมโดยอัตโนมัติว่ามีคุณสมบัติตรงตามการตกชั้นหรือไม่ เวลาสะสมคือวันแรกของวันอัปเกรด และจะคำนวณในภายหลัง ตัวอย่าง: สมาชิกได้รับการอัพเกรดเป็นสมาชิกระดับโกลด์ในวันที่ 3 พฤศจิกายน และเวลาสะสมในระบบคือวันที่ 3 กันยายน เวลา 12:00:01 น. ถึง 3 ธันวาคม เวลา 11:59:59 น. ในช่วงเวลาสามเดือน ( หนึ่งฤดูกาล) ไม่ว่าจะผ่านเข้ารอบในการตกชั้นหรือไม่ \n3. ของขวัญวันเกิด: 3 วันก่อนและหลังได้รับของขวัญวันเกิดหรือในวันเดียวกัน คุณต้องส่งรูปถ่ายบัตรประจำตัวของคุณไปที่ฝ่ายบริการลูกค้าเพื่อยืนยัน และชื่อบัตรประจำตัวที่แสดงจะต้องตรงกับชื่อบัญชีธนาคารของบัญชีเกมก่อนจึงจะอ้างสิทธิ์ได้ ทั้งนี้ เกินกำหนดเวลาในการสมัครรับเงินของขวัญวันเกิดถือเป็นการสละสิทธิ์ \n4. ของขวัญวันหยุดที่ผิดปกติ ของขวัญวันหยุดที่ผิดปกติ จะได้รับทางไปรษณีย์หรือเงินของขวัญ。\n5. ทัวร์ฟรี คุณต้องรักษา vip6,ต้องบำรุงรักษาอย่างน้อย 4 ไตรมาส (12 เดือน) ก่อนจึงจะได้รับมัน บริษัทจะจัดการวันออกเดินทาง โรงแรม และตั๋วเครื่องบินโดยรับผิดชอบแต่เพียงผู้เดียว (ไม่อนุญาตให้เปลี่ยนโรงแรมหรือเปลี่ยนแปลงวันเดินทางและวันเดินทาง). \n6. ระยะเวลารับรางวัลกิจกรรมหรือเงินของขวัญข้างต้นคือภายใน 14 วันหลังจากแจกจ่าย หากไม่ได้รับภายในเวลาที่กำหนดจะถือว่าสละสิทธิ์และจะถูกถอนออกโดยอัตโนมัติโดยระบบ. \n7. รางวัลรายสัปดาห์/รายเดือน: (VIP2 / VIP3) รายเดือน - มีการฝากอย่างน้อย 10 ครั้ง หรือยอดฝากสะสมคือ 1,000 ริงกิต และจำนวนรหัสที่มีผลมากกว่า 5000 เพื่อรับรางวัล VIP รายเดือน (VIP4 / VIP5 / VIP6 ) เงินฝากอย่างน้อย 1 ครั้งต่อสัปดาห์หรือเงินฝากสะสม 1,000 ริงกิตและจำนวนรหัสที่ถูกต้อง 5,000 ขึ้นไปสามารถรับโบนัสวีไอพีรายสัปดาห์ \n\n《เงื่อนไขการจัดงาน'》\n1. โปรโมชั่นนี้สำหรับสมาชิกเพื่อความบันเทิงเท่านั้น หากพบว่าผู้ใช้มีบัญชีมากกว่าหนึ่งบัญชี ได้แก่ ชื่อเดียวกัน, ที่อยู่อีเมลเดียวกัน, ที่อยู่ IP เดียวกัน/คล้ายกัน, ที่อยู่เดียวกัน, บัตรเดบิต/บัตรเครดิตเดียวกัน บัญชีธนาคารเดียวกัน ฯลฯ พฤติกรรมการเดิมพันที่ผิดปกติใดๆ เมื่อพบ LUCKY TOWN จะสงวนสิทธิ์ในการระงับกำไรและยอดคงเหลือในบัญชีของคุณ. \n2. การเดิมพัน เสมอ เดิมพันป้องกันความเสี่ยงอื่น ๆ (การเดิมพันข้ามไซต์) เดิมพันที่ถูกปฏิเสธ เดิมพันเป็นโมฆะ เสมอ หรืออัตราต่อรองกีฬาที่ต่ำกว่า 1.5 จะไม่ถูกนับเป็นการเดิมพันที่ถูกต้องที่จำเป็นสำหรับโปรโมชั่น. \n3. การเดิมพันใดๆ ที่ทำผ่านซอฟต์แวร์ที่ผิดกฎหมายของบุคคลที่สาม เช่น การแฮก และ เปิดหลายๆยูส ถือเป็นการเดิมพันที่ผิดกฎหมาย และลัคกี้ทาวน์ขอสงวนสิทธิ์ในการระงับยอดเงินคงเหลือของบัญชีต้องสงสัยและปิดบัญชีสมาชิกทันที. \n4. LUCKY TOWN มีสิทธิ์ตรวจสอบบันทึกการเดิมพันของสมาชิกทุกคน หากสมาชิกฝ่าฝืนระเบียบและกฎของการแข่งขันหรือมีวัตถุประสงค์ที่ไม่ใช่เพื่อความบันเทิงในการใช้โบนัสเพื่อทำกำไร LUCKY TOWN ขอสงวนสิทธิ์ในการหยุด ยกเลิก หรือ เรียกร้องคืนเมื่อใดก็ได้. \n5. LUCKY TOWN ขอสงวนสิทธิ์ในการกำหนดให้สมาชิกส่งข้อมูลเพื่อยืนยันตัวตน หากบัญชีถูกบล็อกจะไม่มีสิทธิ์ได้รับโปรโมชั่นนี้. \n6. หากบุคคล/ทีม/องค์กรใดใช้วิธีการที่ไม่ซื่อสัตย์หรือการกระทำที่เป็นการฉ้อโกงเพื่อจุดประสงค์ในการฉ้อโกง/ใช้โบนัสในทางที่ผิด เมื่อตรวจสอบแล้ว LUCKY TOWN จะมีสิทธิ์ระงับผลกำไรและยอดคงเหลือในบัญชีที่เกี่ยวข้อง. \n7. ในการเข้าร่วมโปรโมชั่นนี้ ต้องยืนยันว่าคุณยอมรับ 'กฎและข้อกำหนดทั้งหมดของการส่งเสริมการขาย' \n8. ลัคกี้ทาวน์ขอสงวนสิทธิ์ในการแก้ไข ยุติ หรือการตีความขั้นสุดท้ายของโปรโมชั่นนี้ และทำการเปลี่ยนแปลงโปรโมชั่นนี้โดยไม่ต้องแจ้งให้ทราบ. \n9. หากพบการเดิมพันที่ผิดกฎหมาย เงินฝาก (รวมถึงจำนวนกำไรและโบนัส) จะถูกระงับ และระบบจะปรับให้เป็นศูนย์โดยอัตโนมัติ \n",
    weekly: "รายสัปดาห์)",
    withdraw_duration_text:
      "*ระยะเวลาการถอน เวลาดำเนินการฝากจะเสร็จสิ้นภายใน 30 นาที รบกวนรอสักครู่นะคะ",
    hot_game: "เกมส์สุดฮอต",
    new_games: "เกมส์ใหม่",
    reset_app: "ล้างแคชของแอป",
    reset_app_title: "ล้างข้อมูลแคช",
    reset_app_description: "ุณแน่ใจหรือ คุณต้องการลบข้อมูลแอพของคุณ.",
    anoucement_intro_title: "ระกาศ",
    anoucement_intro_description: "คุณสามารถค้นหาสิ่งสำคัญ.",
    game_list_intro_title: "รายชื่อเกม",
    game_list_intro_description: "คุณสามารถคลิกที่ไอคอนเกมเพื่อเริ่มเกม",
    topup_intro_title: "ิมเงิน/ถอน",
    topup_intro_description:
      "ือที่ที่คุณสามารถเติมเงิน/ถอนยอดคงเหลือของคุณได้.",
    leatherboard_intro_title: "ื่กระดานคะแนน ",
    leatherboard_intro_description:
      "ผู้เล่นอันดับต้น ๆ ของเดือนจะแสดงอยู่ที่นี่ ฝากถอนและรับรางวัลอื่นๆ",
    previous_step: "นก่อนหน้า",
    next_step: "ขั้นตอนต่อไป",
    skip_step: "ข้ามขั้นตอน",
    finish_step: "จบขั้นตอน",
    point_history: "ประวัติคะแนน",
    points: "คะแนน",
    luckytown_points: "คะแนนลัคกี้ทาวน์",
    you_have_earned: "คุณได้รับ",
    topup_info:
      "หากชื่อจริงและชื่อบัญชีที่ทำการโอนเงินเข้าไม่ตรงกัน ทางบริษัทสามารถปฏิเสธการเติมเงินให้กับลูกค้าได้ทันที",
    please_upload_reciept: "กรุณาอัปโหลดใบเสร็จรับเงิน",
    pull_out_credit: "บังคับออกจากเกม",
    pull_out_all_credit: "ดึงเครดิตทั้งหมดออก",
    pull_out_credit_message: "คุณแน่ใจหรือไม่ว่าต้องการถอนเครดิตทั้งหมด",
    topup_promotion_intro:
      "การแจ้งเตือนสำคัญ: ในการเข้าร่วมในกิจกรรมพิเศษใด ๆ ผู้ใช้จะไม่สามารถใช้การโอน QR หรือการโอน ID ได้จนกว่าเงื่อนไขการทำยอดเทิร์นของส่วนลดที่เลือกจะเสร็จสิ้น และหลังจากการถอนผ่านแพลตฟอร์มเสร็จสิ้น นำไปให้กับบริการลูกค้า และผ่านการตรวจสอบเพื่อเริ่มฟังก์ชั่นการถ่ายโอน QR",
    statment: "Statement",
    withdraw_usdt: "ถอนเงิน USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n\n• The minimum withdrawal amount is: 1USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    withdraw_amount: "Withdraw Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",
    game_detail: "Game Detail",
    google_auth: "การรับรองความถูกต้อง",
    redeem: "คูปอง",
    enter_verification_code: "Enter the 6-digit verification code",
    activate_google_auth: "Activate Google Authenticator",
    inactivate_google_auth: "In Activate Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Are you sure you want to Reset Google Authenticator?",
    activate_google_auth_msg:
      "Are you sure you want to Activate Google Authenticator?",
    register_google_auth_verification_msg:
      "Setup account with Google Auth Veririfcation ",
    scan_google_auth_msg:
      "Scan this QR Code with yoour Google Authenticator App. Alternatively, you can use this code to reset   ",
    secret_key: "Secret Key:",
    pin: "PIN",
    change_app_icon: "การเปลี่ยนไอคอน",
    change_app_icon_message: "Are you sure you want to change app icon?",
    change_app_icon_success_message: "App Icon Change Successfully",
    real_name_verification: "การตรวจสอบชื่อจริง",
    enter_real_name: "Enter Real Name",
    real_name_notes:
      "Notes:\n\n1. Add a bank account with your real-name. \n2. Choose the bank account.\n3. Fill in your real-name. \n4. Submit Verification Request. \n5. Your request will be updated within 3 working days.",
    please_login_first: "Please Login first",
    otp_prefix: "OTP Prefix",
    notification_detail: "Notification Detail",
    bonus_chips: "Bonus Chips",
    bonus: "Bonus",
    cash_wallet: "Cash Wallet",
    promotion_intro_description: "ตรวจสอบโปรโมชั่นล่าสุดของเราที่นี่",
    looked_amount: "จำนวนล็อค",
    current_tunrover_stake: "ต้องมีสเตคปัจจุบัน/มูลค่าการซื้อขาย",
    turnover_stake_remarks: "การอัพเดทการลงทุนอัตโนมัติใน 10 นาที",
    otp_verification_text:
      "โปรดตรวจสอบ SMS ของโทรศัพท์มือถือและ ป้อน OTPเพื่อยืนยันและผูกอุปกรณ์มือถือของคุณ เพื่อปกป้องความปลอดภัยบัญชีของคุณ",
    select_deposit_method: "เลือกวิธีการฝากเงิน",
    user_agreement: "ข้อตกลงการใช้",
    no_record_found: ".ไม่มีบันทึก",
    info: "ข้อมูล",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "คำแนะนำผู้ใช้",
  },
  vt: {
    app_name: "Thị trấn may mắn",
    login_text: "Đăng nhập",
    signUp_text: "Đăng ký",
    welcom_text: "Chào mừng bạn đến với Ứng dụng Lucky Town Plus",
    username_text: "Tên tài khoản",
    password_text: "Mật khẩu",
    forgotPassword_text: "Quên mật khẩu",
    otp_text: "OTP",
    invalid_username_or_password: "Sai username hoặc password",
    invalid_password: "Mật khẩu không hợp lệ",
    invalid_data_input: "Dữ liệu nhập không hợp lệ",
    invalid_phone_number: "Số điện thoại không hợp lệ",
    invalid_transaction_pin: "Pin giao dịch không hợp lệ",
    history_text: "Lịch sử",
    from_date: "Từ ngày",
    to_date: "Cho đến nay",
    to: "Đến",
    go: "Đi",
    select: "Lựa chọn",
    new_account: "Tài khoản mới",
    new_password: "Mật khẩu mới",
    recommended_user: "Người dùng đề xuất: ",
    phone_number: "Số điện thoại",
    confirm_password: "Xác nhận mật khẩu",
    username_or_phone_number_is_registered:
      "Tên người dùng hoặc số điện thoại đã được đăng ký",
    recover_password: "Khôi phục mật khẩu",
    recover_username: "Khôi phục tên người dùng",
    please_enter_phone_number:
      "Vui lòng nhập số điện thoại đã đăng ký của bạn để khôi phục mật khẩu.",
    please_enter_phone_number_to_recover_username:
      "Vui lòng nhập số điện thoại đã đăng ký của bạn để khôi phục tên người dùng của bạn.",
    please_enter_txid: "Vui lòng nhập txid.",
    next: "Kế tiếp",
    otp_code_resended: "Đã gửi lại mã OTP",
    invalid_otp_code: "Mã OTP không hợp lệ",
    request_otp: "Yêu cầu OTP",
    please_enter_otp:
      "Vui lòng nhập OTP gửi đến thông tin đăng nhập đã chọn của bạn.",
    proceed: "Tiếp tục",
    resend_code: "Mã gửi lại",
    change_login_password: "Thay đổi mật khẩu đăng nhập",
    select_one_of_the_cre:
      "Chọn một trong các thông tin xác thực mà chúng tôi sẽ sử dụng để khôi phục mật khẩu của bạn.",
    password_changed: "Mật khẩu đã được thay đổi",
    congratulations_changed_password:
      "Xin chúc mừng! Bạn đã thay đổi thành công mật khẩu của mình.",
    login_now: "Đăng nhập ngay bây giờ",
    discover: "Phát hiện",
    amount_RM: "Số lượng",
    start: "Bắt đầu",
    contacts: "Liên hệ với chúng tôi",
    new_friend: "Bạn mới",
    wallet: "Cái ví",
    cash: "Tiền mặt",
    bank_account: "Tài khoản ngân hàng",
    setting: "Cài đặt",
    withdraw_succ: "Rút tiền thành công",
    top_up_succ: "Nạp tiền thành công",
    coin: "Đồng tiền",
    interest: "Đồng xu may mắn",
    wallet_balance: "Số dư tiền mặt",
    top_up: "Nạp tiền",
    withdraw: "Rút",
    transaction: "Giao dịch",
    instant_top_up: "Nạp tiền tức thì",
    top_up_bank_transfer: "Chuyển khoản ngân hàng",
    error_please_try_again: "Lỗi. Vui lòng thử lại.",
    top_up_RM: "Nạp tiền",
    upload_receipt: "Tải biên nhận lên",
    choose_upload_photo_method: "Chọn phương thức tải ảnh lên",
    take_picture: "Chụp ảnh",
    select_from_gallery: "Chọn từ thư viện",
    take_photo: "Chụp hình",
    retake: "Thi lại",
    use_photo: "Sử dụng ảnh",
    upload_bank_receipt: "Tải Biên lai Ngân hàng lên",
    confirm_to_upload_this_photo: "Xác nhận tải ảnh này lên?",
    cancel: "Hủy bỏ",
    confirm: "Xác nhận",
    wallet_balance_not_enough: "Số dư tiền mặt không đủ để rút",
    withdraw_RM: "Rút",
    no_transaction_for_dates: "Không có giao dịch nào cho các ngày đã chọn",
    no_more_transaction_for_dates:
      "Không còn giao dịch nào cho các ngày đã chọn",
    please_enter_date: "Vui lòng nhập ngày",
    all_transaction: "Tất cả giao dịch",
    top_up_history: "Lịch sử nạp tiền",
    interest_account_removed: "Tài khoản LuckyCoin đã bị xóa!",
    interest_account_created_succ: "Tài khoản LuckyCoin được tạo thành công.",
    you_have_no_interest_account: "Bạn không có tài khoản LuckyCoin đang chạy.",
    interest_history: "Lịch sử đồng xu may mắn",
    days: "Ngày",
    hours: "Giờ",
    create_interest: "Tạo LuckyCoin",
    deposit_RM: "Tiền gửi",
    balance_RM: "Sự cân bằng :",
    remove: "Di dời",
    partial_withdraw: "Rút một phần",
    interest_withdraw: "Rút tiền lãi",
    add_back_account_succ: "Thêm tài khoản ngân hàng thành công",
    edit_bank_account: "Chỉnh sửa tài khoản ngân hàng",
    bank: "Ngân hàng",
    account_name: "Tên tài khoản",
    account_no: "Số tài khoản.",
    add_bank_account: "Thêm tài khoản ngân hàng",
    sign_out: "Đăng xuất",
    language: "Ngôn ngữ",
    clear_cache: "Xóa bộ nhớ cache",
    about: "Về",
    old_password_not_match: "Mật khẩu cũ không khớp.",
    old_password: "Mật khẩu cũ",
    back: "Trở lại",
    version: "Phiên bản",
    change_payment_pin: "Thay đổi mã pin thanh toán",
    change_nickname: "Thay đổi biệt danh",
    transfer: "Chuyển nhượng",
    create_pin: "Tạo mã pin giao dịch",
    change_pin: "Thay đổi mã pin giao dịch",
    creat_pin_description:
      "Tạo mã pin gồm 6 chữ số cho giao dịch của bạn trong ứng dụng",
    please_enter_pin_again: "Vui lòng nhập lại mã pin 6 chữ số",
    pin_dont_match: "Pin không khớp",
    old_pin: "Chốt cũ",
    new_pin: "Pin mới",
    confirm_new_pin: "Xác nhận mã PIN",
    pin_max_six: "Pin giao dịch 6 chữ số",
    succ_pin_change: "Pin chuyển đổi đã thay đổi",
    congratulations_changed_pin:
      "Xin chúc mừng! Bạn đã thay đổi thành công mã pin giao dịch của mình.",
    please_enter_pin: "Vui lòng nhập mã pin giao dịch",
    forgot_pin: "Quên mã pin giao dịch",
    recover_transaction_pin: "Khôi phục mã pin giao dịch",
    please_enter_phone_number_pin:
      "Vui lòng nhập số điện thoại đã đăng ký của bạn để khôi phục mã pin giao dịch của bạn.",
    old_pin_not_match: "Chốt cũ không khớp",
    new_pin_not_match: "Pin mới không khớp",
    transfer_RM: "Chuyển nhượng",
    transfer_succ: "Chuyển tiền thành công",
    transfer_to: "Chuyển đến: ",
    wallet_insuffecient_amount: "Số dư tiền mặt không đủ để chuyển.",
    change_your_nickname: "Chỉnh sửa hoặc thay đổi biệt hiệu của bạn",
    nickname: "Tên nick",
    fullname: "Họ và tên",
    nickname_change_succ: "Thay đổi tên hiệu thành công",
    cancellation: "Hủy",
    confirm_to_remove_and_withdraw:
      "Confir'Xác nhận xóa và rút',m để xóa và rút",
    confirm_go_back: "Xác nhận để quay lại?",
    in_game: "Trong game",
    close_game_first: "Hãy thoát khỏi các trò chơi khác trước!",
    close_game: "Đóng trò chơi",
    game_closed: "Trò chơi đã đóng",
    game: "Trò chơi",
    information: "Thông tin",
    search: "Tìm kiếm",
    no_user_found: "Không tìm thấy người dùng",
    i_have_read_and_agree: "Tôi đã đọc và đồng ý",
    LID: "NẮP",
    referral: "Giới thiệu",
    available_transfer_balance_RM: "Chuyển có sẵn",
    i_am_agreed_to_term: "Tôi đồng ý với thời hạn",
    coin_transaction: "Giao dịch tiền xu",
    status: "Tình trạng",
    succ_submission_pending_review: "Gửi thành công đang chờ xem xét",
    leaderboard: "Bảng xếp hạng",
    time_zone: "Múi giờ",
    customer_service: "Dịch vụ khách hàng",
    qr_transfer: "Chuyển QR",
    top_up_details: "Chi tiết nạp tiền",
    top_up_type: "Loại nạp tiền",
    date: "Ngày",
    receipt: "Ngày",
    available_transfer: "Chuyển có sẵn",
    available_coin: "Xu có sẵn",
    commission: "Nhiệm vụ",
    today_stake: "Cổ phần hôm nay",
    yesterday_stake: "Cổ phần hôm nay",
    wallet_transaction: "Giao dịch ví",
    game_transaction: "Giao dịch trò chơi",
    type: "Loại",
    all: "Tất cả các",
    refund: "Đền bù",
    penalty: "Hình phạt",
    pick_date: "Chọn ngày",
    time: "Thời gian",
    win: "Thắng thua",
    win_: "Chiến thắng",
    bet: "Cá cược",
    bet_or_transfer: "Cược/Chuyển khoản",
    save_in_album: "Lưu vào album",
    qr_code_saved: "Đã lưu mã QR",
    save_error: "Lưu lỗi",
    change_avatar: "Thay đổi hình đại diện",
    avatar_changed: "Hình đại diện đã thay đổi",
    cant_start_game: "Không thể bắt đầu trò chơi",
    details: "Thông tin chi tiết",
    product: "Sản phẩm",
    total_bet: "Tổng cược",
    total: "Tổng cộng",
    reward: "Phần thưởng",
    photo_library: "Thư viện ảnh",
    qr_code_error: "Lỗi mã QR",
    maintenance: "Bảo trì",
    coming_soon: "Sắp có",
    top_up_disclaimer:
      "** Vui lòng tuân thủ các quy định do công ty chúng tôi liệt kê. Nếu không, số điểm được tặng sẽ bị chậm lại. Chúc bạn chơi game vui vẻ, xin cảm ơn.",
    minimum_top_up: "Tối thiểu: ",
    maximum_top_up: "Tối đa: ",
    top_up_left_times: "Thời gian còn lại:",
    top_up_unlimited: "(Vô hạn)",
    order_history: "Lịch sử đơn hàng",
    withdraw_history: "Lịch sử rút tiền",
    no_bank_account_added: "Vui lòng liên kết ít nhất một tài khoản ngân hàng",
    minimum_withdraw: "Min: ",
    maximum_withdraw: "Tối đa: ",
    free_withdraw_time: "Thơi gian rảnh rôi: ",
    withdraw_balance: "Số dư hiện tại: ",
    unlimited: "Vô hạn",
    withdraw_details: "Chi tiết rút tiền",
    updated_date: "Ngày cập nhật",
    pending: "Chưa giải quyết",
    success: "Thành công!",
    in_inspection: "Đang kiểm tra",
    hold: "Đang chờ",
    confirm_to_remove_withdraw: "Xác nhận xóa rút tiền?",
    confrim_to_remove_top_up: "Xác nhận để xóa nạp tiền?",
    rejected: "Bác bỏ",
    copied: "Sao chép vào clipboard",
    anouncement: "Thông báo",
    contactUs: "Liên hệ chúng tôi",
    newVersionTitle: "Một phiên bản mới có sẵn",
    versionDescription:
      "Để tiếp tục, vui lòng cập nhật ứng dụng của bạn lên phiên bản mới nhất",
    verification: "Xác minh",
    register_device_text:
      "Thiết bị này không liên kết với tài khoản của bạn. Vui lòng đăng ký thiết bị để tiếp tục",
    device_name: "Tên thiết bị",
    device_info: "Thông tin thiết bị",
    friend: "Bạn bè",
    about_phone: "Về điện thoại",
    remarks: "Nhận xét",
    balance_transfer: "Chuyển số dư thành công",
    usdt_top_up: "Nạp USDT",
    app_close: "Đóng",
    topupRemarks:
      "Vui lòng chỉ định LT- (tên người dùng của bạn) trên phiếu chuyển khoản \nVí dụ: \nID: lucky town \nGiới thiệu: LTluckytown",
    top_up_policy:
      "Công ty chúng tôi sẽ thay đổi tài khoản ngân hàng theo thời gian, vui lòng xác nhận trước tài khoản tại ngân hàng của bạn/ trước khi chuyển khoản thanh toán. Công ty không chịu trách nhiệm cho bất kỳ tổn thất nào do lỗi của bạn gây ra",
    notification: "Thông báo",
    empty_notifications: "Không có thông báo mới.",
    promotion: "Khuyến mãi",
    use_now: "SỬ DỤNG NGAY BÂY GIỜ",
    promo_code: "Mã khuyến mại",
    enter_otp: "Vui lòng nhập OTP",
    change_phone_no: "Thay đổi số điện thoại",
    change_your_phone: "Chỉnh sửa hoặc thay đổi số điện thoại của bạn",
    congratulations_changed_phone:
      "Xin chúc mừng! Bạn đã thay đổi thành công số điện thoại của mình.",
    default_avatar: "Hình đại diện mặc định",
    forgotUsername_text: "Quên tên người dùng",
    authenticate: "Xác thực",
    forgot_id_password: "Quên UID/Mật khẩu",
    manage_account: "Chuyển tài khoản",
    add_another_account: "Thêm tài khoản khác",
    add_account: "Thêm tài khoản",
    cashout: "RÚT TIỀN",
    please_signin_to_continue: "Vui lòng đăng nhập để tiếp tục",
    no_account_found: "Không có tài khoản nào được tìm thấy",
    reward: "Phần thưởng",
    please_enter_amount: "Vui lòng nhập số tiền.",
    topUpUSDTReceipt: "Biên nhận USDT nạp tiền",
    amount_usdt: "Số tiền (USDT)",
    txid: "TXID",
    enter_txid: "Nhập TXID",
    platform: "Nền tảng",
    select_platrform: "Chọn nền tảng",
    request_topup_success: "Yêu cầu nạp tiền thành công.",
    chip: "Chip",
    confrim_to_remove_back_account: "Vui lòng xác nhận xóa tài khoản ngân hàng",
    footer_home: "Nhà",
    footer_contact: "Liên lạc",
    footer_transaction: "Giao dịch",
    footer_me: "Tôi",
    profile_cash: "Tiền mặt",
    profile_chip: "Chip",
    profile_luck: "Đồng xu may mắn",
    profile_vip: "CAO CẤP",
    bank_search_bank: "Tìm kiếm ngân hàng",
    avatar_back: "Trở lại",
    friend_search_friend: "Tìm kiếm bạn bè",
    friend_delete: "Xóa bỏ",
    friend_title: "Thêm bạn",
    friend_popup: "Nhập tên người bạn",
    game_details_download: "Tải xuống",
    game_details_launch: "Phóng",
    game_details_transfer: "Chuyển nhượng",
    qr_copy_link: "Sao chép đường dẫn",
    qr_qr_share: "Chia sẻ QR",
    profile_lucky_coin: "Đồng xu may mắn",
    currency_exchange: "Thu đổi ngoại tệ",
    currency_exchange_successfully: "Trao đổi tiền tệ thành công",
    please_select_other_currency: "Vui lòng chọn loại tiền tệ khác để trao đổi",
    receipt_get: "Người nhận Nhận",
    send_currency_exactly: "Bạn gửi chính xác",
    exchange_rate: "Tỷ giá",
    helpDesk: "Bộ phận trợ giúp",
    topup_withdraw: "Nạp tiền/Rút tiền",
    more: "Hơn",
    order: "Gọi món",
    add_friend: "Thêm bạn",
    search_friend: "Tìm kiếm bạn bè",
    friend_added_successfully: "Bạn Đã Thêm Thành Công",
    please_enter_friend_name: "Vui lòng nhập tên bạn bè",
    message: "Thông điệp",
    home: "Nhà",
    contact: "Tiếp xúc",
    qr_topup: "QR TopUp",
    qr_topup_reciept: "QR TopUp",
    transaction_process: "Giao dịch của bạn đang được tiến hành",
    please_allow_camera_permission: "Vui lòng cho phép máy ảnh.",
    enter_game: "Vào trò chơi",
    exit_game: "Vào trò chơi",
    edit_nickname: "Chỉnh sửa biệt hiệu",
    model: "Mô hình",
    device_id: "Id thiết bị",
    unique_id: "Id duy nhất",
    lt_coin: "Id duy nhất",
    stage: "Sân khấu",
    update_now: "CẬP NHẬT BÂY GIỜ",
    withdraw_policy:
      "Quý khách thân mến, để ngăn chặn gian lận, khách hàng phải đảm bảo rằng tên chủ ngân hàng của bạn giống với tên tài khoản tiền gửi của bạn khi thực hiện rút tiền. Chính sách này cũng nhằm bảo vệ an toàn cho tiền của khách hàng. Xin lỗi vì bất kỳ sự bất tiện nào, Cảm ơn bạn ",
    max: "Tối đa",
    promotion_reward: "Phần thưởng khuyến mãi",
    birthday_gift: "Quà sinh nhật",
    daily_withdraw: "Số tiền rút tối đa hàng ngày",
    monthly_Salary: "Lương tháng gấp đôi",
    edit_bank_account_succ: "Sửa tài khoản ngân hàng thành công",
    cancel_request: "Hủy yêu cầu",
    redeem_coupon: "Đổi phiếu giảm giá",
    coupon_list: "Danh sách phiếu giảm giá",
    code_redeem_success: "Đổi mã thành công",
    please_enter_username: "Vui lòng nhập tên người dùng.",
    limitPerDay: "Giới hạn mỗi ngày: ",
    approved: "chấp thuận",
    processing: "Processing",
    got_it: "HIỂU RỒI",
    amount_greater_then_available_balance:
      "Rất tiếc, số tiền của bạn lớn hơn số dư hiện có",
    details: "Chi tiết",
    rate: "Tỷ lệ",
    select_bank: "Chọn Ngân hàng",
    address: "Địa chỉ nhà",
    date_time: "Ngày giờ",
    amount_myr: "Số tiền(MYR)",
    select_country_code: "Chọn mã quốc gia",
    pick_bank: "Chọn ngân hàng",
    balance: "Sự cân bằng",
    luckytownviplabel: "Thị trấn may mắn VIP",
    vip_activity_label: "Hoạt động",
    vip_member_bonus: "Tiền thưởng thành viên VIP ",
    vip_promoted_conditions: "Điều kiện thăng hạng",
    vip_toa: "Điều khoản & Điều kiện VIP của LuckyTown",
    promoted_bonus: "Tiền thưởng thăng cấp",
    birthday_bonus: "Tiền thưởng sinh nhật",
    withdraw_limit: "Giới hạn rút tiền",
    monthly_bonus: "Tiền thưởng hàng tháng",
    vip_activity_1:
      "â— Lucky Town cam kết tạo ra một nền tảng chơi trò chơi thoải mái nhưng cũng không quên tạo ra một nền tảng VIP hạng nhất mà chúng tôi đã và đang theo đuổi trong ngành.",
    vip_activity_2:
      "â—Với sự tăng trưởng không ngừng của người chơi' trên nền tảng trò chơi Lucky Town, chúng tôi sẽ cung cấp cho người chơi sự chăm sóc chu đáo hơn và các hoạt động chất lượng cao hơn. Hệ thống phần thưởng mới dành cho người chơi Lucky Town đã được ra mắt. Người chơi mới và cũ cũng có thể tận hưởng nhiều ưu đãi tiền thưởng sự kiện hơn;",
    vip_policy_1:
      "1. Điều kiện khuyến mãi: Hệ thống tự động xác định quà khuyến mãi sẽ được phát ngay sau khi nâng cấp xong. Thời hạn nhận quà là sau 14 ngày kể từ ngày phát, nếu không nhận trong thời hạn sẽ bị coi là bỏ cuộc và hệ thống sẽ tự động rút tiền.",
    vip_policy_2:
      "2. Điều kiện xuống hạng: Hệ thống sẽ tự động cộng dồn xem có đủ điều kiện xuống hạng hay không. Thời gian tích lũy là ngày đầu tiên của ngày nâng cấp, sẽ tính sau. \nVí dụ: Một thành viên được nâng cấp lên thành viên vàng vào ngày 3/11 , và thời gian tích lũy trong hệ thống là từ ngày 3 tháng 9 lúc 12:00:01 chiều đến ngày 3 tháng 12 lúc 11:59:59 sáng, trong khoảng thời gian ba tháng (một mùa giải) liệu có đủ điều kiện xuống hạng hay không.",
    vip_policy_3:
      "3. Quà sinh nhật: 3 ngày trước và sau khi nhận quà sinh nhật hoặc trong cùng ngày, bạn cần gửi ảnh CMND của mình cho bộ phận chăm sóc khách hàng để xác minh. Và tên trên CMND xuất trình phải trùng với tên của người nhận. tài khoản ngân hàng của tài khoản trò chơi trước khi nó có thể được yêu cầu. Quá thời hạn đăng ký tiền quà tặng sinh nhật sẽ được coi là từ bỏ.",
    vip_policy_4:
      "4. Quà tặng ngày lễ không thường xuyên, quà tặng ngày lễ không thường xuyên sẽ được gửi qua thư hoặc tiền quà tặng.",
    vip_policy_5:
      "5. Đối với du lịch miễn phí, bạn cần duy trì vip6 ít nhất 4 quý (12 tháng) trước khi bạn có thể nhận được. Ngày khởi hành, khách sạn và vé máy bay sẽ do công ty chịu trách nhiệm sắp xếp (sẽ không được phép thay đổi khách sạn hoặc thay đổi ngày vé máy bay và ngày khởi hành).",
    vip_policy_6:
      "6. Thời gian thu thập phần thưởng hoặc tiền quà tặng sự kiện trên là trong vòng 14 ngày sau khi phân phối. Nếu không thu thập trong thời hạn sẽ được coi là bỏ cuộc và sẽ bị hệ thống tự động thu hồi.",
    vip_policy_7:
      "7. Phần thưởng hàng tuần/hàng tháng: (VIP2 / VIP3) Hàng tháng - Hoàn thành ít nhất 10 khoản tiền gửi hoặc khoản tiền gửi tích lũy là 8000 THB và số tiền quay lớn hơn 40.000, để nhận được phần thưởng VIP hàng tháng. \n(VIP4 / VIP5 / VIP6 ) Ít nhất 1 khoản tiền gửi mỗi tuần hoặc khoản tiền gửi tích lũy là 8000 THB và số tiền luân phiên từ 40.000 trở lên, có thể nhận được tiền thưởng VIP hàng tuần",
    vip_policy_8:
      "ã€ŠĐiều khoản sự kiệnã€‹ \n\n1. Khuyến mãi chỉ dành cho thành viên giải trí. Nếu phát hiện người dùng có nhiều tài khoản, bao gồm trùng tên, trùng địa chỉ email, trùng/tương tự địa chỉ IP, cùng địa chỉ, cùng thẻ ghi nợ/thẻ tín dụng, cùng tài khoản ngân hàng, cùng máy tính, v.v. Bất kỳ hành vi cá cược bất thường nào, sau khi được phát hiện, LUCKY TOWN sẽ có quyền đóng băng lợi nhuận và số dư tài khoản của bạn. \n\n2. Bất kỳ cá cược, hòa, cược bảo hiểm rủi ro khác (cược trên nhiều trang web), cược bị từ chối, cược vô hiệu, hòa hoặc tỷ lệ cược thể thao dưới 1,5 sẽ không được tính là cược hợp lệ cần thiết cho khuyến mãi. \n\n3. Bất kỳ cược nào được thực hiện thông qua bên thứ ba phần mềm bất hợp pháp như 'rô-bốt' và 'mở hai cửa sổ/nhiều cửa sổ' có thể được coi là cá cược bất hợp pháp và LUCKY TOWN có quyền đóng băng số dư của tài khoản bị nghi ngờ và đóng tài khoản thành viên. \n\n4. LUCKY TOWN có quyền kiểm tra tất cả các hồ sơ cá cược của thành viên. Nếu một thành viên vi phạm các quy định và quy tắc của sự kiện hoặc h vì bất kỳ mục đích phi giải trí nào của việc sử dụng tiền thưởng để kiếm lợi nhuận, LUCKY TOWN có toàn quyền dừng, hủy bỏ hoặc yêu cầu trả lại bất cứ lúc nào. Tất cả các cung cấp thanh toán. \n\n5. LUCKY TOWN có quyền yêu cầu thành viên gửi các giấy tờ liên quan để xác minh danh tính nếu tài khoản liên quan bị nghi ngờ bị lạm dụng và/hoặc không đủ điều kiện tham gia khuyến mãi này. \n\n6. Nếu bất kỳ cá nhân/nhóm/tổ chức nào bị nghi ngờ sử dụng các phương pháp không trung thực hoặc hành vi gian lận nhằm mục đích lừa đảo/lạm dụng tiền thưởng, sau khi được xác minh, LUCKY TOWN sẽ có quyền đóng băng lợi nhuận và số dư tài khoản có liên quan. \n\n7. Khi tham gia chương trình khuyến mãi này, bạn đồng ý với 'Tất cả các Quy tắc và Điều khoản Khuyến mãi'. \n\n8. LUCKY TOWN có quyền sửa đổi, chấm dứt hoặc giải thích cuối cùng về chương trình khuyến mãi này; và để thay đổi chương trình khuyến mãi này mà không cần thông báo. \n\n9. Nếu phát hiện cá cược bất hợp pháp, khoản tiền gửi (bao gồm số tiền lãi và tiền thưởng) sẽ bị đóng băng và hệ thống sẽ tự động xóa số tiền đó về 0.",
    vip_policy_9: "``",
    vip_policy_10: "",
    vip_accumulated_deposit: "`Tiền gửi tích lũy:`",
    vip_require_turnover: "`Yêu cầu quay vòng:`",
    change_language: "Thay đổi ngôn ngữ",
    fraud_prevention: "Phòng chống gian lận",
    fraud_prevention_desc:
      "(Bên trong nhận xét) Nếu điền những từ sau, chúng tôi sẽ xem xét nghiêm ngặt hơn và người dùng có thể không nạp tiền thành công. \nVí dụ: Bán / Mua, Cho thuê / Cho vay, Trạm viễn thông, Thu đổi ngoại tệ, Vật tư y tế, Cung cấp quần áo, Sản phẩm điện tử, Giao thông vận tải, Phụ tùng ô tô, Phụ tùng xe máy, Thương hiệu xa xỉ / Nổi tiếng, Vé xem hòa nhạc / Phiếu giảm giá, Thực phẩm / Đồ ăn nhẹ / Trái cây / Đồ uống / Sách và những thứ khác.",
    got_it: "Hiểu rồi",
    type_a_message: "Gõ một tin nhắn",
    vip_coupon: "Phiếu giảm giá VIP",
    egames_coupon: "Phiếu giảm giá trò chơi điện tử",
    reminder: "Lời nhắc nhở",
    signup_username_info:
      "Tên đăng nhập chỉ được phép bao gồm chữ cái + số và độ dài ít nhất là 8 ký tự",
    signup_password_info:
      "Mật khẩu phải có ít nhất 8 chữ số và không hỗ trợ dấu cách",
    signup_new_password_error_msg: "Mật khẩu mới phải là chữ và số. ",
    signup_password_confirm_passwors_error_msg:
      "Mật khẩu và xác nhận mật khẩu không khớp ",
    eng_text: "Tiếng Anh",
    bahasa_melayu_text: "Tiếng Mã lai",
    thai_text: "tiếng Thái Lan",
    ch_text: "tiếng Trung Quốc",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*Thời gian xử lý tiền gửi sẽ hoàn tất trong vòng 10 phút, vui lòng kiên nhẫn, cảm ơn bạn!",
    qr_description_thb:
      "*Đề xuất một người chơi mới 'đăng ký tài khoản' với số tiền ' Nạp tiền tối thiểu là 100THB ' và bạn sẽ nhận được phí 'giới thiệu' là 20THB'. \n\n*Giới thiệu thành công một 'người chơi mới', tài khoản của bạn sẽ được tự động được nâng cấp thành 'người chơi siêu hạng' và bạn có thể trích một phần trăm số tiền đặt cược hiệu quả của 'người chơi' mà bạn đề xuất.",
    total_amount: "Tổng cộng",
    transaaction_no: "Giao dịch không",
    share: "Chia sẻ",
    timer: "Hẹn giờ",
    gift: "Quà",
    schedule: "Lịch trình",
    qr_description_myr:
      "*Đề xuất một người chơi mới 'đăng ký tài khoản' với số tiền ' Nạp tiền tối thiểu là 20MYR ' và bạn sẽ nhận được phí 'giới thiệu' là 2MYR'. \n\n*Giới thiệu thành công một 'người chơi mới', tài khoản của bạn sẽ được tự động được nâng cấp thành 'người chơi siêu hạng' và bạn có thể trích một phần trăm số tiền đặt cược hiệu quả của 'người chơi' mà bạn đề xuất.",
    bonus_monthly: "Tiền thưởng (hàng tháng)",
    birthday_bonus: "tiền thưởng sinh nhật",
    withdraw_per_day: "Rút tiền mỗi ngày",
    exclusive_domain: "Tên miền độc quyền",
    deposit_priority: "Ưu tiên tiền gửi",
    festival_gift: "quà tết",
    exclusive_customer_service: "Dịch vụ khách hàng độc quyền",
    free_travel: "Du lịch miễn phí",
    vip_myr_activity_1:
      "â— Lucky Town cam kết tạo ra một nền tảng chơi trò chơi thoải mái nhưng cũng không quên tạo ra một nền tảng VIP hạng nhất mà chúng tôi đã và đang theo đuổi trong ngành.",
    vip_myr_activity_2:
      "â— Với sự tăng trưởng không ngừng của người chơi' trên nền tảng trò chơi Lucky Town, chúng tôi sẽ cung cấp cho người chơi sự chăm sóc chu đáo hơn và các hoạt động chất lượng cao hơn. Hệ thống phần thưởng mới dành cho người chơi Lucky Town đã được ra mắt. Người chơi mới và cũ cũng có thể tận hưởng nhiều ưu đãi tiền thưởng sự kiện hơn;",
    vip_myr_policy:
      "1. Điều kiện khuyến mãi: Hệ thống tự động xác định quà khuyến mãi sẽ được phát ngay sau khi nâng cấp xong. Thời hạn nhận quà là sau 14 ngày kể từ ngày phát, nếu không nhận trong thời hạn sẽ bị coi là bỏ cuộc và hệ thống sẽ tự động rút tiền. \n2. Điều kiện xuống hạng: Hệ thống tự động tích lũy xem có đủ điều kiện xuống hạng hay không. Thời gian tích lũy là ngày đầu tiên của ngày nâng hạng và sẽ được tính sau. Ví dụ: A thành viên được nâng cấp thành thành viên vàng vào ngày 3 tháng 11 và thời gian tích lũy trong hệ thống là từ ngày 3 tháng 9 lúc 12:00:01 chiều đến ngày 3 tháng 12 lúc 11:59:59 sáng, trong khoảng thời gian ba tháng (một mùa) xem có đủ điều kiện xuống hạng không. \n3. Quà sinh nhật: 3 ngày trước và sau khi nhận quà sinh nhật hoặc trong cùng ngày, bạn cần gửi ảnh CMND của mình cho bộ phận chăm sóc khách hàng để xác minh. Và tên của CMND đã xuất trình phải khớp với tên tài khoản ngân hàng của tài khoản trò chơi trước khi có thể yêu cầu. Quá thời hạn nộp đơn xin tiền quà sinh nhật sẽ được coi là bỏ cuộc. \n4. Quà tặng ngày lễ đột xuất, quà tặng ngày lễ đột xuất sẽ được gửi qua đường bưu điện hoặc tiền quà tặng. \n5. Để được đi miễn phí, bạn cần duy trì vip6 ít nhất 4 quý (12 tháng) thì mới được. Ngày khởi hành, khách sạn và vé máy bay sẽ do công ty tự chịu trách nhiệm thu xếp (không cho phép thay đổi khách sạn hoặc thay đổi vé máy bay và ngày khởi hành). \n6. Phần thưởng sự kiện trên hoặc thời gian thu tiền quà tặng là trong vòng 14 ngày sau khi phân phối. Nếu không thu thập trong thời hạn sẽ được coi là bỏ cuộc và sẽ được hệ thống tự động thu hồi. \n7. Phần thưởng hàng tuần/hàng tháng: (VIP2 / VIP3) Hàng tháng - Hoàn thành ít nhất 10 khoản tiền gửi hoặc khoản tiền gửi tích lũy là 1000 RM và số tiền luân chuyển lớn hơn 5000 để nhận được phần thưởng VIP hàng tháng. (VIP4 / VIP5 / VIP6 ) Ít nhất 1 khoản tiền gửi mỗi tuần hoặc khoản tiền gửi tích lũy 1000 RM và số tiền luân phiên từ 5000 trở lên, bạn có thể nhận được phần thưởng VIP hàng tuần \n\nã€ŠĐiều khoản sự kiệnã€‹\n1. Chương trình khuyến mãi chỉ dành cho các thành viên giải trí. Nếu phát hiện ra rằng người dùng có nhiều tài khoản, bao gồm cùng tên, cùng địa chỉ email, cùng địa chỉ IP/tương tự, cùng địa chỉ, cùng thẻ ghi nợ/thẻ tín dụng, cùng tài khoản ngân hàng, cùng máy tính, v.v. Bất kỳ hành vi cá cược bất thường nào, một khi được tìm thấy, LUCKY TOWN sẽ có quyền đóng băng lợi nhuận và số dư tài khoản của bạn. \n2. Bất kỳ cá cược, hòa, cược bảo hiểm rủi ro nào khác (cược chéo trang), cược bị từ chối, cược vô hiệu, hòa hoặc tỷ lệ cược thể thao dưới 1,5 sẽ không được tính là cược hợp lệ cần thiết cho khuyến mãi. \n3. Bất kỳ cược nào được thực hiện thông qua phần mềm bất hợp pháp của bên thứ ba như 'rô-bốt' và 'mở hai cửa sổ/nhiều cửa sổ' đều có thể bị coi là cược bất hợp pháp và LUCKY TOWN có quyền đóng băng số dư của tài khoản bị nghi ngờ và đóng tài khoản thành viên. \n4. LUCKY TOWN có quyền kiểm tra tất cả hồ sơ cá cược của thành viên. Nếu thành viên vi phạm các quy định và thể lệ của sự kiện hoặc có bất kỳ mục đích nào ngoài mục đích giải trí là sử dụng tiền thưởng để kiếm lợi nhuận, LUCKY TOWN có toàn quyền dừng, hủy bỏ hoặc đòi lại bất cứ lúc nào. Tất cả các cung cấp thanh toán. \n5. LUCKY TOWN có quyền yêu cầu thành viên gửi các giấy tờ liên quan để xác minh danh tính nếu tài khoản liên quan bị nghi ngờ bị lạm dụng và/hoặc không đủ điều kiện tham gia khuyến mãi này. \n6. Nếu bất kỳ cá nhân/nhóm/tổ chức nào bị nghi ngờ sử dụng các phương pháp không trung thực hoặc hành vi gian lận nhằm mục đích lừa đảo/lạm dụng tiền thưởng, sau khi được xác minh, LUCKY TOWN sẽ có quyền đóng băng lợi nhuận và số dư tài khoản có liên quan. \n7. Khi tham gia chương trình khuyến mãi này, bạn đồng ý với 'Tất cả các Quy tắc và Điều khoản Khuyến mãi'. \n8. LUCKY TOWN có quyền sửa đổi, chấm dứt hoặc giải thích cuối cùng về chương trình khuyến mãi này; và để thay đổi chương trình khuyến mãi này mà không cần thông báo. \n9. Nếu phát hiện cá cược bất hợp pháp, khoản tiền gửi (bao gồm số tiền lãi và tiền thưởng) sẽ bị đóng băng và hệ thống sẽ tự động xóa số tiền đó về 0. N",
    weekly: "Hàng tuần",
    withdraw_duration_text:
      "*Thời gian xử lý tiền gửi sẽ hoàn tất trong vòng 30 phút, vui lòng kiên nhẫn, xin cảm ơn!",
    hot_game: "Trò chơi hấp dẫn",
    new_games: "Những trò chơi mới",
    reset_app: "Xóa bộ nhớ cache của ứng dụng",
    reset_app_title: "Xóa dữ liệu đã lưu trong bộ nhớ cache",
    reset_app_description:
      "Bạn có chắc không? Bạn muốn xóa dữ liệu ứng dụng của mình.",
    anoucement_intro_title: "Thông báo",
    anoucement_intro_description:
      "Bạn có thể tìm thấy thông báo quan trọng ở đây.",
    game_list_intro_title: "Danh sách trò chơi",
    game_list_intro_description:
      "Tất cả các trò chơi được liệt kê ở đây, bạn có thể nhấp vào biểu tượng trò chơi để bắt đầu trò chơi.",
    topup_intro_title: "Nạp tiền/Rút tiền",
    topup_intro_description: "Đây là nơi bạn có thể nạp/rút số dư của mình.",
    leatherboard_intro_title: "Bảng xếp hạng",
    leatherboard_intro_description:
      "Những người chơi hàng đầu của tháng sẽ được liệt kê tại đây. Chi tiêu và giành giải thưởng!",
    previous_step: "Trước",
    next_step: "Kế tiếp",
    skip_step: "Nhảy",
    finish_step: "Hoàn thành",
    point_history: "Lịch sử điểm",
    points: "Điểm",
    luckytown_points: "Điểm LK",
    you_have_earned: "Bạn đã kiếm được",
    topup_info:
      "**Nếu tên thật và tên tài khoản chuyển khoản ngân hàng nộp để nạp tiền không thống nhất, công ty có quyền từ chối đơn đã nộp",
    please_upload_reciept: "Vui lòng tải biên nhận lên",
    pull_out_credit: "Rút tín dụng",
    pull_out_all_credit: "rút hết tín dụng",
    pull_out_credit_message: "Bạn có chắc chắn muốn Rút tất cả Tín dụng không?",
    topup_promotion_intro:
      "THÔNG BÁO QUAN TRỌNG: Để tham gia vào bất kỳ sự kiện đặc biệt nào, người dùng sẽ không thể sử dụng chuyển khoản QR hoặc chuyển ID cho đến khi đáp ứng các điều kiện về doanh thu của chiết khấu đã chọn. và sau khi hoàn tất việc rút tiền thông qua nền tảng, hãy đưa đến dịch vụ khách hàng và thông qua xác minh để bắt đầu chức năng chuyển QR.",
    statment: "Statement",
    withdraw_usdt: "Rút USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n\n• The minimum withdrawal amount is: 1USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    withdraw_amount: "Withdraw Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",
    game_detail: "Game Detail",
    google_auth: "Google Authentication",
    redeem: "chuộc lại",
    enter_verification_code: "Enter the 6-digit verification code",
    activate_google_auth: "Activate Google Authenticator",
    inactivate_google_auth: "In Activate Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Are you sure you want to Reset Google Authenticator?",
    activate_google_auth_msg:
      "Are you sure you want to Activate Google Authenticator?",
    register_google_auth_verification_msg:
      "Setup account with Google Auth Veririfcation ",
    scan_google_auth_msg:
      "Scan this QR Code with yoour Google Authenticator App. Alternatively, you can use this code to reset   ",
    secret_key: "Secret Key:",
    pin: "PIN",
    change_app_icon: "Change App Icon",
    change_app_icon_message: "Are you sure you want to change app icon?",
    change_app_icon_success_message: "App Icon Change Successfully",
    real_name_verification: "Real Name Verification",
    enter_real_name: "Enter Real Name",
    real_name_notes:
      "Notes:\n\n1. Add a bank account with your real-name. \n2. Choose the bank account.\n3. Fill in your real-name. \n4. Submit Verification Request. \n5. Your request will be updated within 3 working days.",
    please_login_first: "Please Login first",
    otp_prefix: "OTP Prefix",
    notification_detail: "Notification Detail",
    bonus_chips: "Bonus Chips",
    bonus: "Bonus",
    cash_wallet: "Cash Wallet",
    promotion_intro_description:
      "Hãy xem chương trình khuyến mãi mới nhất của chúng tôi tại đây.",
    looked_amount: "Số tiền bị khóa",
    current_tunrover_stake: "Yêu cầu cổ phần hiện tại/doanh thu",
    turnover_stake_remarks: "Doanh thu Cập nhật tự động trong 10 phút",
    otp_verification_text:
      "Vui lòng kiểm tra SMS điện thoại di động và nhập OTP để xác minh và ràng buộc thiết bị di động của bạn để bảo vệ bảo mật tài khoản của bạn",
    select_deposit_method: "Chọn phương thức gửi tiền ",
    user_agreement: "sự thỏa thuận của người dùng",
    no_record_found: "No Record Found",
    info: "Thông tin",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "Hướng dẫn sử dụng",
  },
  id: {
    app_name: "Lucky Town",
    login_text: "Log Masuk",
    signUp_text: "Daftar",
    welcom_text: "Selamat Datang Ke APP Lucky Town Plus",
    username_text: "Nama Pengguna",
    password_text: "Kata Laluan",
    forgotPassword_text: "Lupa Kata Laluan",
    otp_text: "OTP",
    invalid_username_or_password: "Nama Pengguna atau Kata Laluan tidak betul",
    invalid_password: "Kata Laluan tidak betul",
    invalid_data_input: "Input data tidak betul",
    invalid_phone_number: "Nombor telefon tidak betul",
    invalid_transaction_pin: "Pin Transaksi tidak betul",
    history_text: "Rekod",
    from_date: "Dari Tarikh",
    to_date: "Ke Tarikh",
    to: "Ke",
    go: "Pergi",
    select: "Pilih",
    new_account: "Akaun Baru",
    new_password: "Kata Laluan Baru",
    recommended_user: "Perujuk Pengguna",
    phone_number: "Nombor Telefon",
    confirm_password: "Sahkan Kata Laluan",
    username_or_phone_number_is_registered:
      "Nama pengguna atau nombor telefon didaftar",
    recover_password: "Menetapkan semula kata laluan",
    please_enter_phone_number:
      "Masukkan nombor telefon daftar untuk tetapan semula kata laluan",
    next: "Seterusnya",
    otp_code_resended: "Kod OTP dihantar sekali ",
    invalid_otp_code: "Kod OTP tidak betul",
    request_otp: "Minta OTP",
    please_enter_otp: "Masukkan OTP dihantar ke kaedah pengesahan anda",
    proceed: "Teruskan",
    resend_code: "Kod dihantar sekali",
    change_login_password: "Tukar kata laluan log masuk",
    select_one_of_the_cre:
      "Pilih salah satu kaedah pengesahan untuk menetapkan semula kata laluan",
    password_changed: "Kata laluan ditukar",
    congratulations_changed_password: "Taniah!Kata laluan anda ditukar",
    login_now: "Log masuk sekarang",
    discover: "Didapati",
    amount_RM: "Jumalah",
    start: "Masuk Game",
    contacts: "Hubungi",
    new_friend: "Rakan Baru",
    wallet: "Dompet",
    cash: "Tunai",
    bank_account: "Akaun Bank",
    setting: "Tetapan",
    withdraw_succ: "Pengeluaran nilai berjaya",
    top_up_succ: "Tambah nilai berjaya",
    coin: "Coin",
    interest: "Lucky Coin",
    wallet_balance: "Baki tunai",
    top_up: "Tambah nilai",
    withdraw: "Pengeluaran Nilai",
    transaction: "Transaksi",
    instant_top_up: "Tambah Nilai(Pantas)",
    top_up_bank_transfer: "Pemindahan Bank",
    error_please_try_again: "Silap,sila cuba sekali",
    top_up_RM: "Tambah Nilai",
    upload_receipt: "Upload Receipt",
    choose_upload_photo_method: "Pilih kaedah muat naik foto",
    take_picture: "Ambil gambar",
    select_from_gallery: "Pilih dari galeri",
    take_photo: "Ambil foto",
    retake: "Ambil semula",
    use_photo: "Guna foto",
    upload_bank_receipt: "Muat naik resit bank ",
    confirm_to_upload_this_photo: "Sahkan untuk memuat naik foto ini?",
    cancel: "Batal",
    confirm: "Sahkan",
    wallet_balance_not_enough: "Baki tunai tidak cukup untuk pengeluaran",
    withdraw_RM: "Pengeluaran nilai",
    no_transaction_for_dates: "Tiada transaksi untuk tarikh yang dipilih",
    please_enter_date: "Masukkan tarikh",
    all_transaction: "Semua transaksi",
    top_up_history: "Rekod tambah nilai",
    interest_account_removed: "Akaun LuckyCoin ditutup",
    interest_account_created_succ: "Akaun LuckyCoin berjaya dibuat",
    you_have_no_interest_account: "Anda tidak mempunyai akaun LuckyCoin",
    interest_history: "Rekod faedah",
    days: "Hari",
    hours: "Jam",
    create_interest: "Buat LuckyCoin",
    deposit_RM: "Deposit",
    balance_RM: "Baki",
    remove: "Tutup",
    partial_withdraw: "Pengeluaran sebahagian",
    interest_withdraw: "Pengeluaran faedah",
    add_back_account_succ: "Akaun bank berjaya ditambah ",
    edit_bank_account: "Edit akaun bank",
    bank: "Bank",
    account_name: "Nama akaun",
    account_no: "Nombor akaun",
    add_bank_account: "Tambah akaun bank",
    sign_out: "Log keluar",
    language: "Indonesia",
    clear_cache: "Padam cache",
    about: "Mengenai",
    old_password_not_match: "Kata laluan lama salah",
    old_password: "Kata laluan lama",
    back: "Kembali",
    version: "Versi",
    change_payment_pin: "Tukar pin pembayaran",
    change_nickname: "Tukar nama samaran",
    transfer: "Pindah",
    create_pin: "Buat pin transaksi",
    change_pin: "Tukar pin transaksi",
    creat_pin_description: "Buat pin 6 digit untuk transaksi anda di aplikasi",
    please_enter_pin_again: "Masukkan pin 6 digit sekali",
    pin_dont_match: "Pin salah",
    old_pin: "Pin lama",
    new_pin: "Pin baru",
    confirm_new_pin: "Sahkan pin",
    pin_max_six: "6 digit pin transaksi",
    succ_pin_change: "pin transaksi ditukar",
    congratulations_changed_pin: "Taniah!Pin transaksi anda berjaya ditukar",
    please_enter_pin: "Masukkan pin transaksi",
    forgot_pin: "Lupa pin transaksi",
    recover_transaction_pin: "Menetapkan semula pin transaksi",
    please_enter_phone_number_pin:
      "Masukan nombor telefon daftar untuk tetapan semula pin transaksi",
    old_pin_not_match: "Pin lama salah",
    new_pin_not_match: "Pin baru salah",
    transfer_RM: "Pindah",
    transfer_succ: "Pindahan berjaya",
    transfer_to: "Pindah ke",
    wallet_insuffecient_amount: "Baki tunai tidak cukup untuk dipindah",
    change_your_nickname: "Edit atau tukar nama samaran",
    nickname: "Nama samaran",
    nickname_change_succ: "Nama samaran berjaya ditukar",
    cancellation: "Pembatalan",
    confirm_to_remove_and_withdraw: "Sahkan untuk tutup dan pengeluaran nilai",
    confirm_go_back: "Sahkan untuk kembali？",
    in_game: "Dalam Game",
    close_game_first: "Sila keluar game lain dulu",
    close_game: "Tutup game",
    game_closed: "Game ditutup",
    game: "Games",
    information: "Maklumat",
    search: "Cari",
    no_user_found: "Pengguna tidak dapat dicari",
    i_have_read_and_agree: "Saya telah membaca dan bersetuju",
    LID: "LID",
    referral: "Perujuk",
    available_transfer_balance_RM: "Pemindahan yang ada",
    i_am_agreed_to_term: "Saya bersetuju terma",
    coin_transaction: "Coin transaksi",
    status: "Status",
    succ_submission_pending_review: "Hantar berjaya untuk disemak",
    leaderboard: "Papan pendahulu",
    time_zone: "Zon masa",
    customer_service: "Perkhidmatan pelanggan",
    qr_transfer: "Pemindahan dengan QR",
    top_up_details: "Maklumat tambah nilai",
    top_up_type: "Jenis tambah nilai",
    date: "Tarikh",
    receipt: "Resit",
    available_transfer: "Pemindahan yang ada",
    available_coin: "Coin yang ada",
    commission: "Komisen",
    today_stake: "Pertaruhan semasa",
    yesterday_stake: "Pertaruhan lepas",
    wallet_transaction: "Dompet transaksi",
    game_transaction: "Transaksi game",
    type: "Jenis",
    all: "Semua",
    refund: "Bayaran balik",
    penalty: "Denda",
    pick_date: "Pilih tarikh",
    time: "Masa",
    win: "Menang/Kalah",
    win_: "Menang",
    bet: "Pertaruhan",
    bet_or_transfer: "Pertaruhan/Pemindahan",
    save_in_album: "Simpan di album",
    qr_code_saved: "Kod QR disimpan",
    save_error: "Simpanan tidak berjaya",
    change_avatar: "Tukar avatar",
    avatar_changed: "Avatar ditukar",
    cant_start_game: "Game tidak dapat dimulakan ",
    details: "Butiran",
    product: "Produk",
    total_bet: "Jumlah taruhan",
    reward: "Reward",
    photo_library: "Foto galeri",
    qr_code_error: "Kesalahan kod QR",
    maintenance: "Penyelenggaraan",
    coming_soon: "Akan Datang",
    top_up_disclaimer:
      "** Harap patuhi peraturan yang disenaraikan oleh syarikat kami. Jika tidak, mata yang diberikan akan ditangguhkan. Kami mengucapkan selamat bermain, terima kasih.",
    minimum_top_up: "Minimum: ",
    maximum_top_up: "Maksimum: ",
    top_up_left_times: "Kekal: ",
    top_up_unlimited: "(Tidak terhad)",
    order_history: "Sejarah Pesanan",
    withdraw_history: "Pengeluaran Sejarah",
    no_bank_account_added: "Sila ikat sekurang-kurangnya satu akaun bank",
    minimum_withdraw: "Min: ",
    maximum_withdraw: "Max: ",
    free_withdraw_time: "Percuma kekerapan: ",
    withdraw_balance: "Baki terkini: ",
    unlimited: "Tidak terhad",
    withdraw_details: "Maklumat Pengeluaran Nilai",
    updated_date: "Tarikh dikemas kini",
    pending: "Belum selesai",
    success: "Berjaya",
    in_inspection: "Dalam pemeriksaan",
    hold: "ditahan",
    confirm_to_remove_withdraw: "Sahkan pengeluaran nilai?",
    confrim_to_remove_top_up: "Sahkan tambah nilai",
    rejected: "Ditolak",
    copied: "Disalin ke papan keratan",
    anouncement: "Pengumuman",
    contactUs: "Perkhidmatan pelanggan",
    newVersionTitle: "Versi Baru Terkini Ada",
    versionDescription:
      "Untuk menggunakan aplikasi tersebut，perlu meningkatkan aplikasi ke versi baru",
    verification: "Verifikasi",
    device_name: "Nama Telephone",
    device_info: "Info telephone",
    friend: "Sosial",
    about_phone: "Info telefon",
    remarks: "kenyataan",
    balance_transfer: "Pemindahan baki berjaya",
    usdt_top_up: "Top Up USDT",
    app_close: "Tutup",
    topupRemarks:
      "Sila nyatakan LT- (nama pengguna anda) pada slip pemindahan \nE.g. \nID: lucky town \nRefer: LTluckytown ",
    top_up_policy:
      "Syarikat kami akan menukar akaun bank dari semasa ke semasa, sila sahkan akaun terlebih dahulu di bank anda / sebelum pindahan wang. Syarikat tidak bertanggungjawab atas kerugian yang disebabkan oleh kesilapan anda.",
    notification: "Pemberitahuan",
    promotion: "Promosi",
    use_now: "Gunakan sekarang",
    promo_code: "Kod Promosi",
    enter_otp: "Sila masukkan OTP",
    change_phone_no: "Tukar nombor",
    congratulations_changed_phone: "Tahniah! anda telah berjaya tukar nombor.",
    change_your_phone: "Edit atau tukar nombor",
    default_avatar: "Default Avatar",
    forgotUsername_text: "Terlupa nama",
    authenticate: "Pengesahan",
    forgot_id_password: "Terlupa UID / Kata Laluan",
    recover_username: "Pulihkan Nama Pengguna",
    manage_account: "Tukar Akaun",
    add_another_account: "Tambah Akaun Lain",
    add_account: "Tambah Akaun",
    cashout: "Keluarkan duit",
    please_signin_to_continue: "Sila log masuk untuk meneruskan",
    no_account_found: "Tiada Akaun Ditemui",
    please_enter_phone_number_to_recover_username:
      "Sila masukkan nombor telefon berdaftar anda untuk memulihkan nama pengguna anda.",
    register_device_text:
      "Peranti ini tidak terikat dengan akaun anda. Sila daftarkan peranti untuk meneruskan",
    please_enter_txid: "Sila masukkan txid.",
    please_enter_amount: "Sila masukkan amount.",
    topUpUSDTReceipt: "Topup USDT Receipt",
    amount_usdt: "Amaun (USDT)",
    txid: "TXID",
    enter_txid: "Masukkan TXID",
    platform: "Platform",
    select_platrform: "Pilih Platform",
    request_topup_success: "Request Top Up Success.",
    chip: "Cip",
    confrim_to_remove_back_account: "Sahkan untuk mengalih keluar akaun bank?",
    footer_home: "Utama",
    footer_contact: "Contact",
    footer_transaction: "Transaksi",
    footer_me: "Profil",
    profile_cash: "Duit Tunai",
    profile_chip: "Cip",
    profile_lucky_coin: "Lucky Coin",
    profile_vip: "VIP",
    bank_search_bank: "Cari akaun bank",
    avatar_back: "Balik",
    friend_search_friend: "Cari kawan",
    friend_delete: "Padam",
    friend_title: "Tambah kawan",
    friend_popup: "Masukkan nama kawan",
    game_details_download: "Muat Turun",
    game_details_launch: "Masuk",
    game_details_transfer: "Hantar",
    qr_copy_link: "Salinan Link",
    qr_qr_share: "Kongsi QR",
    currency_exchange: "Pertukaran mata wang",
    currency_exchange_successfully: "Pertukaran Mata Wang Berjaya",
    please_select_other_currency: "Sila pilih mata wang lain untuk ditukar",
    receipt_get: "resit dapat",
    send_currency_exactly: "hantar mata wang dengan tepat",
    exchange_rate: "Kadar pertukaran",
    helpDesk: "Meja bantuan",
    topup_withdraw: "TopUp/Withdraw",
    more: "lebih",
    order: "Pesanan",
    add_friend: "Menambah rakan",
    search_friend: "Cari kawan",
    friend_added_successfully: "Rakan Berjaya Ditambah",
    please_enter_friend_name: "Sila masukkan nama rakan",
    message: "Mesej",
    qr_topup: "QR TopUp",
    qr_topup_reciept: "TopUp QR",
    transaction_process: "Urus niaga anda sedang dijalankan",
    please_allow_camera_permission: "Sila benarkan kebenaran kamera.",
    enter_game: "Masuk game",
    exit_game: "Keluar game",
    edit_nickname: "edit nama panggilan",
    max: "Max",
    stage: "pentas",
    empty_notifications: "Tiada pemberitahuan baharu.",
    model: "Model",
    device_id: "Id Peranti",
    unique_id: "Id unik",
    lt_coin: "LT Coin",
    update_now: "Kemas Kini",
    withdraw_policy:
      "Pelanggan yang dihormati, untuk mengelakkan penipuan, pelanggan mesti memastikan bahawa nama akaun deposit adalah sama dengan akaun deposit anda semasa membuat pengeluaran. Polisi ini juga untuk melindungi keselamatan dana pelanggan. Mohon maaf atas sebarang kesulitan, Terima Kasih",
    please_enter_username: "sila masukkan nama pengguna.",
    promotion_reward: "Ganjaran Kenaikan Pangkat",
    birthday_gift: "Hadiah Hari Lahir",
    daily_withdraw: "Pengeluaran Harian",
    monthly_Salary: "Gaji Bulanan Dua Kali Ganda",
    edit_bank_account_succ: "Edit bank account successfully",
    cancel_request: "Cancel Request",
    redeem_coupon: "tebus kupon",
    coupon_list: "Coupon List",
    code_redeem_success: "Code Redeem Successful",
    limitPerDay: "had pengeluaran setiap hari: ",
    approved: "Diluluskan",
    processing: "Memproses",
    got_it: "faham",
    amount_greater_then_available_balance:
      "Maaf, jumlah anda lebih besar daripada baki yang ada",
    rate: "Kadar",
    select_bank: "Pilih Bank",
    address: "Alamat",
    date_time: "Masa Tarikh",
    select_country_code: "Pilih Kod Negara",
    pick_bank: "Pilih Bank",
    balance: "Baki",
    luckytownviplabel: "Lucky Town VIP",
    vip_activity_label: "Aktiviti",
    vip_member_bonus: "Bonus Ahli VIP ",
    vip_promoted_conditions: "Syarat Yang Dipromosikan",
    vip_toa: "LuckyTown VIP Terma & Syarat",
    promoted_bonus: "Bonus Dinaikkan Pangkat",
    birthday_bonus: "Bonus hari jadi",
    withdraw_limit: "Had Pengeluaran",
    monthly_bonus: "Bonus Bulanan",
    vip_activity_1:
      "● Lucky Town is committed to creating a comfortable gaming platform but also does not forget to create a first-class VIP platform that we have been pursuing in the industry.",
    vip_activity_2:
      "● With the continuous growth of players on the Lucky Town gaming platform, we will provide players with more attentive care and higher-quality activities. A new reward system for Lucky Town players has been launched. New and old players can also enjoy more event bonus offers;",
    vip_policy_1:
      "1.System will review the member conditions on the 1st of every month to distribute promotion rewards",
    vip_policy_2:
      "2.The platform will issue twice bonus a month based on eligible member levels\nNo need to apply,and system will automatically distribute\nDistribution time: 1st and 16th of every month, Time: 2pm to 3pm\nApply conditions: Apply bonus for the 16th of the month- Must be topup from the 1st to the 15th of the month\nAt least 3 times with a single transaction exceeds THB 5000. Apply bonus for the 1st of the month- Must be topup at least 3 times with a single transaction exceeds THB 5000 from the 16th to the 30th / 31st of the previous month.",
    vip_policy_3:
      "3.If players has participate in other promotions of LuckyTown,the effective amount required for active promotions will not included in the players promoted effective amount.",
    vip_policy_4: "4.This activity is shared with the daily rebate activity.",
    vip_policy_5:
      "5.After the player is promoted in the current month, you can enjoy the promoted bonus\n(Exp: Player XXX was promoted from  VIP1 to VIP2 at the beginning of October,\nAt the beginning of October, players XXX can enjoy VIP2 promoted bonus for THB 1880 ).",
    vip_policy_6:
      "6.Birthday bonus can be applied through customer service on the day of your birthday by providing the relevant information of the player account and the scan of the ID card.",
    vip_policy_7:
      "7.Customer service manager is at your service 24 hours a day.",
    vip_policy_8:
      "8.If find that players abuse our VIP terms and maliciously use abnormal means to obtain benefits, we reserve the right to take back VIP privileges.",
    vip_policy_9:
      "`9.Once the company's risk control department detects that the player is an arbitrage player, it will give ten times turn over for withdrawal , refund the principal as a punishment.`",
    vip_policy_10:
      "10.By participating in this activity, you agree to the Rules and Regulations, and LuckyTown reserves the right to revise, stop and final interpretation of the activity.",
    vip_accumulated_deposit: "`Deposit terkumpul:`",
    vip_require_turnover: "`Keperluan peralihan:`",
    change_language: "Tukar bahasa",
    fraud_prevention: "Pencegahan Penipuan",
    fraud_prevention_desc:
      "(Dalam Catatan) Sekiranya kata-kata berikut diisi, kami akan memeriksa dengan lebih ketat dan pengguna mungkin tidak dapat menambah nilai dengan berjaya.\nContoh: Jualan / Belian, Sewa / Pinjam, Stesen telekomunikasi, Tukar mata wang, Bekalan Perubatan, Bekalan Pakaian, Produk elektronik, Pengangkutan, Bahagian kereta, Bahagian motor, Jenama mewah / Terkenal, Tiket konsert / Kupon, Makanan / Makananan ringan / Buah-buahan / Minuman/  Buku dan lain-lain",
    type_a_message: "Taip mesej",
    vip_coupon: "Kupon VIP",
    egames_coupon: "Kupon Egames",
    reminder: "Peringatan",
    signup_username_info:
      "Nama pengguna hanya dibenarkan terdiri daripada 'huruf + nombor', dan panjangnya sekurang-kurangnya 8 aksara",
    signup_password_info:
      "Kata laluan mestilah sekurang-kurangnya 8 digit, dan ruang tidak disokong",
    signup_new_password_error_msg: "Kata sandi baru harus alfanumerik. ",
    signup_password_confirm_passwors_error_msg:
      "Kata sandi dan konfirmasi kata sandi tidak cocok ",
    bahasa_melayu_text: "Bahasa Melayu",
    eng_text: "English",
    thai_text: "เปลื่ยนภาษา",
    ch_text: "中文",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*Masa pemprosesan deposit selesai dalam masa 10 minit, harap bersabar, terima kasih!",
    qr_description_thb:
      "*Syorkan pemain baru untuk 'daftar akaun' dengan minimum ' Tambah Nilai 100THB' dan anda akan mendapat ' Bonus sebanyak 20THB'. \n\n*Berjaya mengesyorkan 'pemain baru', akaun anda akan dinaik taraf secara automatik kepada 'pemain super', dan anda boleh mendapat peratusan daripada jumlah pertaruhan berkesan 'pemain' yang anda mengesyorkan",
    total_amount: "Total Amount",
    transaaction_no: "Transaction No",
    share: "Share",
    timer: "Timer",
    gift: "Gift",
    schedule: "Schedule",
    qr_description_myr:
      "*Syorkan pemain baru untuk 'daftar akaun' dengan minimum ' Tambah Nilai 20MYR' dan anda akan mendapat ' Bonus sebanyak 2MYR'. \n\n*Berjaya mengesyorkan 'pemain baru', akaun anda akan dinaik taraf secara automatik kepada 'pemain super', dan anda boleh mendapat peratusan daripada jumlah pertaruhan berkesan 'pemain' yang anda mengesyorkan",
    bonus_monthly: "Ganjaran kenaikan taraf",
    withdraw_per_day: "Pengeluaran harian",
    exclusive_domain: "Domain eksklusif",
    deposit_priority: "Keutamaan deposit",
    festival_gift: "Hadiah cuti keistimewanan",
    exclusive_customer_service: "Perkhidmatan pelanggan eksklusif",
    free_travel: "Pelancongan Percuma",
    vip_myr_activity_1:
      "● Lucky Town komited untuk mewujudkan platform permainan yang selesa, tetapi juga tidak lupa untuk melabur banyak dalam mewujudkan tempat VIP kelas pertama industri - nikmati kemewahan, capai kehormatan anda dengan keikhlasan hati, dan cipta klasik kami dengan kredibiliti anda. Memuaskan keseronokan anda adalah usaha berterusan kami. Yang mulia adalah tetamu, yang mulia adalah yang dihormati.",
    vip_myr_activity_2:
      "● Dengan pertumbuhan berterusan aktiviti ahli di platform hiburan Lucky Town，demi menyediakan ahli dengan penjagaan yang lebih prihatin dan aktiviti yang lebih baik, sistem ganjaran baharu untuk pemain Lucky Town dilancarkan. Pemain baharu dan lama juga boleh menikmati lebih banyak tawaran bonus；",
    vip_myr_policy:
      "1. Syarat promosi: Sistem secara automatik menentukan bahawa hadiah promosi akan diedarkan serta-merta selepas naik taraf selesai. Had masa untuk menerima hadiah ialah 14 hari selepas pengagihan. Kegagalan menerimanya dalam had masa akan dianggap sebagai pemberian naik dan akan ditarik balik secara automatik oleh sistem. \n2. Syarat Penyingkiran: Sistem secara automatik terkumpul sama ada kelayakan penyingkiran dipenuhi. Masa terkumpul ialah hari pertama hari naik taraf, dan ia akan dikira kemudian. Contoh: Seorang ahli dinaik taraf kepada ahli emas pada 3 November, dan masa terkumpul dalam sistem adalah dari 3 September pada 12:00:01 PM hingga 3 Disember pada 11:59:59 AM, dalam tempoh tiga bulan ( satu musim) sama ada layak ke penyingkiran. \n3. Hadiah hari jadi: 3 hari sebelum dan selepas menerima hadiah hari jadi atau pada hari yang sama, anda perlu menyerahkan gambar kad pengenalan anda kepada perkhidmatan pelanggan untuk pengesahan. Dan nama kad pengenalan yang dikemukakan mesti sepadan dengan nama akaun bank akaun permainan sebelum ia boleh dituntut. Melebihi tarikh akhir untuk memohon wang hadiah hari jadi akan dianggap sebagai menyerah kalah. \n4. Hadiah hari raya tidak teratur, hadiah hari raya tidak tetap akan diberikan melalui pos atau wang hadiah. \n5. Untuk perjalanan percuma, anda perlu mengekalkan vip6 sekurang-kurangnya 4 suku (12 bulan) sebelum anda boleh mendapatkannya.Tarikh berlepas, hotel dan tiket penerbangan akan diuruskan oleh syarikat di atas tanggungjawab sendiri (ia tidak akan diberikan untuk menukar hotel atau menukar tarikh tiket penerbangan dan tarikh berlepas). \n6. Ganjaran acara atau tempoh kutipan wang hadiah di atas adalah dalam tempoh 14 hari selepas pengedaran. Kegagalan untuk mengumpul dalam had masa akan dianggap sebagai berputus asa dan akan ditarik balik secara automatik oleh sistem. \n7. Ganjaran Mingguan/Bulanan: (VIP2 / VIP3) Bulanan - Sekurang-kurangnya 10 deposit dilengkapkan, atau deposit terkumpul ialah RM1000 dan jumlah kod efektif adalah lebih daripada 5000, untuk mendapatkan ganjaran VIP bulanan.(VIP4 / VIP5 / VIP6 ) Sekurang-kurangnya 1 deposit seminggu, atau deposit terkumpul RM1000 dan jumlah kod sah 5000 atau lebih, boleh mendapat bonus VIP mingguan. \n\n《Syarat Acara》\n1.Promosi hanya untuk ahli hiburan. Jika didapati pengguna mempunyai lebih daripada satu akaun, termasuk nama yang sama, alamat e-mel yang sama, alamat IP yang sama/serupa, alamat yang sama, kad debit/kredit yang sama , akaun bank yang sama, komputer yang sama, dsb. Sebarang tingkah laku pertaruhan yang tidak normal, setelah ditemui, LUCKY TOWN akan berhak untuk membekukan keuntungan dan baki akaun anda. \n2. Sebarang pertaruhan, seri, pertaruhan lindung nilai lain (pertaruhan merentas tapak), pertaruhan yang ditolak, pertaruhan terbatal, seri atau peluang sukan di bawah 1.5 tidak akan dikira sebagai pertaruhan sah yang diperlukan untuk promosi. \n3. Sebarang pertaruhan yang dibuat melalui perisian haram pihak ketiga seperti 'robot' dan 'membuka tingkap berganda/berbilang' boleh dianggap sebagai pertaruhan haram, dan LUCKY TOWN berhak untuk membekukan baki akaun yang disyaki dan menutup akaun ahli . \n4. LUCKY TOWN mempunyai hak untuk menyemak semua rekod pertaruhan ahli. Jika ahli melanggar peraturan dan peraturan acara atau mempunyai sebarang tujuan bukan hiburan untuk menggunakan bonus untuk membuat keuntungan, LUCKY TOWN berhak untuk menghentikan, membatalkan atau tuntut semula pada bila-bila masa. Semua tawaran telah dibayar. \n5. LUCKY TOWN berhak untuk meminta ahli mengemukakan dokumen sokongan yang berkaitan untuk mengesahkan identiti mereka jika akaun berkenaan disyaki disalahgunakan dan/atau tidak layak untuk promosi ini. \n6. Jika mana-mana individu/pasukan/organisasi disyaki menggunakan kaedah tidak jujur ​​atau tindakan penipuan untuk tujuan menipu/menyalahgunakan bonus, setelah disahkan, LUCKY TOWN akan mempunyai hak untuk membekukan keuntungan dan baki akaun yang berkaitan. \n7. Dengan menyertai promosi ini, anda bersetuju menerima 'Semua Peraturan dan Syarat Promosi' \n8. LUCKY TOWN berhak untuk menyemak, menamatkan atau tafsiran akhir promosi ini, dan membuat perubahan pada promosi ini tanpa notis. \n9.Jika pertaruhan haram ditemui, deposit (termasuk jumlah keuntungan dan bonus) akan dibekukan, dan sistem akan mengosongkannya secara automatik kepada sifar.\n",
    weekly: "Mingguan",
    withdraw_duration_text:
      "*Masa pemprosesan deposit selesai dalam masa 30 minit, harap bersabar, terima kasih!",
    hot_game: "Permainan popular",
    new_games: "Permainan Baru",
    reset_app: "Kosongkan Cache App",
    reset_app_title: "Kosongkan Data Cache",
    reset_app_description:
      "Adakah awak pasti? Anda mahu memadamkan data app anda.",
    anoucement_intro_title: "Announcement",
    anoucement_intro_description:
      "Anda boleh mendapatkan pengumuman penting di sini.",
    game_list_intro_title: "Game List",
    game_list_intro_description:
      "Semua permainan disenaraikan di sini, anda boleh mengklik ikon permainan untuk memulakan permainan.",
    topup_intro_title: "TopUp/Withdraw",
    topup_intro_description: "Anda boleh topup/withdraw nilai anda.",
    leatherboard_intro_title: "Papan Pendahulu ",
    leatherboard_intro_description:
      "Pemain terbaik bulan ini akan disenaraikan di sini. Bermain dan menangi hadiahnya!",
    previous_step: "Sebelumnya",
    next_step: "Seterusnya",
    skip_step: "Langkau",
    finish_step: "Selesai",
    point_history: "Transaksi rekod",
    points: "Points",
    luckytown_points: "LK Points",
    you_have_earned: "Anda sudah terima",
    topup_info:
      "**Sekiranya name sebenar dan name akaun pindahan bank yang dikemukakan untuk topup tidak konsisten,syarikat berhak menolak promohonan yang dikemukakan.",
    please_upload_reciept: "Sila muat nail gambar resit",
    pull_out_credit: "Pemulangan Cip Wang Wajib",
    pull_out_all_credit: "Tarik Keluar Semua Kredit",
    pull_out_credit_message:
      "Adakah anda pasti mahu Tarik Keluar semua Kredit?",
    topup_promotion_intro:
      "Pengingat penting:\nUntuk berpartisipasi dalam aktivitas prioritas apa pun, pengguna tidak akan dapat menggunakan transfer QR atau transfer ID hingga ketentuan transaksi diskon yang dipilih selesai, dan setelah penarikan melalui platform selesai, berlaku untuk layanan pelanggan dan lulus cek untuk mengaktifkan fungsi transfer QR.",
    statment: "Statement",
    withdraw_usdt: "Pengeluaran Nilai USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n\n• The minimum withdrawal amount is: 150USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    withdraw_amount: "Withdraw Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",
    google_auth: "Google Authentication",
    redeem: "menukarkan",
    enter_verification_code: "Enter the 6-digit verification code",
    activate_google_auth: "Activate Google Authenticator",
    inactivate_google_auth: "In Activate Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Are you sure you want to Reset Google Authenticator?",
    activate_google_auth_msg:
      "Are you sure you want to Activate Google Authenticator?",
    register_google_auth_verification_msg:
      "Setup account with Google Auth Veririfcation ",
    scan_google_auth_msg:
      "Scan this QR Code with yoour Google Authenticator App. Alternatively, you can use this code to reset   ",
    secret_key: "Secret Key:",
    pin: "PIN",
    change_app_icon: "Change App Icon",
    change_app_icon_message: "Are you sure you want to change app icon?",
    change_app_icon_success_message: "App Icon Change Successfully",
    real_name_verification: "Real Name Verification",
    enter_real_name: "Enter Real Name",
    real_name_notes:
      "Notes:\n\n1. Add a bank account with your real-name. \n2. Choose the bank account.\n3. Fill in your real-name. \n4. Submit Verification Request. \n5. Your request will be updated within 3 working days.",
    please_login_first: "Please Login first",
    otp_prefix: "OTP Prefix",
    notification_detail: "Notification Detail",
    bonus_chips: "Bonus Chips",
    bonus: "Bonus",
    cash_wallet: "Cash Wallet",
    promotion_intro_description: "Lihat promosi terbaru kami di sini.",
    looked_amount: "Jumlah yang terkunci",
    current_tunrover_stake: "Diperlukan tiang pancang saat ini/turnover",
    turnover_stake_remarks: "Pembaruan dalam 10 Menit",
    otp_verification_text:
      "Sila semak SMS telefon dan masukkan OTP untuk pengesahan dan mengikat telefon anda untuk melindungi keselamatan akaun anda",
    select_deposit_method: "Pilih Metode Setoran",
    user_agreement: "Perjanjian Pengguna",
    no_record_found: "No Record Found",
    info: "Informasi",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "Instruksi Pengguna",
  },
  my: {
    app_name: "Lucky Town",
    login_text: "လော့ဂ်အင်",
    signUp_text: "ဆိုင်းအပ်",
    welcom_text: "Lucky Town Plus App မှကြိုဆိုပါတယ်",
    username_text: "Username",
    password_text: "စကားဝှက်",
    forgotPassword_text: "စကားဝှက်မေ့နေပါသလား",
    otp_text: "OTP",
    invalid_username_or_password:
      "မမှန်ကန်သော အသုံးပြုသူအမည် သို့မဟုတ် စကားဝှက်",
    invalid_password: "မမှန်ကန်သောစကားဝှက်",
    invalid_data_input: "ဒေတာထည့်သွင်းမှု မမှန်ကန်ပါ",
    invalid_phone_number: "မမှန်ကန်သော ဖုန်းနံပါတ်",
    invalid_transaction_pin: "မမှန်ကန်သော ငွေပေးငွေယူ ပင်နံပါတ်",
    history_text: "မှတ်တမ်း",
    from_date: "နေ့ရက်မှ",
    to_date: "နေ့ရက်အထိ",
    to: "သို့",
    go: "သွားသည်",
    select: "ရွေးချယ်ပါ",
    new_account: "အကောင့်အသစ်",
    new_password: "စကားဝှက်အသစ်",
    recommended_user: "အကြံပြုအသုံးပြုသူ: ",
    phone_number: "ဖုန်းနံပါတ်",
    confirm_password: "စကားဝှက်အတည်ပြုခြင်း",
    username_or_phone_number_is_registered:
      "အသုံးပြုသူအမည် သို့မဟုတ် ဖုန်းနံပါတ်ကို မှတ်ပုံတင်ထားပြီး",
    recover_password: "စကားဝှက်ကိုပြန်လည်ရယူပါ",
    recover_username: "အသုံးပြုသူအမည်ကို ပြန်လည်ရယူပါ",
    please_enter_phone_number:
      "သင့်စကားဝှက်ကို ပြန်လည်ရယူရန် သင့်မှတ်ပုံတင်ထားသော ဖုန်းနံပါတ်ကို ကျေးဇူးပြု၍ ထည့်သွင်းပါ.",
    please_enter_phone_number_to_recover_username:
      "သင့်အသုံးပြုသူအမည်ကို ပြန်လည်ရယူရန် သင်၏မှတ်ပုံတင်ထားသော ဖုန်းနံပါတ်ကို ကျေးဇူးပြု၍ ထည့်သွင်းပါ.",
    please_enter_txid: "ကျေးဇူးပြုပြီး txid ထည့်ပါ.",
    next: "နောက်တစ်ခု",
    otp_code_resended: "OTP ကုဒ်ကို ပြန်ပို့သည်",
    invalid_otp_code: "မမှန်ကန်သော OTP ကုဒ်",
    request_otp: "OTP တောင်းဆိုရန်",
    please_enter_otp:
      "ကျေးဇူးပြု၍ သင်ရွေးချယ်ထားသော အထောက်အထားများထံ OTP ပေးပို့ရန် ထည့်သွင်းပါ.",
    proceed: "ဆက်လုပ်သည်",
    resend_code: "ကုဒ်ပြန်ပို့ပါ",
    change_login_password: "ဝင်ရန်စကားဝှက်ကိုပြောင်းရန်",
    select_one_of_the_cre:
      "သင့်စကားဝှက်ကို ပြန်လည်ရယူရန်အတွက် ကျွန်ုပ်တို့အသုံးပြုသင့်သည့် အထောက်အထားများထဲမှ တစ်ခုကို ရွေးပါ.",
    password_changed: "စကားဝှက်ပြောင်းထားသည်",
    congratulations_changed_password:
      "ဂုဏ်ယူပါတယ်။ သင်စကားဝှက်ကို အောင်မြင်စွာ ပြောင်းလဲလိုက်ပါပြီ.",
    login_now: "ယခုလော့ဂ်အင်ဝင်ပါ",
    discover: "ရှာဖွေတွေ့ရှိသည်",
    amount_RM: "ပမာဏ",
    start: "စတင်သည်",
    contacts: "ကျွန်ုပ်တို့ကို ဆက်သွယ်ပါ",
    new_friend: "သူငယ်ချင်းအသစ်",
    wallet: "ပိုက်ဆံအိတ်",
    cash: "ငွေသား",
    bank_account: "ဘဏ်အကောင့်",
    setting: "ဆက်တင်",
    withdraw_succ: "အောင်မြင်စွာ ထုတ်ယူခြင်း",
    top_up_succ: "အောင်မြင်စွာ ငွေဖြည့်သွင်းခြင်း",
    coin: "ဒင်္ဂါး",
    interest: "Luckyဒင်္ဂါး",
    wallet_balance: "ငွေလက်ကျန်",
    top_up: "ငွေဖြည့်ခြင်း",
    withdraw: "ငွေထုတ်ခြင်း",
    transaction: "ငွေလွှဲ",
    instant_top_up: "ချက်ချင်းငွေဖြည့်ခြင်း",
    top_up_bank_transfer: "ဘဏ်ငွေလွှဲ",
    error_please_try_again: "အမှားပါ၊ ထပ်မံ၍စမ်းကြည့်ပါ.",
    top_up_RM: "ငွေဖြည့်ခြင်း",
    upload_receipt: "ပြေစာတင်သွင်းခြင်း",
    choose_upload_photo_method: "ဓာတ်ပုံတင်ခြင်းနည်းလမ်းကို ရွေးချယ်ပါ",
    take_picture: "ဓါတ်ပုံရိုက်သည်",
    select_from_gallery: "ဓာတ်ပုံအယ်လ်ဘမ်မှရွေးချယ်ပါ",
    take_photo: "ဓါတ်ပုံရိုက်သည်",
    retake: "ပြန်ယူသည်",
    use_photo: "ဓာတ်ပုံကိုသုံးပါ",
    upload_bank_receipt: "ဘဏ်ပြေစာတင်ခြင်း",
    confirm_to_upload_this_photo: "ပယ်ဖျက်သည်?",
    cancel: "အတည်ပြုသည်",
    confirm: "ငွေလက်ကျန်ကို ထုတ်ယူရန် မလုံလောက်ပါ",
    wallet_balance_not_enough: "ငွေထုတ်ခြင်း",
    withdraw_RM: "ရွေးချယ်ထားသော ရက်စွဲများအတွက် ငွေပေးငွေယူ မရှိပါ",
    no_transaction_for_dates:
      "ရွေးချယ်ထားသော ရက်စွဲများအတွက် ငွေပေးငွေယူ မရှိတော့ပါ",
    no_more_transaction_for_dates: "ရက်စွဲများ ထည့်ပါ",
    please_enter_date: "ရက်စွဲများ ထည့်ပါ",
    all_transaction: "ငွေလွှဲမှုအားလုံး",
    top_up_history: "ငွေဖြည့်မှတ်တမ်း",
    interest_account_removed: "LuckyCoin အကောင့်ကို ဖယ်ရှားလိုက်ပြီ",
    interest_account_created_succ:
      "LuckyCoin အကောင့်ကို အောင်မြင်စွာ ဖန်တီးခဲ့သည်.",
    you_have_no_interest_account: "သင့်မှာ LuckyCoin အကောင့်မရှိပါ.",
    interest_history: "Lucky Coin မှတ်တမ်း",
    days: "ရက်စွဲများ",
    hours: "နာရီ",
    create_interest: "LuckyCoin ကိုဖန်တီးပါ",
    deposit_RM: "အပ်ငွေ",
    balance_RM: "လက်ကျန်:",
    remove: "ဖယ်ရှားသည်",
    partial_withdraw: "တစ်စိတ်တစ်ပိုင်း ထုတ်ယူခြင်း",
    interest_withdraw: "အတိုးပြန်ထုတ်ခြင်း",
    add_back_account_succ: "ဘဏ်အကောင့်ကို အောင်မြင်စွာထည့်ပါ",
    edit_bank_account: "ဘဏ်အကောင့် တည်းဖြတ်ရန်",
    bank: "ဘဏ်",
    account_name: "အကောင့်အမည်",
    account_no: "အကောင့်နံပါတ်.",
    add_bank_account: "ဘဏ်အကောင့်ထည့်ရန်",
    sign_out: "ဆိုင်းအောက်",
    language: "ဘာသာစကား",
    clear_cache: "Cache ကိုရှင်းပါ",
    about: "အကြောင်း",
    old_password_not_match: "စကားဝှက်ဟောင်းနှင့် မကိုက်ညီပါ.",
    old_password: "စကားဝှက်ဟောင်း",
    back: "နောက်သို့",
    version: "ဗားရှင်း",
    change_payment_pin: "ငွေပေးချေမှုပင်နံပါတ်ပြောင်းရန်",
    change_nickname: "အမည်ပြောင်းသည်",
    transfer: "လွှဲပြောင်းသည်",
    create_pin: "ငွေပေးငွေယူ ပင်နံပါတ် ဖန်တီးပါ",
    change_pin: "ငွေပေးငွေယူ ပင်နံပါတ်ပြောင်းရန်",
    creat_pin_description:
      "အက်ပ်တွင် သင်၏ ငွေပေးငွေယူအတွက် ဂဏန်း ၆ လုံး ပင်နံပါတ်တစ်ခု ဖန်တီးပါ",
    please_enter_pin_again: "ကျေးဇူးပြုပြီး ဂဏန်း ၆လုံး ပင်ကို ထပ်ထည့်ပါ",
    pin_dont_match: "ပင်မကိုက်ညီပါ",
    old_pin: "ပင်ဟောင်း",
    new_pin: "ပင်သစ်",
    confirm_new_pin: "ပင်ကိုအတည်ပြုပါ",
    pin_max_six: "ငွေပေးငွေယူ ပင်နံပါတ်၆လုံး",
    succ_pin_change: "ငွေပေးငွေယူပင်နံပါတ် ပြောင်းထားသည်",
    congratulations_changed_pin:
      "ဂုဏ်ယူပါတယ်။ သင်၏ ငွေပေးငွေယူပင်နံပါတ်ကို အောင်မြင်စွာ ပြောင်းလဲလိုက်ပါပြီ.",
    please_enter_pin: "ကျေးဇူးပြု၍ ငွေပေးငွေယူ ပင်နံပါတ်ထည့်ပါ",
    forgot_pin: "ငွေပေးငွေယူ ပင်နံပါတ် မေ့နေသည်",
    recover_transaction_pin: "ငွေသွင်းငွေထုတ်ပင်ကို ပြန်လည်ရယူရန်",
    please_enter_phone_number_pin:
      "သင်၏ ငွေပေးငွေယူ ပင်နံပါတ်ကို ပြန်လည်ရယူရန် သင်၏ စာရင်းသွင်းထားသော ဖုန်းနံပါတ်ကို ထည့်ပါ.",
    old_pin_not_match: "ပင်ဟောင်းမကိုက်ညီပါ",
    new_pin_not_match: "ပင်သစ်မကိုက်ညီပါ",
    transfer_RM: "လွှဲပြောင်းသည်",
    transfer_succ: "အောင်မြင်စွာ လွှဲပြောင်းခြင်း",
    transfer_to: "လွှဲပြောင်းရန်: ",
    wallet_insuffecient_amount: "ငွေလက်ကျန်ငွေလွှဲရန် မလုံလောက်ပါ.",
    change_your_nickname: "သင်၏အမည်ပြောင်ကို တည်းဖြတ်ပါ သို့မဟုတ် ပြောင်းပါ",
    nickname: "အမည်ပြောင်",
    fullname: "အမည်အပြည့်အစုံ",
    nickname_change_succ: "အမည်ပြောင်ကို အောင်မြင်စွာပြောင်းပြီးပါသည်",
    cancellation: "ပယ်ဖျက်ခြင်း",
    confirm_to_remove_and_withdraw: "ဖယ်ရှားရန်နှင့် ရုပ်သိမ်းရန် အတည်ပြုရန်",
    confirm_go_back: "နောက်ပြန်ဖို့ အတည်ပြုမလား?",
    in_game: "ဂိမ်းထဲမှာ",
    close_game_first: "ကျေးဇူးပြုပြီး တခြားဂိမ်းတွေကို အရင်ထွက်လိုက်ပါ",
    close_game: "ဂိမ်းပိတ်ပါ",
    game_closed: "ဂိမ်းပိတ်ပြီးပါသည်",
    game: "ဂိမ်းများ",
    information: "သတင်းအချက်အလက်",
    search: "ရှာဖွေသည်",
    no_user_found: "အသုံးပြုသူကို ရှာမတွေ့ပါ",
    i_have_read_and_agree: "ဖတ်ပြီး သဘောတူပါသည်",
    LID: "LID",
    referral: "ရည်ညွှန်းချက်",
    available_transfer_balance_RM: "ရရှိနိုင်သောလွှဲပြောင်းမှု",
    i_am_agreed_to_term: "ဤအချက်အလက်ကိုသဘောတူညီပါသည်",
    coin_transaction: "အကြွေစေ့အရောင်းအ၀ယ်",
    status: "အဆင့်အတန်း",
    succ_submission_pending_review:
      "အောင်မြင်သော တင်ပြမှုကို ဆိုင်းငံ့ထားသော ပြန်လည်သုံးသပ်ခြင်း",
    leaderboard: "ခေါင်းဆောင်ဘုတ်",
    time_zone: "စံတော်ချိန်",
    customer_service: "ဧည့်ဝန်ဆောင်မှု",
    qr_transfer: "QR လွှဲပြောင်းခြင်း",
    top_up_details: "ငွေဖြည့်အသေးစိတ်",
    top_up_type: "ငွေဖြည့်အမျိုးအစား",
    date: "ရက်စွဲ",
    receipt: "ပြေစာ",
    available_transfer: "ရနိုင်သော လွှဲပြောင်းမှု",
    available_coin: "ရနိုင်သောဒင်္ဂါး",
    commission: "ကော်မရှင်",
    today_stake: "ယနေ့လောင်းကြေး",
    yesterday_stake: "မနေ့ကလောင်းကြေး",
    wallet_transaction: "ပိုက်ဆံအိတ်ငွေလွှဲခြင်း",
    game_transaction: "ဂိမ်းငွေလွှဲခြင်း",
    type: "အမျိုးအစား",
    all: "အားလုံး",
    refund: "ပြန်အမ်းငွေ",
    penalty: "ပြစ်ဒဏ်",
    pick_date: "ရက်စွဲရွေးချယ်သည်",
    time: "အချိန်",
    win: "အနိုင်/အရှုံး",
    win_: "နိုင်သည်",
    bet: "လောင်းကစား",
    bet_or_transfer: "လောင်းကြေး/ငွေလွှဲခြင်း",
    save_in_album: "အယ်လ်ဘမ်တွင်သိမ်းဆည်းရန်",
    qr_code_saved: "QR ကုဒ်ကို သိမ်းဆည်းပြီးပြီ",
    save_error: "အမှားကိုသိမ်းဆည်းပါ",
    change_avatar: "ရုပ်ပွားပုံပြောင်းရန်",
    avatar_changed: "ကိုယ်ပွား ပြောင်းသွားပြီ",
    cant_start_game: "ဂိမ်းစတင်၍မရပါ",
    details: "အသေးစိတ်",
    product: "ထုတ်ကုန်",
    total_bet: "စုစုပေါင်းလောင်းကြေး",
    total: "စုစုပေါင်း",
    reward: "ဆုလာဘ်",
    photo_library: "ဓာတ်ပုံစာကြည့်တိုက်",
    qr_code_error: "QR ကုဒ်အမှား",
    maintenance: "ပြုပြင်ထိန်းသိမ်းခြင်း",
    coming_soon: "မကြာမီလာမည်",
    top_up_disclaimer:
      "ကျေးဇူးပြု၍ ကျွန်ုပ်တို့၏ ကုမ္ပဏီမှ ဖော်ပြထားသော စည်းမျဉ်းများကို လိုက်နာပါ။ သို့မဟုတ်ပါက ပေးထားသော အမှတ်များ နှောင့်နှေးသွားပါမည်။ ပျော်ရွှင်ဖွယ် ဂိမ်းတစ်ခု ဖြစ်ပါစေကြောင်း ဆုမွန်ကောင်း တောင်းအပ်ပါသည်။.",
    minimum_top_up: "အနည်းဆုံး: ",
    maximum_top_up: "အများဆုံး: ",
    top_up_left_times: "လက်ကျန်အချိန်များ:",
    top_up_unlimited: "အကန့်အသတ်မရှိ",
    order_history: "အော်ဒါမှတ်တမ်း",
    withdraw_history: "ငွေထုတ်မှတ်တမ်း",
    no_bank_account_added: "အနည်းဆုံး ဘဏ်အကောင့်တစ်ခု ချိတ်ပါ",
    minimum_withdraw: "အနည်းဆုံး: ",
    maximum_withdraw: "အများဆုံး: ",
    free_withdraw_time: "အားလပ်ချိန်များ: ",
    withdraw_balance: "လက်ကျန်ငွေ: ",
    unlimited: "အကန့်အသတ်မရှိ",
    withdraw_details: "ငွေထုတ်ခြင်းအသေးစိတ်",
    updated_date: "မွမ်းမံထားသောရက်စွဲ",
    pending: "ဆိုင်းငံ့",
    success: "အောင်မြင်သည်",
    in_inspection: "စစ်ဆေးခြင်း",
    hold: "ကိုင်ထားသည်",
    confirm_to_remove_withdraw: "ရုပ်သိမ်းရန် အတည်ပြုမလား?",
    confrim_to_remove_top_up: "ငွေဖြည့်သွင်းခြင်းကို ဖယ်ရှားရန် အတည်ပြုမလား?",
    rejected: "ငြင်းပယ်သည်",
    copied: "ကလစ်ဘုတ်သို့ ကူးယူထားသည်",
    anouncement: "ကြေငြာချက်",
    contactUs: "ကျွန်ုပ်တိုကိုဆက်သွယ်ရန်",
    newVersionTitle: "ဗားရှင်းအသစ် ရပါပြီ",
    versionDescription:
      "ဆက်လုပ်ရန်၊ သင့်အက်ပ်ကို နောက်ဆုံးဗားရှင်းသို့ အပ်ဒိတ်လုပ်ပါ",
    verification: "စိစစ်ခြင်း",
    register_device_text:
      "ဤစက်ပစ္စည်းသည် သင့်အကောင့်နှင့် ချိတ်ဆက်ထားခြင်းမရှိပါ။ ကျေးဇူးပြု၍ ဆက်လက်ဆောင်ရွက်ရန် စက်ပစ္စည်းကို စာရင်းသွင်းပါ",
    device_name: "စက်ပစ္စည်းအမည်",
    device_info: "စက်ပစ္စည်းအချက်အလက်",
    friend: "သူငယ်ချင်း",
    about_phone: "ဖုန်းအကြောင်း",
    remarks: "မှတ်ချက်",
    balance_transfer: "လက်ကျန်ငွေလွှဲပြောင်းမှု အောင်မြင်သည်",
    usdt_top_up: "USDT ငွေဖြည့်သွင်းခြင်း",
    app_close: "ပိတ်သည်",
    topupRemarks:
      "ငွေလွှဲစလစ်တွင် LT- (သင့်အသုံးပြုသူအမည်) ကို သတ်မှတ်ပေးပါ \nE.g. \nID- lucky town\nရည်ညွှန်း- LTluckytown",
    top_up_policy:
      "ကျွန်ုပ်တို့၏ကုမ္ပဏီသည် ဘဏ်အကောင့်ကို အခါအားလျော်စွာ ပြောင်းလဲပေးပါမည်။ ငွေပေးချေမှုမပြုလုပ်မီ သင့်ဘဏ်တွင် အကောင့်ကို ကြိုတင်အတည်ပြုပေးပါ။ သင့်အမှားကြောင့် ဆုံးရှုံးမှုများအတွက် ကုမ္ပဏီမှ တာဝန်ယူမည်မဟုတ်ပါ။",
    notification: "အကြောင်းကြားစာ",
    empty_notifications: "အကြောင်းကြားချက်အသစ်များ မရှိပါ။.",
    promotion: "ပရိုမိုးရှင်း",
    use_now: "ယခုသုံးပါ",
    promo_code: "ပရိုမိုကုဒ်",
    enter_otp: "ကျေးဇူးပြု၍ OTP ထည့်ပါ",
    change_phone_no: "ဖုန်းနံပါတ်ပြောင်းရန်",
    change_your_phone: "သင့်ဖုန်းနံပါတ်ကို တည်းဖြတ်ပါ သို့မဟုတ် ပြောင်းလဲပါ",
    congratulations_changed_phone:
      "ဂုဏ်ယူပါတယ်သင့်ဖုန်းနံပါတ်ကို အောင်မြင်စွာ ပြောင်းလဲလိုက်ပါပြီ။.",
    default_avatar: "ပုံသေရုပ်ပွားတော်",
    forgotUsername_text: "အသုံးပြုသူအမည်မေ့နေသည်",
    authenticate: "အတည်ပြုခြင်း",
    forgot_id_password: "UID/စကားဝှက် မေ့နေသည်",
    manage_account: "အကောင့်ပြောင်းရန်",
    add_another_account: "အခြားအကောင့်ထည့်ပါ",
    add_account: "အကောင့်ထည့်ပါ",
    cashout: "ငွေရှင်း",
    please_signin_to_continue: "ဆက်လုပ်ရန် ကျေးဇူးပြု၍ ဆိုင်းအင်ဝင်ပါ",
    no_account_found: "အကောင့်ရှာမတွေ့ပါ",
    please_enter_amount: "ကျေးဇူးပြု၍ ပမာဏထည့်ပါ။.",
    topUpUSDTReceipt: "ငွေဖြည့် USDT ပြေစာ",
    amount_usdt: "ငွေပမာဏ (USDT)",
    txid: "TXID",
    enter_txid: "TXID ထည့်ပါ",
    platform: "ပလပ်ဖောင်း",
    select_platrform: "ပလပ်ဖောင်းကိုရွေးချယ်ပါ",
    request_topup_success: "ငွေဖြည့်သွင်းခြင်း အောင်မြင်မှုကို တောင်းဆိုပါ.",
    chip: "ချစ်ပ်",
    confrim_to_remove_back_account: "ဘဏ်အကောင့်ကို ဖယ်ရှားကြောင်း အတည်ပြုပါ",
    footer_home: "ပင်မစာမျက်နှာ",
    footer_contact: "အဆက်အသွယ်များ",
    footer_transaction: "ငွေလွှဲ",
    footer_me: "ကျွန်ုပ်",
    profile_cash: "ငွေသား",
    profile_chip: "ချစ်ပ်",
    profile_luck: "Lucky Coin",
    profile_vip: "VIP",
    bank_search_bank: "ဘဏ်ရှာဖွေသည်",
    avatar_back: "ဘဏ်",
    friend_search_friend: "သူငယ်ချင်းရှာဖွေသည်",
    friend_delete: "ဖျက်သည်",
    friend_title: "သူငယ်ချင်းအပ်သည်",
    friend_popup: "သူငယ်ချင်းနာမည်ထည့်ပါ",
    game_details_download: "ဒေါင်းလုဒ်",
    game_details_launch: "ပစ်လွှတ်ခြင်း",
    game_details_transfer: "လွှဲပြောင်းသည်",
    qr_copy_link: "လင့်ခ်ကို ကူးယူပါ",
    qr_qr_share: "QR မျှဝေရန်",
    profile_lucky_coin: "Lucky Coin",
    currency_exchange: "ငွေကြေးလဲလှယ်မှု",
    currency_exchange_successfully: "ငွေကြေးလဲလှယ်မှု အောင်မြင်သည်",
    please_select_other_currency: "လဲလှယ်ရန် အခြားငွေကြေးကို ရွေးချယ်ပါ",
    receipt_get: "လက်ခံသူ ရယူသည်",
    send_currency_exactly: "သင်အတိအကျ ပို့သည်",
    exchange_rate: "ငွေလဲလှယ်နှုန်း",
    helpDesk: "အကူအညီပေးရေးဌာန",
    topup_withdraw: "ငွေဖြည့်သွင်း/ငွေထုတ်ခြင်း",
    more: "နောက်ထပ်",
    order: "အော်ဒါ",
    add_friend: "သူငယ်ချင်းအပ်သည်",
    search_friend: "သူငယ်ချင်းရှာဖွေသည်",
    friend_added_successfully: "သူငယ်ချင်းကို အောင်မြင်စွာ ပေါင်းထည့်လိုက်သည်",
    please_enter_friend_name: "ကျေးဇူးပြုပြီး သူငယ်ချင်းနာမည်ထည့်ပါ",
    message: "မက်ဆေ့ခ်ျ",
    home: "ပင်မစာမျက်နှာ",
    contact: "ဆက်သွယ်ရန်",
    qr_topup: "QRငွေဖြည့်",
    qr_topup_reciept: "ငွေဖြည့်QR",
    transaction_process: "သင်၏ ငွေပေးငွေယူ လုပ်ဆောင်နေသည်",
    please_allow_camera_permission: "ကျေးဇူးပြုပြီး ကင်မရာခွင့်ပြုချက်ပေးပါ.",
    enter_game: "ဂိမ်းဝင်ပါ",
    exit_game: "ဂိမ်းထွက်ရန်",
    edit_nickname: "အမည်ပြောင် တည်းဖြတ်ရန်",
    model: "မော်ဒယ်",
    device_id: "စက်ပစ္စည်း ID",
    unique_id: "ထူးခြားသော ID",
    lt_coin: "LT Coin",
    stage: "စင်မြင့်",
    update_now: "ယခု အပ်ဒိတ်လုပ်ပါ",
    withdraw_policy:
      "ချစ်ခင်ရပါသော Customer များ ၊ လိမ်လည်မှုမှ ကာကွယ်ရန်အတွက် ဖောက်သည်များသည် ငွေထုတ်သည့်အခါတွင် သင့်ဘဏ်ကိုင်ဆောင်သူအမည်သည် သင့်အပ်ငွေအကောင့်နှင့် တူညီကြောင်း သေချာစေရပါမည်။ ဤမူဝါဒသည် ဖောက်သည်၏ရန်ပုံငွေလုံခြုံရေးကို ကာကွယ်ပေးပါသည်။ အဆင်မပြေမှုများအတွက် တောင်းပန်အပ်ပါသည်။",
    max: "အများဆုံး",
    promotion_reward: "ပရိုမိုးရှင်းဆု",
    birthday_gift: "မွေးနေ့လက်ဆောင်",
    daily_withdraw: "နေ့စဉ် အများဆုံး ငွေထုတ်ခြင်း",
    monthly_Salary: "လစဉ်လစာ နှစ်ဆ",
    edit_bank_account_succ: "ဘဏ်အကောင့်ကို အောင်မြင်စွာ တည်းဖြတ်ပါပြီ",
    cancel_request: "ပယ်ဖျက်ရန် တောင်းဆိုချက်",
    redeem_coupon: "ကူပွန်ကို ရွေးပါ",
    coupon_list: "ကူပွန်စာရင်း",
    code_redeem_success: "ကုဒ်သုံးငွေလဲလှယ်မှုအောင်မြင်သည်",
    please_enter_username: "ကျေးဇူးပြု၍ အသုံးပြုသူအမည်ထည့်ပါ.",
    limitPerDay: "တစ်ရက် ကန့်သတ်ချက်: ",
    approved: "အတည်ပြုခဲ့သည်",
    processing: "လုပ်ဆောင်နေသည်",
    got_it: "နားလည်ပြီ",
    amount_greater_then_available_balance:
      "ဝမ်းနဲပါတယ်။သင့်ပမာဏသည်ရနိုင်သည့်လက်ကျန်ငွေထက်ပိုများနေသည်",
    rate: "နှုန်း",
    select_bank: "ဘဏ်ကိုရွေးချယ်ပါ",
    address: "လိပ်စာ",
    date_time: "ရက်စွဲအချိန်",
    amount_myr: "ပမာဏ(MYR)",
    select_country_code: "နိုင်ငံကုဒ်ကို ရွေးပါ",
    pick_bank: "ဘဏ်ရွေး",
    balance: "လက်ကျန်",
    luckytownviplabel: "Lucky Town VIP",
    vip_activity_label: "လှုပ်ရှားမှု",
    vip_member_bonus: "VIP အဖွဲ့ဝင်ဆုကြေ",
    vip_promoted_conditions: "ပရိုမိုးရှင်းအခြေအနေများ",
    vip_toa: "Lucky Town VIP သက်တမ်းနှင့် အခြေအနေ",
    promoted_bonus: "ပရိုမိုးရှင်းအပိုဆု",
    birthday_bonus: "မွေးနေ့အပိုဆု",
    withdraw_limit: "ငွေထုတ်ကန့်သတ်ချက်",
    monthly_bonus: "လစဉ်အပိုဆု",
    vip_activity_1:
      "● Lucky Town သည် သက်သောင့်သက်သာရှိသော ဂိမ်းပလက်ဖောင်းကို ဖန်တီးရန် ကတိပြုထားသော်လည်း စက်မှုလုပ်ငန်းတွင် ကျွန်ုပ်တို့လိုက်ရှာနေသည့် ပထမတန်းစား VIP ပလပ်ဖောင်းကို ဖန်တီးရန်လည်း မမေ့ပါနှင့်။.",
    vip_activity_2:
      "●Lucky Town ဂိမ်းပလက်ဖောင်းတွင် ကစားသမားများ၏ စဉ်ဆက်မပြတ် ကြီးထွားလာမှုနှင့်အတူ ကစားသမားများအား ပိုမိုဂရုစိုက်ဂရုစိုက်ပြီး အရည်အသွေးမြင့်သည့် လုပ်ဆောင်ချက်များကို ပံ့ပိုးပေးပါမည်။ Lucky Town ကစားသမားများအတွက် ဆုပေးစနစ်အသစ်ကို စတင်လိုက်ပါပြီ။ ကစားသမားဟောင်းများနှင့် ကစားသမားသစ်များလည်း အသုံးပြုနိုင်ပါပြီ။ အစီအစဉ်အပိုဆုကြေးများကို ပိုမိုခံစားပါ;",
    vip_policy_1:
      "1. ပရိုမိုးရှင်းအခြေအနေများ- ပရိုမိုးရှင်းလက်ဆောင်ကို အဆင့်မြှင့်ပြီးသည်နှင့် ချက်ချင်းဖြန့်ဝေမည်ဖြစ်ကြောင်း စနစ်က အလိုအလျောက် ဆုံးဖြတ်ပေးပါသည်။ လက်ဆောင်လက်ခံရရှိမည့်အချိန်ကန့်သတ်ချက်မှာ ဖြန့်ဖြူးပြီး 14 ရက်အတွင်း ဖြစ်ပါသည်။ သတ်မှတ်ချိန်အတွင်း ၎င်းကို လက်ခံရရှိရန် ပျက်ကွက်ပါက သတ်မှတ်ခံရမည်ဖြစ်ပါသည်။ စွန့်စားပြီး စနစ်ဖြင့် အလိုအလျောက် ထုတ်ယူပါမည်။.",
    vip_policy_2:
      "2. တန်းဆင်းရေး အခြေအနေ- တန်းဆင်းခွင့် အရည်အချင်း ပြည့်မီခြင်း ရှိ/မရှိ စနစ်သည် အလိုအလျောက် စုဆောင်းပေးပါသည်။ စုဆောင်းချိန်သည် အဆင့်မြှင့်သည့်နေ့၏ ပထမနေ့ဖြစ်ပြီး ၎င်းကို နောက်ပိုင်းတွင် တွက်ချက်ပါမည်။ ဥပမာ- အဖွဲ့ဝင်တစ်ဦးအား နိုဝင်ဘာလ 3 ရက်နေ့တွင် ရွှေအဖွဲ့ဝင်အဖြစ် အဆင့်မြှင့်ထားသည်နှင့် စနစ်တွင် စုဆောင်းသည့်အချိန်သည် စက်တင်ဘာ 3 ရက်မှ 12:00:01 PM မှ ဒီဇင်ဘာ 3 ရက် 11:59:59 AM၊ တန်းဆင်းရန် အရည်အချင်းပြည့်မီခြင်းရှိမရှိ သုံးလ (ရာသီတစ်ခု) ကာလအတွင်း။.",
    vip_policy_3:
      "3. မွေးနေ့လက်ဆောင်- မွေးနေ့လက်ဆောင်မရရှိမီနှင့် 3 ရက်အကြာတွင် သို့မဟုတ် ထိုနေ့တွင် သင်၏ ID ကတ်ဓာတ်ပုံကို စိစစ်ရန်အတွက် ဖောက်သည်ဝန်ဆောင်မှုထံသို့ ပေးပို့ရန်လိုအပ်ပါသည်။ ပေးအပ်ထားသည့် ID ကတ်၏အမည်သည် အဆိုပါအမည်နှင့် ကိုက်ညီရမည်ဖြစ်သည်။ ဂိမ်းအကောင့်၏ ဘဏ်အကောင့်ကို တောင်းဆို၍မရမီ မွေးနေ့လက်ဆောင်ငွေကို လျှောက်ထားရန် သတ်မှတ်ရက်ထက် ကျော်လွန်သွားပါက စွန့်လွှတ်ခြင်းဟု သတ်မှတ်သည်။.",
    vip_policy_4:
      "4. ၄။ ပုံမှန်အားလပ်ရက် လက်ဆောင်များ၊ ပုံမှန်မဟုတ်သော အားလပ်ရက် လက်ဆောင်များကို စာတိုက် သို့မဟုတ် လက်ဆောင်ငွေဖြင့် ပေးအပ်ပါမည်။.",
    vip_policy_5:
      "5. 5. အခမဲ့ခရီးသွားလာခွင့်အတွက်၊ သင်မရရှိနိုင်မီ အနည်းဆုံး 4 လေးပုံ (12 လ) vip6 ကို ထိန်းသိမ်းထားရန် လိုအပ်ပါသည်။ ထွက်ခွာမည့်ရက်၊ ဟိုတယ်နှင့် လေယာဉ်လက်မှတ်တို့ကို ကုမ္ပဏီမှ ၎င်း၏တစ်ဦးတည်းတာဝန်ဖြင့် စီစဉ်ပေးမည် (ထိုသို့မဟုတ်ပါက၊ ဟိုတယ်ပြောင်းရန် သို့မဟုတ် လေယာဉ်လက်မှတ်ရက်စွဲနှင့် ထွက်ခွာမည့်ရက်ကို ပြောင်းလဲရန်).",
    vip_policy_6:
      "၆။ အထက်ဖော်ပြပါ အစီအစဉ် ဆုလက်ဆောင်များ သို့မဟုတ် လက်ဆောင်ငွေ ကောက်ခံမှု ကာလသည် ဖြန့်ချီပြီး 14 ရက်အတွင်း ဖြစ်ပါသည်။ သတ်မှတ်ချိန်အတွင်း ကောက်ခံရန် ပျက်ကွက်ခြင်းကို စွန့်လွှတ်ခြင်းအဖြစ် သတ်မှတ်ပြီး စနစ်ဖြင့် အလိုအလျောက် ထုတ်ယူမည်ဖြစ်ပါသည်။.",
    vip_policy_7:
      "7. အပတ်စဉ်/လစဉ် ဆုလာဘ်များ- (VIP2/VIP3) လစဉ် - အနည်းဆုံး အပ်ငွေ 10 ခု ပြီးပါပြီ၊ သို့မဟုတ် စုဆောင်းငွေမှာ ဘတ် 8000 ဖြစ်ပြီး လစဉ် VIP ဆုကြေးကို ရယူရန်အတွက် လစဉ် VIP ဆုငွေ 40,000 ကျော် ဖြစ်ပါသည်။ (VIP4 / VIP5 / VIP6 ) တစ်ပတ်လျှင် အနည်းဆုံး စပေါ်ငွေ 1 ခု သို့မဟုတ် စုဆောင်းအပ်ငွေ THB8000 နှင့် အလှည့်ကျ ပမာဏ 40,000 နှင့်အထက် အပတ်စဉ် VIP ဘောနပ်စ်ကို ရနိုင်သည်",
    vip_policy_8:
      "ã€ŠEvent Termsã€‹ \n\n1။ ပရိုမိုးရှင်းသည် ဖျော်ဖြေရေးအဖွဲ့ဝင်များအတွက်သာဖြစ်သည်။ အသုံးပြုသူတွင် အမည်တူ၊ အီးမေးလ်လိပ်စာ၊ တူညီသော/အလားတူ IP လိပ်စာအပါအဝင် အကောင့်တစ်ခုထက်ပို၍ရှိကြောင်း တွေ့ရှိပါက၊ တူညီသောလိပ်စာ၊ တူညီသောဒက်ဘစ်/ခရက်ဒစ်ကတ်၊ ဘဏ်အကောင့်တစ်ခုတည်း၊ တူညီသောကွန်ပျူတာစသည်ဖြင့် ပုံမှန်မဟုတ်သော လောင်းကစားအပြုအမူကို တွေ့ရှိပါက LUCKY TOWN သည် သင့်အကောင့်၏ အမြတ်ငွေနှင့် လက်ကျန်ငွေကို ရပ်တန့်စေမည့်အခွင့်အရေးကို သိမ်းဆည်းထားမည်ဖြစ်သည်။ \n\n2။ မည်သည့် လောင်းကစား၊ သရေပွဲ၊ အခြားသော အကာအကွယ်ပေးထားသည့် လောင်းကြေးများ (ဆိုက်စုံလောင်းကစား)၊ ပယ်ချထားသော လောင်းကစားများ၊ ပျက်ပြယ်သော လောင်းကြေးများ၊ ဂိမ်းများ သို့မဟုတ် 1.5 အောက်ရှိ အားကစားဆိုင်ရာ ပေါက်ကြေးများကို ပရိုမိုးရှင်းအတွက် လိုအပ်သော တရားဝင်လောင်းကြေးများအဖြစ် ထည့်သွင်းရေတွက်မည်မဟုတ်ပါ။ \n\n3. ပြင်ပကုမ္ပဏီမှတစ်ဆင့် ပြုလုပ်သော အလောင်းအစားများ 'စက်ရုပ်များ' နှင့် 'နှစ်ထပ်/ပြတင်းပေါက်အများအပြားဖွင့်ခြင်း' ကဲ့သို့သော တရားမဝင်ဆော့ဖ်ဝဲများကို တရားမဝင် အလောင်းအစားများအဖြစ် မှတ်ယူနိုင်ပြီး LUCKY TOWN သည် သံသယရှိအကောင့်၏ လက်ကျန်ငွေကို အေးခဲပြီး အဖွဲ့ဝင်အကောင့်ကို ပိတ်ရန် အခွင့်အရေးကို လက်ဝယ်ရှိပါသည်။ \n\n4။ LUCKY TOWN တွင် ရှိသည်။ အဖွဲ့ဝင်လောင်းကစားမှတ်တမ်းအားလုံးကို စစ်ဆေးပိုင်ခွင့်ရှိသည်။ အသင်းဝင်တစ်ဦးသည် ပွဲ၏ စည်းမျဉ်းများနှင့် စည်းမျဉ်းများကို ချိုးဖောက်ပါက သို့မဟုတ် ဇ၊ အမြတ်အစွန်းများရရှိရန် ဘောနပ်စ်များကိုအသုံးပြုခြင်း၏ ဖျော်ဖြေရေးမဟုတ်သောရည်ရွယ်ချက်ကြောင့် LUCKY TOWN သည် အချိန်မရွေး ရပ်တန့်ရန်၊ ပယ်ဖျက်ရန် သို့မဟုတ် ပြန်လည်တောင်းဆိုရန် အခွင့်အရေးအားလုံးကို လက်ဝယ်ရှိပါသည်။ ကမ်းလှမ်းချက်များအားလုံးကို ပေးဆောင်ခဲ့သည်။ \n\n၅။ LUCKY TOWN သည် သက်ဆိုင်ရာအကောင့်အား အလွဲသုံးစားလုပ်နေသည်ဟု သံသယရှိကာ ဤပရိုမိုးရှင်းအတွက် အရည်အချင်းမပြည့်မီပါက သက်ဆိုင်ရာ စာရွက်စာတမ်းများ တင်ပြရန် အဖွဲ့ဝင်များထံ တောင်းဆိုပိုင်ခွင့်ကို လက်ဝယ်ရှိပါသည်။ \n\n၆။ အကယ်၍ တစ်ဦးချင်း/အဖွဲ့/အဖွဲ့အစည်းသည် ဘောနပ်စ်များကို အလွဲသုံးစားလုပ်ခြင်း/အလွဲသုံးစားလုပ်ခြင်းအတွက် မရိုးမသားနည်းလမ်းများ သို့မဟုတ် လိမ်လည်လှည့်ဖြားသည့် လုပ်ရပ်များကို အသုံးပြုသည်ဟု သံသယရှိပါက စစ်ဆေးပြီးသည်နှင့်၊ LUCKY TOWN သည် သက်ဆိုင်ရာအကောင့်၏ အမြတ်ငွေများနှင့် လက်ကျန်များကို ရပ်တန့်ပိုင်ခွင့်ရှိသည်။ \n\n၇။ ဤပရိုမိုးရှင်းတွင် ပါဝင်ခြင်းဖြင့် သင်သည် 'ပရိုမိုးရှင်း၏ စည်းမျဉ်းများနှင့် စည်းကမ်းချက်များ' အားလုံးကို သဘောတူပါသည်။ \n\n၈။ LUCKY TOWN သည် ဤပရိုမိုးရှင်း၏ ပြန်လည်ပြင်ဆင်ခြင်း၊ ရပ်စဲခြင်း သို့မဟုတ် နောက်ဆုံးအဓိပ္ပာယ်ဖွင့်ဆိုခွင့်ကို လက်ဝယ်ရှိပါသည်။ အသိပေးခြင်းမရှိဘဲ ဤပရိုမိုးရှင်းကို အပြောင်းအလဲပြုလုပ်ရန်။ \n\n၉။ တရားမဝင်လောင်းကစားတွေ့ရှိပါက အပ်ငွေ (အမြတ်ငွေပမာဏနှင့် အပိုဆုများအပါအဝင်) ရပ်တန့်သွားမည်ဖြစ်ပြီး၊ စနစ်က ၎င်းအား သုညအထိ အလိုအလျောက်ရှင်းပေးမည်ဖြစ်သည်။.",
    vip_policy_9: "``",
    vip_policy_10: "",
    vip_accumulated_deposit: "`စုဆောင်းအပ်ငွေ:`",
    vip_require_turnover: "`လှည့်ရန် လိုအပ်သည်:`",
    change_language: "ဘာသာစကားပြောင်းလဲခြင်း",
    fraud_prevention: "လိမ်လည်မှုကာကွယ်ရေး",
    fraud_prevention_desc:
      "(မှတ်ချက်အတွင်းတွင်) အောက်ပါစကားလုံးများကို ဖြည့်သွင်းပါက ၎င်းတို့ကို ပိုမိုတင်းကြပ်စွာ ပြန်လည်သုံးသပ်ပြီး သုံးစွဲသူသည် ငွေဖြည့်သွင်းခြင်းကို အောင်မြင်စွာဆောင်ရွက်နိုင်မည်မဟုတ်ပေ။ ဥပမာ- အရောင်း/ဝယ်ယူမှု၊ ငှားရမ်း/ချေးငွေ၊ ဆက်သွယ်ရေးဌာန၊ ငွေကြေးလဲလှယ်မှု၊ ဆေးဘက်ဆိုင်ရာပစ္စည်းများ၊ အဝတ်အစားထောက်ပံ့မှု၊ အီလက်ထရွန်းနစ်ပစ္စည်းများ၊ သယ်ယူပို့ဆောင်ရေး၊ ကားအစိတ်အပိုင်းများ၊ မော်တော်အစိတ်အပိုင်းများ၊ တန်ဖိုးကြီး/နာမည်ကြီးအမှတ်တံဆိပ်၊ ဖျော်ဖြေပွဲလက်မှတ်များ/ကူပွန်များ၊ အစားအသောက်/အဆာပြေ/သစ်သီးများ/အချိုရည်/စာအုပ်များနှင့် အခြားအရာများ။.",
    type_a_message: "မက်ဆေ့ခ်ျကိုရိုက်ပါ",
    vip_coupon: "VIP ကူပွန်",
    egames_coupon: "Egames ကူပွန်",
    reminder: "သတိပေးချက်",
    signup_username_info:
      "username သည် စာလုံး နှင့် နံပါတ်များသာ ပါဝင်ခွင့်ပြုထားပြီး အရှည်မှာ အနည်းဆုံး စာလုံး 8 လုံး",
    signup_password_info:
      "အသုံးပြုသူအမည်သည် စာလုံး + နံပါတ်များသာ ပါဝင်ခွင့်ပြုထားပြီး အရှည်မှာ အနည်းဆုံး စာလုံး 8 လုံး",
    signup_new_password_error_msg:
      "စကားဝှက်အသစ်သည်အက်ခရာနံပါတ်များဖြစ်သင့်သည်။",
    signup_password_confirm_passwors_error_msg: "စကားဝှက်နှင့်စကားဝှက်ကိုမတူပါ",
    eng_text: "English",
    bahasa_melayu_text: "Bahasa Melayu",
    thai_text: "เปลื่ยนภาษา",
    ch_text: "中文",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*အပ်ငွေ ထုတ်ယူချိန်သည် 10 မိနစ်အတွင်း ပြီးစီးပါမည်၊ ကျေးဇူးပြု၍ စိတ်ရှည်ပါ၊ ကျေးဇူးတင်ပါတယ်!",
    qr_description_thb:
      "*အနည်းဆုံး 'ငွေဖြည့်သွင်းရာတွင် 100THB' ဖြင့် 'အကောင့်တစ်ခုမှတ်ပုံတင်ရန်' ကစားသမားအသစ်ကို အကြံပြုလိုက်ပါက 'ကိုးကားခ' 20THB' ရရှိမည်ဖြစ်သည်။ 'ကစားသမားအသစ်' ကို အကြံပြုပြီး အောင်မြင်ပါက သင့်အကောင့်ဖြစ်လိမ့်မည် 'စူပါကစားသမား' သို့ အလိုအလျောက် အဆင့်မြှင့်တင်ပြီး သင်အကြံပြုထားသည့် 'ကစားသမား' ၏ ထိရောက်သောလောင်းကြေးပမာဏ၏ ရာခိုင်နှုန်းတစ်ရာခိုင်နှုန်းကို သင် ထုတ်ယူနိုင်ပါသည်။.",
    total_amount: "စုစုပေါင်းတန်ဘိုး",
    transaaction_no: "ငွေလွှဲခြင်းအမှတ်",
    share: "မျှဝေ",
    timer: "အချိန်",
    gift: "လက်ဆောင်",
    schedule: "အချိန်ဇယား",
    qr_description_myr:
      "*အနည်းဆုံး 'ငွေဖြည့်သွင်းမှု 20MYR' ဖြင့် 'အကောင့်တစ်ခုမှတ်ပုံတင်ရန်' ကစားသမားအသစ်ကို အကြံပြုပေးပါက 'ကိုးကားခ' 2MYR' ရရှိမည်ဖြစ်သည်။'ကစားသမားအသစ်' ကို အကြံပြုခြင်းဖြင့် အောင်မြင်ပါက သင့်အကောင့်ဖြစ်လိမ့်မည် 'စူပါကစားသမား' သို့ အလိုအလျောက် အဆင့်မြှင့်ထားပြီး သင်အကြံပြုထားသည့် 'ကစားသမား' ၏ ထိရောက်သောလောင်းကြေးပမာဏ၏ ရာခိုင်နှုန်းတစ်ရာခိုင်နှုန်းကို သင် ထုတ်ယူနိုင်သည်။.",
    bonus_monthly: "အပိုဆု(လစဉ်)",
    withdraw_per_day: "တစ်နေ့လျှင် ငွေထုတ်ခြင်း",
    exclusive_domain: "သီးသန့် ဒိုမိန်းအမည်",
    deposit_priority: "အပ်ငွေဦးစားပေး",
    festival_gift: "ပွဲတော်လက်ဆောင်",
    exclusive_customer_service: "သီးသန့်ဖောက်သည်ဝန်ဆောင်မှု",
    free_travel: "အခမဲ့ ခရီးသွားခြင်း",
    vip_myr_activity_1:
      "● Lucky Town သည် သက်သောင့်သက်သာရှိသော ဂိမ်းပလက်ဖောင်းကို ဖန်တီးရန် ကတိပြုထားသော်လည်း စက်မှုလုပ်ငန်းတွင် ကျွန်ုပ်တို့လိုက်ရှာနေသည့် ပထမတန်းစား VIP ပလပ်ဖောင်းကို ဖန်တီးရန်လည်း မမေ့ပါနှင့်။.",
    vip_myr_activity_2:
      "● Lucky Town ဂိမ်းပလက်ဖောင်းပေါ်တွင် ကစားသမားများ၏ စဉ်ဆက်မပြတ် ကြီးထွားလာမှုနှင့်အတူ ကစားသမားများအား ပိုမိုဂရုစိုက်ဂရုစိုက်ပြီး အရည်အသွေးပိုမြင့်သည့် လုပ်ဆောင်ချက်များကို ပံ့ပိုးပေးပါမည်။ Lucky Town ကစားသမားများအတွက် ဆုပေးသည့်စနစ်အသစ်ကို စတင်လိုက်ပါပြီ။ ကစားသမားဟောင်းများနှင့် ကစားသမားသစ်များလည်း လုပ်ဆောင်နိုင်ပါသည် အစီအစဉ်အပိုဆုကြေးများကို ပိုမိုခံစားပါ;",
    vip_myr_policy:
      "1.ပရိုမိုးရှင်းအခြေအနေများ- အဆင့်မြှင့်တင်မှုပြီးသွားသည်နှင့် ချက်ချင်းဆိုသလို ပရိုမိုးရှင်းလက်ဆောင်ကို စနစ်က အလိုအလျောက် ဆုံးဖြတ်ပေးပါသည်။ လက်ဆောင်လက်ခံရရှိရန် အချိန်ကန့်သတ်ချက်မှာ ဖြန့်ဖြူးပြီးနောက် ၁၄ ရက်ဖြစ်သည်။ အချိန်ကန့်သတ်ချက်အတွင်း လက်ခံရရှိရန် ပျက်ကွက်ပါက စွန့်လွှတ်ခြင်းအဖြစ် မှတ်ယူမည်ဖြစ်ပြီး စနစ်မှ အလိုအလျောက် ထုတ်ယူမည်ဖြစ်သည်။ ၂။ တန်းဆင်းခွင့် အခြေအနေ- တန်းဆင်းခွင့် အရည်အချင်းပြည့်မီခြင်း ရှိမရှိ စနစ်သည် အလိုအလျောက် စုဆောင်းပါသည်။ စုဆောင်းသည့်အချိန်သည် အဆင့်မြှင့်သည့်နေ့၏ ပထမဆုံးနေ့ဖြစ်ပြီး ၎င်းကို နောက်ပိုင်းတွင် တွက်ချက်မည်ဖြစ်သည်။ ဥပမာ- အဖွဲ့ဝင်တစ်ဦးကို နိုဝင်ဘာ 3 ရက်တွင် ရွှေအဖွဲ့ဝင်အဖြစ် အဆင့်မြှင့်ထားပြီး စနစ်တွင် စုဆောင်းသည့်အချိန်သည် စက်တင်ဘာ 3 ရက် 12:00:01 တွင်ဖြစ်သည်။ ညနေ ၃ နာရီမှ ဒီဇင်ဘာ ၃ ရက်အထိ 11:59:59 AM၊ သုံးလ (ရာသီတစ်ခု) အတွင်း တန်းဆင်းရန် အရည်အချင်းပြည့်မီခြင်း ရှိမရှိ၊ ၃။ မွေးနေ့လက်ဆောင်- မွေးနေ့လက်ဆောင်မရရှိမီနှင့် ပြီးနောက် ၃ ရက် သို့မဟုတ် ထိုနေ့တွင်၊ အတည်ပြုရန်အတွက် သင်၏ ID ကတ်ဓာတ်ပုံကို ဖောက်သည်ဝန်ဆောင်မှုထံ ပေးပို့ရန် လိုအပ်ပါသည်။ တင်ပြထားသော ID ကတ်အမည်သည် ဂိမ်းအကောင့်၏ ဘဏ်အကောင့်အမည်နှင့် ကိုက်ညီရပါမည်။ မွေးနေ့ လက်ဆောင် လျှောက်ထားရန် သတ်မှတ်ရက်ထက် ကျော်လွန်ပါက ပေးကမ်းခြင်းဟု သတ်မှတ်သည်။ ၄။ ပုံမှန်မဟုတ်သော အားလပ်ရက်လက်ဆောင်များ၊ ပုံမှန်မဟုတ်သော အားလပ်ရက်လက်ဆောင်များကို စာတိုက် သို့မဟုတ် လက်ဆောင်ငွေဖြင့် ပေးမည်ဖြစ်ပါသည်။ ၅။ အခမဲ့ခရီးသွားလာရန်အတွက် သင်သည် ၎င်းကိုမရနိုင်မီ အနည်းဆုံး 4 လေးပုံ (12 လ) အတွက် vip6 ကို ထိန်းသိမ်းထားရန် လိုအပ်ပါသည်။ထွက်ခွာမည့်ရက်၊ ဟိုတယ်နှင့် လေယာဉ်လက်မှတ်တို့ကို ကုမ္ပဏီက ၎င်း၏တစ်ဦးတည်းတာဝန်ဖြင့် စီစဉ်ပေးမည် (ဟိုတယ်ကို ပြောင်းလဲရန် သို့မဟုတ် လေယာဉ်လက်မှတ်ရက်စွဲနှင့် ထွက်ခွာမည့်ရက်ကို ပြောင်းလဲခြင်းမပြုပါ)။ ၆။ အထက်ဖော်ပြပါ အစီအစဉ် ဆုလက်ဆောင်များ သို့မဟုတ် လက်ဆောင်ငွေ ကောက်ခံမှု ကာလသည် ဖြန့်ဖြူးပြီးနောက် 14 ရက်အတွင်း ဖြစ်သည်။ အချိန်ကန့်သတ်ချက်အတွင်း စုဆောင်းရန်ပျက်ကွက်ခြင်းကို စွန့်လွှတ်ခြင်းအဖြစ် မှတ်ယူမည်ဖြစ်ပြီး စနစ်မှ အလိုအလျောက် ထုတ်ယူမည်ဖြစ်သည်။ ၇။ အပတ်စဉ်/လစဉ်ဆုများ- (VIP2/VIP3) လစဉ် - အနည်းဆုံး အပ်ငွေ 10 ခု ပြီးပါပြီ၊ သို့မဟုတ် စုဆောင်းငွေမှာ RM1000 ဖြစ်ပြီး လစဉ် VIP ဆုငွေကို ရယူရန်အတွက် လှိမ့်ပမာဏသည် 5000 ထက်ပိုပါသည်။ (VIP4 / VIP5 / VIP6 ) တစ်ပတ်လျှင် အနည်းဆုံး အပ်ငွေ 1 ခု သို့မဟုတ် စုဆောင်းအပ်ငွေ RM1000 နှင့် 5000 နှင့်အထက် တစ်ပတ်လျှင် VIP ဘောနပ်စ်ကို ရနိုင်သည် \n\nã€ŠEvent Termsã€‹\n1။ ပရိုမိုးရှင်းသည် ဖျော်ဖြေရေးအဖွဲ့ဝင်များအတွက်သာဖြစ်သည်။ အသုံးပြုသူတွင် အမည်တူ၊ တူညီသောအီးမေးလ်လိပ်စာ၊ တူညီသော/အလားတူ IP လိပ်စာ၊ တူညီသောလိပ်စာ၊ တူညီသောဒက်ဘစ်/ခရက်ဒစ်ကတ်၊ ဘဏ်အကောင့်တစ်ခုတည်း၊ တူညီသောကွန်ပျူတာအပါအဝင် အကောင့်တစ်ခုထက်ပို၍ တွေ့ရှိပါက၊ စသည်ဖြင့် ပုံမှန်မဟုတ်သော လောင်းကစားအပြုအမူကို တွေ့ရှိပြီးသည်နှင့် LUCKY TOWN သည် သင့်အကောင့်၏ အမြတ်ငွေနှင့် လက်ကျန်များကို ရပ်တန့်စေမည့် အခွင့်အရေးကို သိမ်းဆည်းထားမည်ဖြစ်သည်။ ၂။ လောင်းကစား၊ သရေပွဲ၊ အခြား အကာအကွယ်ပေးသည့် လောင်းကြေးများ (ဆိုက်စုံ လောင်းကစား)၊ ပယ်ချထားသော လောင်းကစားများ၊ ပျက်ပြယ်သော လောင်းကြေးများ၊ ဂိမ်းများ သို့မဟုတ် 1.5 အောက်ရှိ အားကစားဆိုင်ရာ ပေါက်ကြေးများကို ပရိုမိုးရှင်းအတွက် လိုအပ်သော တရားဝင်လောင်းကြေးများအဖြစ် ထည့်သွင်းရေတွက်မည်မဟုတ်ပါ။ ၃။ 'စက်ရုပ်များ' နှင့် 'ဝင်းဒိုးနှစ်ထပ်/များစွာဖွင့်ခြင်း' ကဲ့သို့သော ပြင်ပအဖွဲ့အစည်းတရားမ၀င်ဆော့ဖ်ဝဲဖြင့် ပြုလုပ်သော အလောင်းအစားမှန်သမျှကို တရားမဝင်လောင်းကစားအဖြစ် မှတ်ယူနိုင်ပြီး LUCKY TOWN သည် သံသယရှိအကောင့်၏ လက်ကျန်ငွေကို အေးခဲစေပြီး အဖွဲ့ဝင်အကောင့်ကို ပိတ်ရန် အခွင့်အရေးကို ကန့်သတ်ထားသည်။ ၄။ LUCKY TOWN တွင် အဖွဲ့ဝင်များ၏ လောင်းကစားမှတ်တမ်းအားလုံးကို စစ်ဆေးပိုင်ခွင့်ရှိသည်။ အဖွဲ့ဝင်တစ်ဦးသည် ပွဲ၏စည်းမျဉ်းများနှင့် စည်းမျဉ်းများကိုချိုးဖောက်ပါက သို့မဟုတ် အကျိုးအမြတ်ရရှိရန် ဘောနပ်စ်များကိုအသုံးပြုခြင်းအတွက် ဖျော်ဖြေရေးရည်ရွယ်ချက်မရှိပါက၊ LUCKY TOWN သည် အချိန်မရွေးရပ်တန့်ရန်၊ ပယ်ဖျက်ရန် သို့မဟုတ် ပြန်လည်တောင်းဆိုရန် အခွင့်အရေးအားလုံးကို လက်ဝယ်ရှိပါသည်။ ကမ်းလှမ်းချက်များအားလုံးကို ပေးဆောင်ခဲ့သည်။ ၅။ LUCKY TOWN သည် သက်ဆိုင်ရာအကောင့်အား အလွဲသုံးစားလုပ်နေသည်ဟု သံသယရှိကာ ဤပရိုမိုးရှင်းအတွက် အရည်အချင်းမပြည့်မီပါက သက်ဆိုင်ရာ စာရွက်စာတမ်းများ တင်ပြရန် အဖွဲ့ဝင်များထံ တောင်းဆိုပိုင်ခွင့်ကို လက်ဝယ်ရှိပါသည်။ \n၆။ အကယ်၍ တစ်ဦးချင်း/အဖွဲ့/အဖွဲ့အစည်းသည် ဘောနပ်စ်များကို အလွဲသုံးစားလုပ်ခြင်း/အလွဲသုံးစားလုပ်ခြင်းအတွက် မရိုးမသားနည်းလမ်းများ သို့မဟုတ် လိမ်လည်လှည့်ဖြားသည့် လုပ်ရပ်များကို အသုံးပြုသည်ဟု သံသယရှိပါက စစ်ဆေးပြီးသည်နှင့်၊ LUCKY TOWN သည် သက်ဆိုင်ရာအကောင့်၏ အမြတ်ငွေများနှင့် လက်ကျန်များကို ရပ်တန့်ပိုင်ခွင့်ရှိသည်။ ၇။ ဤပရိုမိုးရှင်းတွင် ပါဝင်ခြင်းဖြင့် သင်သည် 'ပရိုမိုးရှင်း၏ စည်းမျဉ်းများနှင့် စည်းကမ်းချက်များ' အားလုံးကို သဘောတူပါသည်။ ၈။ LUCKY TOWN သည် ဤပရိုမိုးရှင်း၏ ပြန်လည်ပြင်ဆင်ခြင်း၊ ရပ်စဲခြင်း သို့မဟုတ် နောက်ဆုံးအဓိပ္ပာယ်ဖွင့်ဆိုခွင့်ကို လက်ဝယ်ရှိပါသည်။ အသိပေးခြင်းမရှိဘဲ ဤပရိုမိုးရှင်းကို အပြောင်းအလဲပြုလုပ်ရန်။ ၉။ တရားမဝင်လောင်းကစားတွေ့ရှိပါက စပေါ်ငွေ (အမြတ်ငွေပမာဏနှင့် ဘောနပ်စ်များအပါအဝင်) ရပ်တန့်သွားမည်ဖြစ်ပြီး၊ စနစ်က ၎င်းကို သုညအထိ အလိုအလျောက်ရှင်းပေးမည်ဖြစ်သည်။ \n",
    weekly: "အပတ်စဉ်",
    withdraw_duration_text:
      "*အပ်ငွေထုတ်ယူချိန်သည် မိနစ် 30 အတွင်း ပြီးစီးပါမည်၊ ကျေးဇူးပြု၍ စိတ်ရှည်ပါ၊ ကျေးဇူးတင်ပါတယ်!",
    hot_game: "ဟော့ဂိမ်းများ",
    new_games: "ဂိမ်းအသစ်များ",
    reset_app: "App Cache ကိုရှင်းပါ",
    reset_app_title: "Cached Data ကို ရှင်းရန်",
    reset_app_description:
      "သင်သေချာပါသလား?သင်appအတွင်းရှိဒေတာတွေကိုပယ်ဖျက်မည်.",
    anoucement_intro_title: "ကြေငြာချက်",
    anoucement_intro_description: "အရေးကြီးတဲ့ ကြေညာချက်ကို ဒီမှာ ရှာလို့ရသည်.",
    game_list_intro_title: "ဂိမ်းစာရင်း",
    game_list_intro_description:
      "ဂိမ်းအားလုံးကို ဤနေရာတွင် စာရင်းသွင်းထားပြီး၊ ဂိမ်းစတင်ရန် ဂိမ်းအိုင်ကွန်ကို နှိပ်နိုင်ပါသည်။.",
    topup_intro_title: "ငွေဖြည့်/ငွေထုတ်ခြင်း",
    topup_intro_description:
      "ဒီနေရာမှာ သင်ရဲ့လက်ကျန်ငွေကို ငွေဖြည့်/ထုတ်ယူလို့ရသည်.",
    leatherboard_intro_title: "ဦးဆောင်ဘုတ်အဖွဲ့ ",
    leatherboard_intro_description:
      "ဒီလ၏အကောင်းဆုံးကစားသမားများကို ဤနေရာတွင် စာရင်းသွင်းပါမည်။ သုံးစွဲပြီး ဆုရယူပါ!!",
    previous_step: "ယခင်",
    next_step: "နောက်တစ်ခု",
    skip_step: "ကျော်သွား",
    finish_step: "ပြီးသည်",
    point_history: "အမှတ် မှတ်တမ်း",
    points: "အမှတ်များ",
    luckytown_points: "LK အမှတ်များ",
    you_have_earned: "သင်ဝင်ငွေရှိသည်",
    topup_info:
      "**ငွေဖြည့်သွင်းရန်အတွက် တင်သွင်းထားသော အမည်ရင်းနှင့် ဘဏ်ငွေလွှဲအကောင့်အမည် ကွဲလွဲပါက ကုမ္ပဏီမှ တင်ပြလျှောက်ထားမှုကို ငြင်းပယ်ပိုင်ခွင့်ရှိသည်",
    please_upload_reciept: "ကျေးဇူးပြု၍ ပြေစာကို အပ်လုဒ်တင်ပါ",
    pull_out_credit: "ခရက်ဒစ်ထုတ်ယူရန်",
    pull_out_all_credit: "ခရက်ဒစ်အားလုံးကိုထုတ်ပါ။",
    pull_out_credit_message:
      "ခရက်ဒစ်များအားလုံးကို ထုတ်ယူလိုသည်မှာ သေချာပါသလား။",
    topup_promotion_intro:
      "အရေးကြီးအသိပေးချက်:\nမည်သည့်အထူးပွဲများတွင်းမဆိုပါဝင်နိုင်ရန် အသုံးပြုသူများသည် ရွေးချယ်ထားသောလျှော့စျေး၏ လွှပြောင်းမှုအခြေအနေများ မပြီးမချင်း QR လွှပြောင်းခြင်း သိုမဟုတ် ID လွှပြောင်းခြင်းကို အသုံးပြု၍မရပါ။  ပလက်ဖောင်းမှတဆင့် ငွေထုတ်ခြင်းကို ပြီးမြောက်ပြီးနောက်  customer service သို QR လွှပြောင်းခြင်း စတင်ရန် အတည်ပြုခြင်းကိုလုပ်ဆောင်ရပါမည်။.",
    statment: "ကြေညာချက်",
    withdraw_usdt: "USDT ထုတ်ယူလျှင်",
    withdraw_usdt_Receipt: "USDT ပြေစာ ထုတ်ယူလျှင်",
    withdraw_usdt_intro:
      "အသိပေးချက်-:\n\n• အနည်းဆုံးထုတ်ယူနိုင်သည့်ပမာဏမှာ 150USDT (TRC20)ဖြစ်သည်။.\n•အကယ်၍ငွေထုတ်ယူသည့်လိပ်စာမှားယွင်းဖြည့်စွက်ထားပါကကုမ္ပဏီဖက်မှတာဝန်ယူမည်မဟုတ်ပါ။.\n• သင့်ရဲ့ငွေများလုံခြုံစေရန်ဖြစ်သည်။ သင်၏ ရန်ပုံငွေများ ဘေးကင်းစေရန်၊ သင့်အကောင့် ဘေးကင်းလုံခြုံသောအခါတွင် ငွေထုတ်ခြင်းများကို ကျွန်ုပ်တိုကိုယ်တိုင်စစ်ဆေးပါမည်။ ကျေးဇူးပြု၍ စိတ်ရှည်စွာစောင့်ဆိုင်းပါ။ အချက်အလက်များကို နှောင့်ယှက်ခြင်း သိုမဟုတ် ပေါက်ကြားခြင်းမှ ကာကွယ်ရန် သင့်ကွန်ပျူတာနှင့်browser၏ လုံခြုံရေးကို သေချာစွာ အတည်ပြုပါ။.\n• *ငွေထုတ်ချိန်သည် 24 နာရီအတွင်း ပြီးမြောက်ပါမည်။ ကျေးဇူးပြု၍ ပြီးေမြာက်ရန်စိတ်ရှည်စွာ စောင့်ပါ။.",
    withdraw_currency: " ထုတ်ယူမည့်ငွေကြေး",
    withdraw_amount: "ထုတ်ငွေပမာဏ",
    withdraw_network: "ထုတ်ငွေ ကွန်ရက်",
    conversion_rate: "ငွေလဲနှုန်း",
    fees: "ပိုခ",
    converted_amount: "ငွေပြောင်းလိုမည့်ပမဏ",
    amount_received: "လက်ခံရရှိသည့်ပမာဏ",
    withdraw_usdt_success: "ထုတ်ယူမှုအောင်မြင်သော USDT.",
    available_usdt: " USDT လက်ခံပြီ",
    google_auth: "Google Authentication",
    redeem: "ရွေးနှုတ်ခြင်း။",
    enter_verification_code: "Enter the 6-digit verification code",
    activate_google_auth: "Activate Google Authenticator",
    inactivate_google_auth: "In Activate Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Are you sure you want to Reset Google Authenticator?",
    activate_google_auth_msg:
      "Are you sure you want to Activate Google Authenticator?",
    register_google_auth_verification_msg:
      "Setup account with Google Auth Veririfcation ",
    scan_google_auth_msg:
      "Scan this QR Code with yoour Google Authenticator App. Alternatively, you can use this code to reset   ",
    secret_key: "Secret Key:",
    pin: "PIN",
    change_app_icon: "Change App Icon",
    change_app_icon_message: "Are you sure you want to change app icon?",
    change_app_icon_success_message: "App Icon Change Successfully",
    real_name_verification: "Real Name Verification",
    enter_real_name: "Enter Real Name",
    real_name_notes:
      "Notes:\n\n1. Add a bank account with your real-name. \n2. Choose the bank account.\n3. Fill in your real-name. \n4. Submit Verification Request. \n5. Your request will be updated within 3 working days.",
    please_login_first: "Please Login first",
    otp_prefix: "OTP Prefix",
    notification_detail: "Notification Detail",
    bonus_chips: "Bonus Chips",
    bonus: "Bonus",
    cash_wallet: "Cash Wallet",
    promotion_intro_description:
      "ကျွန်ုပ်တို၏နောက်ဆုံးထွက်ပရိုမိုးရှင်းကို ဤနေရာတွင်ကြည့်ပါ။",
    looked_amount: "သော့ခတ်ပမာဏ",
    current_tunrover_stake: "လက်ရှိ / လည်ပတ်ငွေကြေးလောင်းကြေးလိုအပ်ပါတယ်",
    turnover_stake_remarks:
      "10 မိနစ်အတွင်းလည်ပတ်ငွေကြေးတင်ခြင်းအော်တို update ကို",
    otp_verification_text:
      "ျေးဇူးပြု. မိုဘိုင်းဖုန်း SMS ကိုစစ်ဆေးပြီးသင်၏အကောင့်လုံခြုံရေးကိုကာကွယ်ရန်သင်၏မိုဘိုင်းပစ္စည်းကိုစစ်ဆေးရန်နှင့်သင်၏မိုဘိုင်းပစ္စည်းကိုဖြည့်စွက်ရန် OTP ကိုထည့်ပါ",
    select_deposit_method: "အပ်ငွေနည်းလမ်းကို ရွေးပါ။",
    user_agreement: "အသုံးပြုသူသဘောတူညီချက်",
    no_record_found: "No Record Found",
    info: "အချက်အလက်",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "အသုံးပြုသူညွှန်ကြားချက်",
  },
  kh: {
    app_name: "Lucky Town",
    login_text: "Log In",
    signUp_text: "Sign Up",
    welcom_text: "Welcome to the Lucky Town Plus App",
    username_text: "Username",
    password_text: "Password",
    forgotPassword_text: "Forgot Password",
    otp_text: "OTP",
    invalid_username_or_password: "Invalid username or password",
    invalid_password: "Invalid password",
    invalid_data_input: "Invalid data input",
    invalid_phone_number: "Invalid phone number",
    invalid_transaction_pin: "Invalid transaction pin",
    history_text: "History",
    from_date: "From Date",
    to_date: "To Date",
    to: "To",
    go: "Go",
    select: "Select",
    new_account: "New Account",
    new_password: "New Password",
    recommended_user: "Recommender user: ",
    phone_number: "Phone Number",
    confirm_password: "Confirm Password",
    username_or_phone_number_is_registered:
      "Username or phone number is registered",
    recover_password: "Recover Password",
    recover_username: "Recover Username",
    please_enter_phone_number:
      "Please enter your registered phone number to recover your password.",
    please_enter_phone_number_to_recover_username:
      "Please enter your registered phone number to recover your username.",
    please_enter_txid: "Please enter txid.",
    next: "Next",
    otp_code_resended: "OTP code resended",
    invalid_otp_code: "Invalid OTP code",
    request_otp: "Request OTP",
    please_enter_otp: "Please enter OTP send to your selected creadentials.",
    proceed: "Proceed",
    resend_code: "Resend code",
    change_login_password: "Change Login Password",
    select_one_of_the_cre:
      "Select one of any creadentials which should we use for recover your password.",
    password_changed: "Password Changed",
    congratulations_changed_password:
      "Congratulations! Youve successfully changed your password.",
    login_now: "Login Now",
    discover: "Discover",
    amount_RM: "Amount",
    start: "Start",
    contacts: "Contacts Us",
    new_friend: "New Friend",
    wallet: "Wallet",
    cash: "Cash",
    bank_account: "Bank Account",
    setting: "Setting",
    withdraw_succ: "Withdraw successfully",
    top_up_succ: "Top up successfully",
    coin: "Coin",
    interest: "Lucky Coin",
    wallet_balance: "Cash Balance",
    top_up: "Top Up",
    withdraw: "Withdraw",
    transaction: "Transaction",
    instant_top_up: "Instant Top Up",
    top_up_bank_transfer: "Bank Transfer",
    error_please_try_again: "Error, please try again.",
    top_up_RM: "Top Up",
    upload_receipt: "Upload Receipt",
    choose_upload_photo_method: "Choose Upload Photo Method",
    take_picture: "Take Picture",
    select_from_gallery: "Select From Gallery",
    take_photo: "Take Photo",
    retake: "Retake",
    use_photo: "Use Photo",
    upload_bank_receipt: "Upload Bank Receipt",
    confirm_to_upload_this_photo: "Confirm to upload this photo?",
    cancel: "Cancel",
    confirm: "Confirm",
    wallet_balance_not_enough: "Cash Balance Not Enought to withdraw",
    withdraw_RM: "Withdraw",
    no_transaction_for_dates: "No transactions for selected dates",
    no_more_transaction_for_dates: "No more transactions for selected dates",
    please_enter_date: "Please enter dates",
    all_transaction: "All Transaction",
    top_up_history: "Top Up History",
    interest_account_removed: "LuckyCoin account removed!",
    interest_account_created_succ: "LuckyCoin account created succesfully.",
    you_have_no_interest_account: "You have no running LuckyCoin account.",
    interest_history: "Lucky Coin History",
    days: "Days",
    hours: "Hours",
    create_interest: "Create LuckyCoin",
    deposit_RM: "Deposit",
    balance_RM: "Balance         :",
    remove: "Remove",
    partial_withdraw: "Partial Withdraw",
    interest_withdraw: "Interest withdraw",
    add_back_account_succ: "Add bank account successfully",
    edit_bank_account: "Edit Bank Account",
    bank: "Bank",
    account_name: "Account Name",
    account_no: "Account No.",
    add_bank_account: "Add Bank Account",
    sign_out: "Sign Out",
    language: "Language",
    clear_cache: "Clear Cache",
    about: "About",
    old_password_not_match: "Old Password Not Match.",
    old_password: "Old Password",
    back: "Back",
    version: "Version",
    change_payment_pin: "Change Payment Pin",
    change_nickname: "Change Nickname",
    transfer: "Transfer",
    create_pin: "Create Transaction Pin",
    change_pin: "Change Transaction Pin",
    creat_pin_description:
      "Create a 6 digits pin for your transaction in the app",
    please_enter_pin_again: "Please enter 6 digits pin again",
    pin_dont_match: "Pin does not match",
    old_pin: "Old Pin",
    new_pin: "New Pin",
    confirm_new_pin: "Confirm Pin",
    pin_max_six: "Transaction Pin 6 digits",
    succ_pin_change: "Transation Pin Changed",
    congratulations_changed_pin:
      "Congratulations! Youve successfully changed your transaction pin.",
    please_enter_pin: "Please enter transaction pin",
    forgot_pin: "Forgot transaction pin",
    recover_transaction_pin: "Recover Transaction Pin",
    please_enter_phone_number_pin:
      "Please enter your registered phone number to recover your transaction pin.",
    old_pin_not_match: "Old pin not match",
    new_pin_not_match: "New pin not match",
    transfer_RM: "Transfer",
    transfer_succ: "Transfer successfully",
    transfer_to: "Transfer to: ",
    wallet_insuffecient_amount: "Cash Balance Not Enought to transfer.",
    change_your_nickname: "Edit or change your nickname",
    nickname: "Nickname",
    fullname: "Full Name",
    nickname_change_succ: "Change nickname successfully",
    cancellation: "Cancellation",
    confirm_to_remove_and_withdraw: "Confirm to remove and withdraw",
    confirm_go_back: "Confirm to go back?",
    in_game: "In Game",
    close_game_first: "Please quit other games first!",
    close_game: "Close Game",
    game_closed: "Game Closed",
    game: "Games",
    information: "Information",
    search: "Search",
    no_user_found: "User not found",
    i_have_read_and_agree: "I have read and agree",
    LID: "LID",
    referral: "Referral",
    available_transfer_balance_RM: "Available Transfer",
    i_am_agreed_to_term: "I'm agreed the term",
    coin_transaction: "Coin Transaction",
    status: "Status",
    succ_submission_pending_review: "Successful submission pending review",
    leaderboard: "Leaderboard",
    time_zone: "Time Zone",
    customer_service: "Customer service",
    qr_transfer: "QR Transfer",
    top_up_details: "Top Up Details",
    top_up_type: "Top Up Type",
    date: "Date",
    receipt: "Receipt",
    available_transfer: "Available Transfer",
    available_coin: "Available Coin",
    commission: "Commission",
    today_stake: "Today Stake",
    yesterday_stake: "Yesterday Stake",
    wallet_transaction: "Wallet Transaction",
    game_transaction: "Game Transaction",
    type: "Type",
    all: "All",
    refund: "Refund",
    penalty: "Penalty",
    pick_date: "Pick Date",
    time: "Time",
    win: "Win/Loss",
    win_: "Win",
    bet: "Bet",
    bet_or_transfer: "Bet/Transfer",
    save_in_album: "Save In Album",
    qr_code_saved: "QR code saved",
    save_error: "Save error",
    change_avatar: "Change Avatar",
    avatar_changed: "Avatar changed",
    cant_start_game: "Can not start game",
    details: "Details",
    product: "Product",
    total_bet: "Total Bet",
    total: "Total",
    reward: "Reward",
    photo_library: "Photo Library",
    qr_code_error: "QR code error",
    maintenance: "Maintenance",
    coming_soon: "Coming Soon",
    top_up_disclaimer:
      "** Please comply with the regulations listed by our company. Otherwise, the points given will be delayed. We wish you a happy game, thank you.",
    minimum_top_up: "Minimum: ",
    maximum_top_up: "Maximum: ",
    top_up_left_times: "Remaining times:",
    top_up_unlimited: "(Unlimited)",
    order_history: "Order History",
    withdraw_history: "Withdraw History",
    no_bank_account_added: "Please bind at least one bank account",
    minimum_withdraw: "Min: ",
    maximum_withdraw: "Max: ",
    free_withdraw_time: "Free times: ",
    withdraw_balance: "Current balance: ",
    unlimited: "Unlimited",
    withdraw_details: "Withdraw Details",
    updated_date: "Updated Date",
    pending: "Pending",
    success: "Successfull!",
    in_inspection: "In inspection",
    hold: "On hold",
    confirm_to_remove_withdraw: "Confirm to remove withdraw?",
    confrim_to_remove_top_up: "Confirm to remove top up?",
    rejected: "Rejected",
    copied: "Copied to clipboard",
    anouncement: "Anouncement",
    contactUs: "Contact Us",
    newVersionTitle: "A new version is available",
    versionDescription:
      "To continue, please update you app to the latest version",
    verification: "Verification",
    register_device_text:
      "This device is not tied to your account. Please register the device to continue",
    device_name: "Device Name",
    device_info: "Device Info",
    friend: "Friends",
    about_phone: "About Phone",
    remarks: "Remarks",
    balance_transfer: "Balance transfer successfully",
    usdt_top_up: "Top Up USDT",
    app_close: "Close",
    topupRemarks:
      "Please specify LT- (your user name) on the transfer slip \nE.g. \nID: lucky town  \nRefer: LTluckytown",
    top_up_policy:
      "Our company will change the bank account from time to time, please confirm the account in advance at your bank/ before transfer of payment. The company is not responsible for any loss caused by your mistake",
    notification: "Notification",
    empty_notifications: "There are no new notifications.",
    promotion: "Promotion",
    use_now: "USE NOW",
    promo_code: "Promo Code",
    enter_otp: "Please enter OTP",
    change_phone_no: "Change Phone Number",
    change_your_phone: "Edit or change your phone number",
    congratulations_changed_phone:
      "Congratulations! Youve successfully changed your Phone number.",
    default_avatar: "Default Avatar",
    forgotUsername_text: "Forgot Username",
    authenticate: "Authentication",
    forgot_id_password: "Forgot UID / Password",
    manage_account: "Switch Account",
    add_another_account: "Add Another Account",
    add_account: "Add Account",
    cashout: "CASH OUT",
    please_signin_to_continue: "Please sign in to continue",
    no_account_found: "No Account Found",
    reward: "Reward",
    please_enter_amount: "Please enter amount.",
    topUpUSDTReceipt: "Topup USDT Receipt",
    amount_usdt: "Amount (USDT)",
    txid: "TXID",
    enter_txid: "Enter TXID",
    platform: "Platform",
    select_platrform: "Select Platform",
    request_topup_success: "Request Top Up Success.",
    chip: "Chip",
    confrim_to_remove_back_account: "Please confirm removal of bank account",
    footer_home: "Home",
    footer_contact: "Contacts",
    footer_transaction: "Transaction",
    footer_me: "Me",
    profile_cash: "Cash",
    profile_chip: "Chip",
    profile_luck: "Lucky Coin",
    profile_vip: "VIP",
    bank_search_bank: "Search Bank",
    avatar_back: "Back",
    friend_search_friend: "Search friend",
    friend_delete: "Delete",
    friend_title: "Add friend",
    friend_popup: "Enter friend name",
    game_details_download: "Download",
    game_details_launch: "Launch",
    game_details_transfer: "Transfer",
    qr_copy_link: "Copy Link",
    qr_qr_share: "Share QR",
    profile_lucky_coin: "Lucky Coin",
    currency_exchange: "Currency Exchange",
    currency_exchange_successfully: "Currency Exchange Successfully",
    please_select_other_currency: "Please select other currency to exchange",
    receipt_get: "Recipent Get",
    send_currency_exactly: "You Send Exactly",
    exchange_rate: "Exhange rate",
    helpDesk: "Helpdesk",
    topup_withdraw: "TopUp/Withdraw",
    more: "More",
    order: "Order",
    add_friend: "Add Friend",
    search_friend: "Search friend",
    friend_added_successfully: "Friend Added Successfully",
    please_enter_friend_name: "Please enter friend name",
    message: "Message",
    home: "Home",
    contact: "Contact",
    qr_topup: "QR TopUp",
    qr_topup_reciept: "TopUp QR",
    transaction_process: "Your transaction is in progress",
    please_allow_camera_permission: "Please allow camera permission.",
    enter_game: "Enter Game",
    exit_game: "Exit Game",
    edit_nickname: "Edit Nickname",
    model: "Model",
    device_id: "Device Id",
    unique_id: "Unique Id",
    lt_coin: "LT Coin",
    stage: "Stage",
    update_now: "UPDATE NOW",
    withdraw_policy:
      "Dear customers, in order to prevent fraud, customers must ensure that your bank holder name is same as that of your deposit account when making withdrawals. This policy is also to protect the security of the customer's funds. Sorry for any inconvenience, Thank you",
    max: "Max",
    promotion_reward: "Promotion Reward",
    birthday_gift: "Birthday Gift",
    daily_withdraw: "Max daily withdrawals",
    monthly_Salary: "Double monthly salary",
    edit_bank_account_succ: "Edit bank account successfully",
    cancel_request: "Cancel Request",
    redeem_coupon: "Redeem Coupon",
    coupon_list: "Coupon List",
    code_redeem_success: "Code Redeem Successful",
    please_enter_username: "Please enter username.",
    limitPerDay: "Limit per day: ",
    approved: "approved",
    processing: "Processing",
    got_it: "GOT IT",
    amount_greater_then_available_balance:
      "Sorry, your amount is greater that available balance",
    details: "Detail",
    rate: "Rate",
    select_bank: "Select Bank",
    address: "Address",
    date_time: "Date Time",
    select_country_code: "Select Country Code",
    pick_bank: "Pick Bank",
    balance: "Balance",
    luckytownviplabel: "Lucky Town VIP",
    vip_activity_label: "Activity",
    vip_member_bonus: "VIP Member Bonus ",
    vip_promoted_conditions: "Promoted Conditions",
    vip_toa: "LuckyTown VIP Term & Condition",
    promoted_bonus: "Promoted Bonus",
    birthday_bonus: "Birthday Bonus",
    withdraw_limit: "Withraw Limit",
    monthly_bonus: "Monthly Bonus",
    vip_activity_1:
      "● Lucky Town is committed to creating a comfortable gaming platform but also does not forget to create a first-class VIP platform that we have been pursuing in the industry.",
    vip_activity_2:
      "●With the continuous growth of players' on the Lucky Town gaming platform, we will provide players with more attentive care and higher-quality activities. A new reward system for Lucky Town players has been launched. New and old players can also enjoy more event bonus offers;",
    vip_policy_1:
      "1. Promotion conditions: The system automatically determines that the promotion gift will be distributed immediately after the upgrade is completed. The time limit for receiving the gift is 14 days after the distribution. Failure to receive it within the time limit will be regarded as giving up and will be automatically withdrawn by the system.",
    vip_policy_2:
      "2. Relegation Condition: The system automatically accumulates whether the relegation eligibility is met. The cumulative time is the first day of the upgrade day, and it will be calculated later. \nExample: A member is upgraded to a gold member on November 3, and the accumulated time in the system is from September 3 at 12:00:01 PM to December 3 at 11:59:59 AM, during a period of three months ( one season) whether to qualify for relegation.",
    vip_policy_3:
      "3. Birthday gift: 3 days before and after receiving the birthday gift or on the same day, you need to submit your ID card photo to the customer service for verification. And the name of the ID card presented must match the name of the bank account of the game account before it can be claimed. Exceeding the deadline for applying for the birthday gift money will be regarded as giving up.",
    vip_policy_4:
      "4. Irregular holiday gifts, irregular holiday gifts will be given by mail or gift money.",
    vip_policy_5:
      "5. For free travel, you need to maintain vip6 for at least 4 quarters (12 months) before you can get it. The departure date, hotel and air ticket will be arranged by the company at its sole responsibility (it will not be given to change the hotel or change the air ticket date and departure date).",
    vip_policy_6:
      "6. The above event rewards or gift money collection period is within 14 days after distribution. Failure to collect within the time limit will be regarded as giving up and will be automatically withdrawn by the system.",
    vip_policy_7:
      "7. Weekly/Monthly Rewards: (VIP2 / VIP3) Monthly - At least 10 deposits are completed, or the cumulative deposit is THB8000 and the rolling amount is more than 40,000, in order to get the monthly VIP reward. \n(VIP4 / VIP5 / VIP6 ) At least 1 deposit per week, or a cumulative deposit of THB8000 and a rolling amount of 40,000 or more, can get weekly VIP bonus",
    vip_policy_8:
      "《Event Terms》 \n\n1. The promotion is only for entertainment members. If it is found that the user has more than one account, including the same name, the same email address, the same/similar IP address, the same address, the same debit/credit card, the same bank account, the same computer, etc. Any abnormal betting behavior, once found, LUCKY TOWN will reserve the right to freeze your account profit and balance. \n\n2. Any betting, tie, other hedging bets (cross-site betting), rejected bets, void bets, ties or sports odds below 1.5 will not be counted as valid bets required for the promotion. \n\n3. Any bets made through third-party illegal software such as 'robots' and 'opening double/multiple windows' can be regarded as illegal bets, and LUCKY TOWN reserves the right to freeze the balance of the suspected account and close the member account. \n\n4. LUCKY TOWN has the right to check all betting records of members. If a member violates the regulations and rules of the event or has any non-entertainment purpose of using bonuses to make profits, LUCKY TOWN reserves all rights to stop, cancel or claim back at any time. All offers paid. \n\n5. LUCKY TOWN reserves the right to require members to submit relevant documents to verify their identity if the relevant account is suspected of being abused and/or not eligible for this promotion. \n\n6. If any individual/team/organization is suspected of using dishonest methods or fraudulent acts for the purpose of defrauding/abusing bonuses, once verified, LUCKY TOWN will have the right to freeze the relevant account profits and balances. \n\n7. By participating in this promotion, you agree to the 'All Rules and Terms of Promotion'. \n\n8. LUCKY TOWN reserves the right to revise, terminate or final interpretation of this promotion; and to make changes to this promotion without notice. \n\n9. If illegal betting is found, the deposit (including profit amount and bonuses) will be frozen, and the system will automatically clear it to zero.",
    vip_policy_9: "``",
    vip_policy_10: "",
    vip_accumulated_deposit: "`Accumulated Deposit:`",
    vip_require_turnover: "`Require Turn Over:`",
    change_language: "Change language",
    fraud_prevention: "Fraud Prevention",
    fraud_prevention_desc:
      "(Inside the remarks) If the following words are filled in, we will review them more strictly and the user may not be able to top-ups successfully. \nExample: Sales / Purchases, Rent / Loan, Telecommunication station, Currency exchange, Medical supplies, Clothing supply, Electronic products, Transportation, Car parts, Motor parts, Luxury / Famous brand, Concert tickets / Coupons, Foods / Snacks / Fruits / Drink / Books and others.",
    got_it: "Got It",
    type_a_message: "Type a message",
    vip_coupon: "VIP Coupon",
    egames_coupon: "Egames Coupon",
    reminder: "Reminder",
    signup_username_info:
      "Username is only allowed to consist of letters + numbers, and the length is at least 8 characters",
    signup_password_info:
      "Password must be at least 8 digits, and spaces are not supported",
    signup_new_password_error_msg: "New Password should be alphanumeric",
    signup_password_confirm_passwors_error_msg:
      "Password and confirm password not match ",
    eng_text: "English",
    bahasa_melayu_text: "Bahasa Melayu",
    thai_text: "เปลื่ยนภาษา",
    ch_text: "中文",
    vt_text: "tiếng Việt",
    indonsia_text: "Indonesia",
    myanmar_text: "Myanmar",
    cambodia_text: "Khmer",
    topup_duration_text:
      "*Deposit processing time will completed within 10 minutes, please be patient, thank you!",
    qr_description_thb:
      "*Recommend a new player to 'register an account' with a minimum ' Topup of 100THB ' and you will get a 'referral' fee of 20THB'. \n\n*Successfully recommending a 'new player', your account will be automatically upgraded to a 'super player', and you can extract a percentage of the effective betting amount of the 'player' you recommend.",
    total_amount: "Total Amount",
    transaaction_no: "Transaction No",
    share: "Share",
    timer: "Timer",
    gift: "Gift",
    schedule: "Schedule",
    qr_description_myr:
      "*Recommend a new player to 'register an account' with a minimum ' Topup of 20MYR ' and you will get a 'referral' fee of 2MYR'. \n\n*Successfully recommending a 'new player', your account will be automatically upgraded to a 'super player', and you can extract a percentage of the effective betting amount of the 'player' you recommend.",
    bonus_monthly: "Bonus(monthly)",
    birthday_bonus: "birthday bonus",
    withdraw_per_day: "Withdraw per day",
    exclusive_domain: "Exclusive domain name",
    deposit_priority: "Deposit priority",
    festival_gift: "Festival gift",
    exclusive_customer_service: "Exclusive customer service",
    free_travel: "Free travel",
    vip_myr_activity_1:
      "● Lucky Town is committed to creating a comfortable gaming platform but also does not forget to create a first-class VIP platform that we have been pursuing in the industry.",
    vip_myr_activity_2:
      "● With the continuous growth of players' on the Lucky Town gaming platform, we will provide players with more attentive care and higher-quality activities. A new reward system for Lucky Town players has been launched. New and old players can also enjoy more event bonus offers;",
    vip_myr_policy:
      "1. Promotion conditions: The system automatically determines that the promotion gift will be distributed immediately after the upgrade is completed. The time limit for receiving the gift is 14 days after the distribution. Failure to receive it within the time limit will be regarded as giving up and will be automatically withdrawn by the system. \n2. Relegation Condition: The system automatically accumulates whether the relegation eligibility is met. The cumulative time is the first day of the upgrade day, and it will be calculated later.Example: A member is upgraded to a gold member on November 3, and the accumulated time in the system is from September 3 at 12:00:01 PM to December 3 at 11:59:59 AM, during a period of three months ( one season) whether to qualify for relegation. \n3. Birthday gift: 3 days before and after receiving the birthday gift or on the same day, you need to submit your ID card photo to the customer service for verification. And the name of the ID card presented must match the name of the bank account of the game account before it can be claimed. Exceeding the deadline for applying for the birthday gift money will be regarded as giving up. \n4. Irregular holiday gifts, irregular holiday gifts will be given by mail or gift money. \n5.  For free travel, you need to maintain vip6 for at least 4 quarters (12 months) before you can get it. The departure date, hotel and air ticket will be arranged by the company at its sole responsibility (it will not be given to change the hotel or change the air ticket date and departure date). \n6. The above event rewards or gift money collection period is within 14 days after distribution. Failure to collect within the time limit will be regarded as giving up and will be automatically withdrawn by the system. \n7. Weekly/Monthly Rewards: (VIP2 / VIP3) Monthly - At least 10 deposits are completed, or the cumulative deposit is RM1000 and the rolling amount is more than 5000, in order to get the monthly VIP reward. (VIP4 / VIP5 / VIP6 ) At least 1 deposit per week, or a cumulative deposit of RM1000 and a rolling amount of 5000 or more, can get weekly VIP bonus \n\n《Event Terms》\n1. The promotion is only for entertainment members. If it is found that the user has more than one account, including the same name, the same email address, the same/similar IP address, the same address, the same debit/credit card, the same bank account, the same computer, etc. Any abnormal betting behavior, once found, LUCKY TOWN will reserve the right to freeze your account profit and balance. \n2. Any betting, tie, other hedging bets (cross-site betting), rejected bets, void bets, ties or sports odds below 1.5 will not be counted as valid bets required for the promotion. \n3. Any bets made through third-party illegal software such as 'robots' and 'opening double/multiple windows' can be regarded as illegal bets, and LUCKY TOWN reserves the right to freeze the balance of the suspected account and close the member account. \n4. LUCKY TOWN has the right to check all betting records of members. If a member violates the regulations and rules of the event or has any non-entertainment purpose of using bonuses to make profits, LUCKY TOWN reserves all rights to stop, cancel or claim back at any time. All offers paid. \n5. LUCKY TOWN reserves the right to require members to submit relevant documents to verify their identity if the relevant account is suspected of being abused and/or not eligible for this promotion. \n6. If any individual/team/organization is suspected of using dishonest methods or fraudulent acts for the purpose of defrauding/abusing bonuses, once verified, LUCKY TOWN will have the right to freeze the relevant account profits and balances. \n7.  By participating in this promotion, you agree to the 'All Rules and Terms of Promotion'. \n8.  LUCKY TOWN reserves the right to revise, terminate or final interpretation of this promotion; and to make changes to this promotion without notice.  \n9. If illegal betting is found, the deposit (including profit amount and bonuses) will be frozen, and the system will automatically clear it to zero. \n",
    weekly: "Weekly",
    withdraw_duration_text:
      "*Deposit processing time will completed within 30 minutes, please be patient, thank you!",
    hot_game: "Hot Games",
    new_games: "New Games",
    reset_app: "Clear App Cache",
    reset_app_title: "Clear Cached Data",
    reset_app_description: "Are you sure ? You want to delete your app data.",
    anoucement_intro_title: "Announcement",
    anoucement_intro_description:
      "You can find the important announcement here.",
    game_list_intro_title: "Game List",
    game_list_intro_description:
      "All the games are listed here, you can click the game icon to start game.",
    topup_intro_title: "Topup/Withdraw",
    topup_intro_description:
      "This is where you can top up/withdraw your balance.",
    leatherboard_intro_title: "Leaderboard ",
    leatherboard_intro_description:
      "Top players of the month will be listed here. Spend and win the prize!",
    previous_step: "Previous",
    next_step: "Next",
    skip_step: "Skip",
    finish_step: "Finish",
    point_history: "Point History",
    points: "Points",
    luckytown_points: "LK Points",
    you_have_earned: "You have earned",
    topup_info:
      "If the real name and bank transfer account name submitted for topup are inconsistent, company has right to reject the submitted application",
    please_upload_reciept: "Please upload receipt",
    pull_out_credit: "Pull Out Credit",
    pull_out_all_credit: "Pull Out All Credit",
    pull_out_credit_message: "Are you sure you want to Pull Out all Credits?",
    topup_promotion_intro:
      "IMPORTANT NOTICE: To participate in any special events, users will not be able to use QR transfer or ID transfer until the turnover conditions of the selected discount are fulfilled. and after the withdrawal through the platform is completed brought to customer service and passed the verification to start the QR transfer function.",
    statment: "Statement",
    withdraw_usdt: "Withdraw USDT",
    withdraw_usdt_Receipt: "Withdraw USDT Receipt",
    withdraw_usdt_intro:
      "Notice:\n• The minimum withdrawal amount is: 1USDT (TRC20).\n• If fill in the wrong withdrawal address, the company will not be responsible for it.\n• To ensure the safety of your funds, we will manually review the withdrawals when your account is safe. Please wait patiently. Please be sure to confirm the safety of your computer and browser to prevent information from being tampered with or leaked.\n• The withdrawal time is completed within 24 hours, please wait patiently for completion.",
    withdraw_currency: "Withdraw Currency",
    origin_amount: "Origin Amount",
    withdraw_network: "Withdraw Network",
    conversion_rate: "Conversion Rate",
    fees: "Fees",
    converted_amount: "Convertion Amount",
    amount_received: "Amount Received",
    withdraw_usdt_success: "Withdraw USDT Success.",
    available_usdt: "Available USDT",
    game_detail: "Game Detail",
    google_auth: "Google Authentication",
    redeem: "Redeem",
    enter_verification_code: "Enter the 6-digit verification code",
    activate_google_auth: "Activate Google Authenticator",
    inactivate_google_auth: "In Activate Google Authenticator",
    activate: "Activate",
    in_activate: "In Activate",
    reset_google_auth_msg:
      "Are you sure you want to Reset Google Authenticator?",
    activate_google_auth_msg:
      "Are you sure you want to Activate Google Authenticator?",
    register_google_auth_verification_msg:
      "Setup account with Google Auth Veririfcation",
    scan_google_auth_msg:
      "Scan this QR Code with yoour Google Authenticator App. Alternatively, you can use this code to reset   ",
    secret_key: "Secret Key:",
    pin: "PIN",
    change_app_icon: "Change App Icon",
    change_app_icon_message: "Are you sure you want to change app icon?",
    change_app_icon_success_message: "App Icon Change Successfully",
    real_name_verification: "Real Name Verification",
    enter_real_name: "Enter Real Name",
    real_name_notes:
      "Notes:\n\n1. Add a bank account with your real-name. \n2. Choose the bank account.\n3. Fill in your real-name. \n4. Submit Verification Request. \n5. Your request will be updated within 3 working days.",
    please_login_first: "Please Login first",
    otp_prefix: "OTP Prefix",
    notification_detail: "Notification Detail",
    bonus_chips: "Bonus Chips",
    bonus: "Bonus",
    cash_wallet: "Cash Wallet",
    promotion_intro_description: "Check out our latest promotion here.",
    looked_amount: "Looked Amount",
    current_tunrover_stake: "Current/Turnover Stake",
    turnover_stake_remarks: "Turnover Stake Auto Update in 10 Minutes",
    otp_verification_text:
      "Please check the mobile phone SMS and enter the OTP for verification and binding your mobile device to protect your account security",
    select_deposit_method: "Select Deposit Method",
    user_agreement: "User Agreement",
    no_record_found: "No Record Found",
    info: "Info",
    payId: "Pay Id",
    bsb: "Bsb",
    instruction: "Instruction",
  },
};
const strings = new I18n(translations);

// Set the locale once at the beginning of your app.
strings.locale = Localization.locale;

// When a value is missing from a language it'll fall back to another language with the key present.
strings.enableFallback = true;

strings.defaultLocale = "en";

export { strings };
